import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useThreadStore, useUserStore, useRouterStore, apiThreadCreate, navigate, useSidebarStore, useCopyToClipboard, useChatStore, UserRole, Role, useParams, useLocation, getApiHost, getAuth, apiGetSuggestions, apiGetThread, apiGetThreads, setApiHost } from '@griffingroupglobal/lumina-lib';
import { Slot } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import * as React from 'react';
import React__default, { useState, useEffect, useRef, useCallback, memo, useMemo } from 'react';
import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { Loader2, Plus, PanelRight, Copy, CircleCheck, Sun, Moon, Terminal, UserCircle, X, ArrowUp, ChartNoAxesGantt, ShieldAlert, Info, DollarSign, CornerDownRight, Search, Link, CloudSunRain, Box, FolderPen, Sparkles, PackageOpen, Package, Text, PhoneCall, Phone, Mail, HousePlus, MapPinHouse, Folders, ScrollText, FolderSearch, Calendar, Clock, Repeat, AlertCircle, Check, House, CircleDollarSign, PhoneOutgoing, PhoneIncoming, ConciergeBell, Store, Notebook, Route, NotebookText, SquareCheck, Microscope, AlarmClockCheck, CopyPlus, Loader as Loader$2, Wrench, Ruler, BedDouble, MonitorPlay, CircleHelp, MessageSquare, ShieldX, Maximize2, Minimize2, ChevronRight, MessageSquareText, Layers2, GalleryHorizontalEnd } from 'lucide-react';
import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import { motion, AnimatePresence } from 'framer-motion';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { Cross2Icon, ChevronRightIcon, CheckIcon, DotFilledIcon, CaretSortIcon, ChevronUpIcon, ChevronDownIcon } from '@radix-ui/react-icons';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import * as LabelPrimitive from '@radix-ui/react-label';
import * as SelectPrimitive from '@radix-ui/react-select';
import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { useTheme, ThemeProvider } from 'next-themes';
import { Toaster as Toaster$1 } from 'sonner';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { useChat } from 'ai/react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ErrorBoundary } from 'react-error-boundary';
import { z } from 'zod';
import { useInfiniteQuery, QueryClient, QueryClientProvider } from '@tanstack/react-query';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var objectGetOwnPropertyDescriptor = {};

var fails$p = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

var fails$o = fails$p;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$o(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});

var fails$n = fails$p;

var functionBindNative = !fails$n(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});

var NATIVE_BIND$3 = functionBindNative;

var call$n = Function.prototype.call;

var functionCall = NATIVE_BIND$3 ? call$n.bind(call$n) : function () {
  return call$n.apply(call$n, arguments);
};

var objectPropertyIsEnumerable = {};

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$4 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$4 && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$4(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var createPropertyDescriptor$5 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var NATIVE_BIND$2 = functionBindNative;

var FunctionPrototype$2 = Function.prototype;
var call$m = FunctionPrototype$2.call;
var uncurryThisWithBind = NATIVE_BIND$2 && FunctionPrototype$2.bind.bind(call$m, call$m);

var functionUncurryThis = NATIVE_BIND$2 ? uncurryThisWithBind : function (fn) {
  return function () {
    return call$m.apply(fn, arguments);
  };
};

var uncurryThis$q = functionUncurryThis;

var toString$c = uncurryThis$q({}.toString);
var stringSlice$7 = uncurryThis$q(''.slice);

var classofRaw$2 = function (it) {
  return stringSlice$7(toString$c(it), 8, -1);
};

var uncurryThis$p = functionUncurryThis;
var fails$m = fails$p;
var classof$9 = classofRaw$2;

var $Object$4 = Object;
var split = uncurryThis$p(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$m(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object$4('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$9(it) === 'String' ? split(it, '') : $Object$4(it);
} : $Object$4;

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
var isNullOrUndefined$5 = function (it) {
  return it === null || it === undefined;
};

var isNullOrUndefined$4 = isNullOrUndefined$5;

var $TypeError$h = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$8 = function (it) {
  if (isNullOrUndefined$4(it)) throw new $TypeError$h("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings
var IndexedObject$1 = indexedObject;
var requireObjectCoercible$7 = requireObjectCoercible$8;

var toIndexedObject$5 = function (it) {
  return IndexedObject$1(requireObjectCoercible$7(it));
};

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var documentAll = typeof document == 'object' && document.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var isCallable$q = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};

var isCallable$p = isCallable$q;

var isObject$e = function (it) {
  return typeof it == 'object' ? it !== null : isCallable$p(it);
};

var globalThis$q = globalThis_1;
var isCallable$o = isCallable$q;

var aFunction = function (argument) {
  return isCallable$o(argument) ? argument : undefined;
};

var getBuiltIn$9 = function (namespace, method) {
  return arguments.length < 2 ? aFunction(globalThis$q[namespace]) : globalThis$q[namespace] && globalThis$q[namespace][method];
};

var uncurryThis$o = functionUncurryThis;

var objectIsPrototypeOf = uncurryThis$o({}.isPrototypeOf);

var globalThis$p = globalThis_1;

var navigator = globalThis$p.navigator;
var userAgent$5 = navigator && navigator.userAgent;

var environmentUserAgent = userAgent$5 ? String(userAgent$5) : '';

var globalThis$o = globalThis_1;
var userAgent$4 = environmentUserAgent;

var process$3 = globalThis$o.process;
var Deno$1 = globalThis$o.Deno;
var versions = process$3 && process$3.versions || Deno$1 && Deno$1.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent$4) {
  match = userAgent$4.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent$4.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

var environmentV8Version = version;

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION$1 = environmentV8Version;
var fails$l = fails$p;
var globalThis$n = globalThis_1;

var $String$6 = globalThis$n.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails$l(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String$6(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$1 && V8_VERSION$1 < 41;
});

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL$3 = symbolConstructorDetection;

var useSymbolAsUid = NATIVE_SYMBOL$3 &&
  !Symbol.sham &&
  typeof Symbol.iterator == 'symbol';

var getBuiltIn$8 = getBuiltIn$9;
var isCallable$n = isCallable$q;
var isPrototypeOf$4 = objectIsPrototypeOf;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var $Object$3 = Object;

var isSymbol$3 = USE_SYMBOL_AS_UID$1 ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn$8('Symbol');
  return isCallable$n($Symbol) && isPrototypeOf$4($Symbol.prototype, $Object$3(it));
};

var $String$5 = String;

var tryToString$4 = function (argument) {
  try {
    return $String$5(argument);
  } catch (error) {
    return 'Object';
  }
};

var isCallable$m = isCallable$q;
var tryToString$3 = tryToString$4;

var $TypeError$g = TypeError;

// `Assert: IsCallable(argument) is true`
var aCallable$d = function (argument) {
  if (isCallable$m(argument)) return argument;
  throw new $TypeError$g(tryToString$3(argument) + ' is not a function');
};

var aCallable$c = aCallable$d;
var isNullOrUndefined$3 = isNullOrUndefined$5;

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
var getMethod$5 = function (V, P) {
  var func = V[P];
  return isNullOrUndefined$3(func) ? undefined : aCallable$c(func);
};

var call$l = functionCall;
var isCallable$l = isCallable$q;
var isObject$d = isObject$e;

var $TypeError$f = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
var ordinaryToPrimitive$1 = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable$l(fn = input.toString) && !isObject$d(val = call$l(fn, input))) return val;
  if (isCallable$l(fn = input.valueOf) && !isObject$d(val = call$l(fn, input))) return val;
  if (pref !== 'string' && isCallable$l(fn = input.toString) && !isObject$d(val = call$l(fn, input))) return val;
  throw new $TypeError$f("Can't convert object to primitive value");
};

var sharedStore = {exports: {}};

var isPure = false;

var globalThis$m = globalThis_1;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$7 = Object.defineProperty;

var defineGlobalProperty$3 = function (key, value) {
  try {
    defineProperty$7(globalThis$m, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    globalThis$m[key] = value;
  } return value;
};

var globalThis$l = globalThis_1;
var defineGlobalProperty$2 = defineGlobalProperty$3;

var SHARED = '__core-js_shared__';
var store$3 = sharedStore.exports = globalThis$l[SHARED] || defineGlobalProperty$2(SHARED, {});

(store$3.versions || (store$3.versions = [])).push({
  version: '3.39.0',
  mode: 'global',
  copyright: '© 2014-2024 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.39.0/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});

var sharedStoreExports = sharedStore.exports;

var store$2 = sharedStoreExports;

var shared$4 = function (key, value) {
  return store$2[key] || (store$2[key] = value || {});
};

var requireObjectCoercible$6 = requireObjectCoercible$8;

var $Object$2 = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$6 = function (argument) {
  return $Object$2(requireObjectCoercible$6(argument));
};

var uncurryThis$n = functionUncurryThis;
var toObject$5 = toObject$6;

var hasOwnProperty = uncurryThis$n({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject$5(it), key);
};

var uncurryThis$m = functionUncurryThis;

var id = 0;
var postfix = Math.random();
var toString$b = uncurryThis$m(1.0.toString);

var uid$2 = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString$b(++id + postfix, 36);
};

var globalThis$k = globalThis_1;
var shared$3 = shared$4;
var hasOwn$c = hasOwnProperty_1;
var uid$1 = uid$2;
var NATIVE_SYMBOL$2 = symbolConstructorDetection;
var USE_SYMBOL_AS_UID = useSymbolAsUid;

var Symbol$2 = globalThis$k.Symbol;
var WellKnownSymbolsStore = shared$3('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol$2['for'] || Symbol$2 : Symbol$2 && Symbol$2.withoutSetter || uid$1;

var wellKnownSymbol$l = function (name) {
  if (!hasOwn$c(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL$2 && hasOwn$c(Symbol$2, name)
      ? Symbol$2[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};

var call$k = functionCall;
var isObject$c = isObject$e;
var isSymbol$2 = isSymbol$3;
var getMethod$4 = getMethod$5;
var ordinaryToPrimitive = ordinaryToPrimitive$1;
var wellKnownSymbol$k = wellKnownSymbol$l;

var $TypeError$e = TypeError;
var TO_PRIMITIVE = wellKnownSymbol$k('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
var toPrimitive$1 = function (input, pref) {
  if (!isObject$c(input) || isSymbol$2(input)) return input;
  var exoticToPrim = getMethod$4(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call$k(exoticToPrim, input, pref);
    if (!isObject$c(result) || isSymbol$2(result)) return result;
    throw new $TypeError$e("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};

var toPrimitive = toPrimitive$1;
var isSymbol$1 = isSymbol$3;

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
var toPropertyKey$2 = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol$1(key) ? key : key + '';
};

var globalThis$j = globalThis_1;
var isObject$b = isObject$e;

var document$3 = globalThis$j.document;
// typeof document.createElement is 'object' in old IE
var EXISTS$1 = isObject$b(document$3) && isObject$b(document$3.createElement);

var documentCreateElement$2 = function (it) {
  return EXISTS$1 ? document$3.createElement(it) : {};
};

var DESCRIPTORS$g = descriptors;
var fails$k = fails$p;
var createElement$1 = documentCreateElement$2;

// Thanks to IE8 for its funny defineProperty
var ie8DomDefine = !DESCRIPTORS$g && !fails$k(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});

var DESCRIPTORS$f = descriptors;
var call$j = functionCall;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var createPropertyDescriptor$4 = createPropertyDescriptor$5;
var toIndexedObject$4 = toIndexedObject$5;
var toPropertyKey$1 = toPropertyKey$2;
var hasOwn$b = hasOwnProperty_1;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$f ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$4(O);
  P = toPropertyKey$1(P);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn$b(O, P)) return createPropertyDescriptor$4(!call$j(propertyIsEnumerableModule$1.f, O, P), O[P]);
};

var objectDefineProperty = {};

var DESCRIPTORS$e = descriptors;
var fails$j = fails$p;

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
var v8PrototypeDefineBug = DESCRIPTORS$e && fails$j(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});

var isObject$a = isObject$e;

var $String$4 = String;
var $TypeError$d = TypeError;

// `Assert: Type(argument) is Object`
var anObject$j = function (argument) {
  if (isObject$a(argument)) return argument;
  throw new $TypeError$d($String$4(argument) + ' is not an object');
};

var DESCRIPTORS$d = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var V8_PROTOTYPE_DEFINE_BUG$1 = v8PrototypeDefineBug;
var anObject$i = anObject$j;
var toPropertyKey = toPropertyKey$2;

var $TypeError$c = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE$1 = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$d ? V8_PROTOTYPE_DEFINE_BUG$1 ? function defineProperty(O, P, Attributes) {
  anObject$i(O);
  P = toPropertyKey(P);
  anObject$i(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject$i(O);
  P = toPropertyKey(P);
  anObject$i(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$c('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var DESCRIPTORS$c = descriptors;
var definePropertyModule$4 = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$5;

var createNonEnumerableProperty$9 = DESCRIPTORS$c ? function (object, key, value) {
  return definePropertyModule$4.f(object, key, createPropertyDescriptor$3(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var makeBuiltIn$3 = {exports: {}};

var DESCRIPTORS$b = descriptors;
var hasOwn$a = hasOwnProperty_1;

var FunctionPrototype$1 = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS$b && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn$a(FunctionPrototype$1, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS$b || (DESCRIPTORS$b && getDescriptor(FunctionPrototype$1, 'name').configurable));

var functionName = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};

var uncurryThis$l = functionUncurryThis;
var isCallable$k = isCallable$q;
var store$1 = sharedStoreExports;

var functionToString = uncurryThis$l(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable$k(store$1.inspectSource)) {
  store$1.inspectSource = function (it) {
    return functionToString(it);
  };
}

var inspectSource$3 = store$1.inspectSource;

var globalThis$i = globalThis_1;
var isCallable$j = isCallable$q;

var WeakMap$1 = globalThis$i.WeakMap;

var weakMapBasicDetection = isCallable$j(WeakMap$1) && /native code/.test(String(WeakMap$1));

var shared$2 = shared$4;
var uid = uid$2;

var keys = shared$2('keys');

var sharedKey$3 = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys$4 = {};

var NATIVE_WEAK_MAP = weakMapBasicDetection;
var globalThis$h = globalThis_1;
var isObject$9 = isObject$e;
var createNonEnumerableProperty$8 = createNonEnumerableProperty$9;
var hasOwn$9 = hasOwnProperty_1;
var shared$1 = sharedStoreExports;
var sharedKey$2 = sharedKey$3;
var hiddenKeys$3 = hiddenKeys$4;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError$2 = globalThis$h.TypeError;
var WeakMap = globalThis$h.WeakMap;
var set$1, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set$1(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$9(it) || (state = get(it)).type !== TYPE) {
      throw new TypeError$2('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared$1.state) {
  var store = shared$1.state || (shared$1.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set$1 = function (it, metadata) {
    if (store.has(it)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey$2('state');
  hiddenKeys$3[STATE] = true;
  set$1 = function (it, metadata) {
    if (hasOwn$9(it, STATE)) throw new TypeError$2(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$8(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn$9(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn$9(it, STATE);
  };
}

var internalState = {
  set: set$1,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};

var uncurryThis$k = functionUncurryThis;
var fails$i = fails$p;
var isCallable$i = isCallable$q;
var hasOwn$8 = hasOwnProperty_1;
var DESCRIPTORS$a = descriptors;
var CONFIGURABLE_FUNCTION_NAME$1 = functionName.CONFIGURABLE;
var inspectSource$2 = inspectSource$3;
var InternalStateModule$3 = internalState;

var enforceInternalState = InternalStateModule$3.enforce;
var getInternalState$2 = InternalStateModule$3.get;
var $String$3 = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty$6 = Object.defineProperty;
var stringSlice$6 = uncurryThis$k(''.slice);
var replace$6 = uncurryThis$k(''.replace);
var join = uncurryThis$k([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS$a && !fails$i(function () {
  return defineProperty$6(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn$2 = makeBuiltIn$3.exports = function (value, name, options) {
  if (stringSlice$6($String$3(name), 0, 7) === 'Symbol(') {
    name = '[' + replace$6($String$3(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn$8(value, 'name') || (CONFIGURABLE_FUNCTION_NAME$1 && value.name !== name)) {
    if (DESCRIPTORS$a) defineProperty$6(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn$8(options, 'arity') && value.length !== options.arity) {
    defineProperty$6(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn$8(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS$a) defineProperty$6(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn$8(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn$2(function toString() {
  return isCallable$i(this) && getInternalState$2(this).source || inspectSource$2(this);
}, 'toString');

var makeBuiltInExports = makeBuiltIn$3.exports;

var isCallable$h = isCallable$q;
var definePropertyModule$3 = objectDefineProperty;
var makeBuiltIn$1 = makeBuiltInExports;
var defineGlobalProperty$1 = defineGlobalProperty$3;

var defineBuiltIn$7 = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable$h(value)) makeBuiltIn$1(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty$1(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule$3.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};

var objectGetOwnPropertyNames = {};

var ceil = Math.ceil;
var floor$1 = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
var mathTrunc = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor$1 : ceil)(n);
};

var trunc = mathTrunc;

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
var toIntegerOrInfinity$4 = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};

var toIntegerOrInfinity$3 = toIntegerOrInfinity$4;

var max$1 = Math.max;
var min$3 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$1 = function (index, length) {
  var integer = toIntegerOrInfinity$3(index);
  return integer < 0 ? max$1(integer + length, 0) : min$3(integer, length);
};

var toIntegerOrInfinity$2 = toIntegerOrInfinity$4;

var min$2 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$3 = function (argument) {
  var len = toIntegerOrInfinity$2(argument);
  return len > 0 ? min$2(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var toLength$2 = toLength$3;

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
var lengthOfArrayLike$5 = function (obj) {
  return toLength$2(obj.length);
};

var toIndexedObject$3 = toIndexedObject$5;
var toAbsoluteIndex = toAbsoluteIndex$1;
var lengthOfArrayLike$4 = lengthOfArrayLike$5;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$2 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$3($this);
    var length = lengthOfArrayLike$4(O);
    if (length === 0) return !IS_INCLUDES && -1;
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$2(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$2(false)
};

var uncurryThis$j = functionUncurryThis;
var hasOwn$7 = hasOwnProperty_1;
var toIndexedObject$2 = toIndexedObject$5;
var indexOf$1 = arrayIncludes.indexOf;
var hiddenKeys$2 = hiddenKeys$4;

var push$2 = uncurryThis$j([].push);

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$2(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn$7(hiddenKeys$2, key) && hasOwn$7(O, key) && push$2(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn$7(O, key = names[i++])) {
    ~indexOf$1(result, key) || push$2(result, key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$1 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$1);
};

var objectGetOwnPropertySymbols = {};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;

var getBuiltIn$7 = getBuiltIn$9;
var uncurryThis$i = functionUncurryThis;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var anObject$h = anObject$j;

var concat$2 = uncurryThis$i([].concat);

// all object keys, includes non-enumerable and symbols
var ownKeys$1 = getBuiltIn$7('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject$h(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  return getOwnPropertySymbols ? concat$2(keys, getOwnPropertySymbols(it)) : keys;
};

var hasOwn$6 = hasOwnProperty_1;
var ownKeys = ownKeys$1;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule$2 = objectDefineProperty;

var copyConstructorProperties$3 = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule$2.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn$6(target, key) && !(exceptions && hasOwn$6(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

var fails$h = fails$p;
var isCallable$g = isCallable$q;

var replacement = /#|\.prototype\./;

var isForced$2 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable$g(detection) ? fails$h(detection)
    : !!detection;
};

var normalize = isForced$2.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$2.data = {};
var NATIVE = isForced$2.NATIVE = 'N';
var POLYFILL = isForced$2.POLYFILL = 'P';

var isForced_1 = isForced$2;

var globalThis$g = globalThis_1;
var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$9;
var defineBuiltIn$6 = defineBuiltIn$7;
var defineGlobalProperty = defineGlobalProperty$3;
var copyConstructorProperties$2 = copyConstructorProperties$3;
var isForced$1 = isForced_1;

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = globalThis$g;
  } else if (STATIC) {
    target = globalThis$g[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = globalThis$g[TARGET] && globalThis$g[TARGET].prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor$3(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties$2(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$7(sourceProperty, 'sham', true);
    }
    defineBuiltIn$6(target, key, sourceProperty, options);
  }
};

var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$2 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};

var DESCRIPTORS$9 = descriptors;
var uncurryThis$h = functionUncurryThis;
var call$i = functionCall;
var fails$g = fails$p;
var objectKeys$1 = objectKeys$2;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var toObject$4 = toObject$6;
var IndexedObject = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$5 = Object.defineProperty;
var concat$1 = uncurryThis$h([].concat);

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$g(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$9 && $assign({ b: 1 }, $assign(defineProperty$5({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$5(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol('assign detection');
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] !== 7 || objectKeys$1($assign({}, B)).join('') !== alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$4(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? concat$1(objectKeys$1(S), getOwnPropertySymbols(S)) : objectKeys$1(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$9 || call$i(propertyIsEnumerable, S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

var $$n = _export;
var assign = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$n({ target: 'Object', stat: true, arity: 2, forced: Object.assign !== assign }, {
  assign: assign
});

/* global Bun, Deno -- detection */
var globalThis$f = globalThis_1;
var userAgent$3 = environmentUserAgent;
var classof$8 = classofRaw$2;

var userAgentStartsWith = function (string) {
  return userAgent$3.slice(0, string.length) === string;
};

var environment = (function () {
  if (userAgentStartsWith('Bun/')) return 'BUN';
  if (userAgentStartsWith('Cloudflare-Workers')) return 'CLOUDFLARE';
  if (userAgentStartsWith('Deno/')) return 'DENO';
  if (userAgentStartsWith('Node.js/')) return 'NODE';
  if (globalThis$f.Bun && typeof Bun.version == 'string') return 'BUN';
  if (globalThis$f.Deno && typeof Deno.version == 'object') return 'DENO';
  if (classof$8(globalThis$f.process) === 'process') return 'NODE';
  if (globalThis$f.window && globalThis$f.document) return 'BROWSER';
  return 'REST';
})();

var ENVIRONMENT$1 = environment;

var environmentIsNode = ENVIRONMENT$1 === 'NODE';

var uncurryThis$g = functionUncurryThis;
var aCallable$b = aCallable$d;

var functionUncurryThisAccessor = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis$g(aCallable$b(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};

var isObject$8 = isObject$e;

var isPossiblePrototype$1 = function (argument) {
  return isObject$8(argument) || argument === null;
};

var isPossiblePrototype = isPossiblePrototype$1;

var $String$2 = String;
var $TypeError$b = TypeError;

var aPossiblePrototype$1 = function (argument) {
  if (isPossiblePrototype(argument)) return argument;
  throw new $TypeError$b("Can't set " + $String$2(argument) + ' as a prototype');
};

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = functionUncurryThisAccessor;
var isObject$7 = isObject$e;
var requireObjectCoercible$5 = requireObjectCoercible$8;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    requireObjectCoercible$5(O);
    aPossiblePrototype(proto);
    if (!isObject$7(O)) return O;
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

var defineProperty$4 = objectDefineProperty.f;
var hasOwn$5 = hasOwnProperty_1;
var wellKnownSymbol$j = wellKnownSymbol$l;

var TO_STRING_TAG$4 = wellKnownSymbol$j('toStringTag');

var setToStringTag$4 = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn$5(target, TO_STRING_TAG$4)) {
    defineProperty$4(target, TO_STRING_TAG$4, { configurable: true, value: TAG });
  }
};

var makeBuiltIn = makeBuiltInExports;
var defineProperty$3 = objectDefineProperty;

var defineBuiltInAccessor$3 = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty$3.f(target, name, descriptor);
};

var getBuiltIn$6 = getBuiltIn$9;
var defineBuiltInAccessor$2 = defineBuiltInAccessor$3;
var wellKnownSymbol$i = wellKnownSymbol$l;
var DESCRIPTORS$8 = descriptors;

var SPECIES$4 = wellKnownSymbol$i('species');

var setSpecies$1 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$6(CONSTRUCTOR_NAME);

  if (DESCRIPTORS$8 && Constructor && !Constructor[SPECIES$4]) {
    defineBuiltInAccessor$2(Constructor, SPECIES$4, {
      configurable: true,
      get: function () { return this; }
    });
  }
};

var isPrototypeOf$3 = objectIsPrototypeOf;

var $TypeError$a = TypeError;

var anInstance$2 = function (it, Prototype) {
  if (isPrototypeOf$3(Prototype, it)) return it;
  throw new $TypeError$a('Incorrect invocation');
};

var wellKnownSymbol$h = wellKnownSymbol$l;

var TO_STRING_TAG$3 = wellKnownSymbol$h('toStringTag');
var test = {};

test[TO_STRING_TAG$3] = 'z';

var toStringTagSupport = String(test) === '[object z]';

var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var isCallable$f = isCallable$q;
var classofRaw$1 = classofRaw$2;
var wellKnownSymbol$g = wellKnownSymbol$l;

var TO_STRING_TAG$2 = wellKnownSymbol$g('toStringTag');
var $Object$1 = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw$1(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$7 = TO_STRING_TAG_SUPPORT ? classofRaw$1 : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object$1(it), TO_STRING_TAG$2)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw$1(O)
    // ES3 arguments fallback
    : (result = classofRaw$1(O)) === 'Object' && isCallable$f(O.callee) ? 'Arguments' : result;
};

var uncurryThis$f = functionUncurryThis;
var fails$f = fails$p;
var isCallable$e = isCallable$q;
var classof$6 = classof$7;
var getBuiltIn$5 = getBuiltIn$9;
var inspectSource$1 = inspectSource$3;

var noop = function () { /* empty */ };
var construct = getBuiltIn$5('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec$3 = uncurryThis$f(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.test(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable$e(argument)) return false;
  try {
    construct(noop, [], argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable$e(argument)) return false;
  switch (classof$6(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec$3(constructorRegExp, inspectSource$1(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
var isConstructor$2 = !construct || fails$f(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;

var isConstructor$1 = isConstructor$2;
var tryToString$2 = tryToString$4;

var $TypeError$9 = TypeError;

// `Assert: IsConstructor(argument) is true`
var aConstructor$1 = function (argument) {
  if (isConstructor$1(argument)) return argument;
  throw new $TypeError$9(tryToString$2(argument) + ' is not a constructor');
};

var anObject$g = anObject$j;
var aConstructor = aConstructor$1;
var isNullOrUndefined$2 = isNullOrUndefined$5;
var wellKnownSymbol$f = wellKnownSymbol$l;

var SPECIES$3 = wellKnownSymbol$f('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$1 = function (O, defaultConstructor) {
  var C = anObject$g(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined$2(S = anObject$g(C)[SPECIES$3]) ? defaultConstructor : aConstructor(S);
};

var NATIVE_BIND$1 = functionBindNative;

var FunctionPrototype = Function.prototype;
var apply$4 = FunctionPrototype.apply;
var call$h = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
var functionApply = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND$1 ? call$h.bind(apply$4) : function () {
  return call$h.apply(apply$4, arguments);
});

var classofRaw = classofRaw$2;
var uncurryThis$e = functionUncurryThis;

var functionUncurryThisClause = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis$e(fn);
};

var uncurryThis$d = functionUncurryThisClause;
var aCallable$a = aCallable$d;
var NATIVE_BIND = functionBindNative;

var bind$5 = uncurryThis$d(uncurryThis$d.bind);

// optional / simple context binding
var functionBindContext = function (fn, that) {
  aCallable$a(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind$5(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var getBuiltIn$4 = getBuiltIn$9;

var html$2 = getBuiltIn$4('document', 'documentElement');

var uncurryThis$c = functionUncurryThis;

var arraySlice$2 = uncurryThis$c([].slice);

var $TypeError$8 = TypeError;

var validateArgumentsLength$1 = function (passed, required) {
  if (passed < required) throw new $TypeError$8('Not enough arguments');
  return passed;
};

var userAgent$2 = environmentUserAgent;

// eslint-disable-next-line redos/no-vulnerable -- safe
var environmentIsIos = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent$2);

var globalThis$e = globalThis_1;
var apply$3 = functionApply;
var bind$4 = functionBindContext;
var isCallable$d = isCallable$q;
var hasOwn$4 = hasOwnProperty_1;
var fails$e = fails$p;
var html$1 = html$2;
var arraySlice$1 = arraySlice$2;
var createElement = documentCreateElement$2;
var validateArgumentsLength = validateArgumentsLength$1;
var IS_IOS$1 = environmentIsIos;
var IS_NODE$2 = environmentIsNode;

var set = globalThis$e.setImmediate;
var clear = globalThis$e.clearImmediate;
var process$2 = globalThis$e.process;
var Dispatch = globalThis$e.Dispatch;
var Function$1 = globalThis$e.Function;
var MessageChannel = globalThis$e.MessageChannel;
var String$1 = globalThis$e.String;
var counter = 0;
var queue$2 = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails$e(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = globalThis$e.location;
});

var run = function (id) {
  if (hasOwn$4(queue$2, id)) {
    var fn = queue$2[id];
    delete queue$2[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  globalThis$e.postMessage(String$1(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable$d(handler) ? handler : Function$1(handler);
    var args = arraySlice$1(arguments, 1);
    queue$2[++counter] = function () {
      apply$3(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue$2[id];
  };
  // Node.js 0.8-
  if (IS_NODE$2) {
    defer = function (id) {
      process$2.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind$4(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    globalThis$e.addEventListener &&
    isCallable$d(globalThis$e.postMessage) &&
    !globalThis$e.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails$e(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    globalThis$e.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html$1.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html$1.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$1 = {
  set: set,
  clear: clear
};

var globalThis$d = globalThis_1;
var DESCRIPTORS$7 = descriptors;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$2 = Object.getOwnPropertyDescriptor;

// Avoid NodeJS experimental warning
var safeGetBuiltIn$1 = function (name) {
  if (!DESCRIPTORS$7) return globalThis$d[name];
  var descriptor = getOwnPropertyDescriptor$2(globalThis$d, name);
  return descriptor && descriptor.value;
};

var Queue$2 = function () {
  this.head = null;
  this.tail = null;
};

Queue$2.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

var queue$1 = Queue$2;

var userAgent$1 = environmentUserAgent;

var environmentIsIosPebble = /ipad|iphone|ipod/i.test(userAgent$1) && typeof Pebble != 'undefined';

var userAgent = environmentUserAgent;

var environmentIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);

var globalThis$c = globalThis_1;
var safeGetBuiltIn = safeGetBuiltIn$1;
var bind$3 = functionBindContext;
var macrotask = task$1.set;
var Queue$1 = queue$1;
var IS_IOS = environmentIsIos;
var IS_IOS_PEBBLE = environmentIsIosPebble;
var IS_WEBOS_WEBKIT = environmentIsWebosWebkit;
var IS_NODE$1 = environmentIsNode;

var MutationObserver = globalThis$c.MutationObserver || globalThis$c.WebKitMutationObserver;
var document$2 = globalThis$c.document;
var process$1 = globalThis$c.process;
var Promise$1 = globalThis$c.Promise;
var microtask$1 = safeGetBuiltIn('queueMicrotask');
var notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask$1) {
  var queue = new Queue$1();

  var flush = function () {
    var parent, fn;
    if (IS_NODE$1 && (parent = process$1.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify$1();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$1 && !IS_WEBOS_WEBKIT && MutationObserver && document$2) {
    toggle = true;
    node = document$2.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise$1 && Promise$1.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$1.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$1;
    then = bind$3(promise.then, promise);
    notify$1 = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE$1) {
    notify$1 = function () {
      process$1.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind$3(macrotask, globalThis$c);
    notify$1 = function () {
      macrotask(flush);
    };
  }

  microtask$1 = function (fn) {
    if (!queue.head) notify$1();
    queue.add(fn);
  };
}

var microtask_1 = microtask$1;

var hostReportErrors$1 = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};

var perform$3 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};

var globalThis$b = globalThis_1;

var promiseNativeConstructor = globalThis$b.Promise;

var globalThis$a = globalThis_1;
var NativePromiseConstructor$3 = promiseNativeConstructor;
var isCallable$c = isCallable$q;
var isForced = isForced_1;
var inspectSource = inspectSource$3;
var wellKnownSymbol$e = wellKnownSymbol$l;
var ENVIRONMENT = environment;
var V8_VERSION = environmentV8Version;

NativePromiseConstructor$3 && NativePromiseConstructor$3.prototype;
var SPECIES$2 = wellKnownSymbol$e('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT$1 = isCallable$c(globalThis$a.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR$5 = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor$3);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor$3);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor$3(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES$2] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (ENVIRONMENT === 'BROWSER' || ENVIRONMENT === 'DENO') && !NATIVE_PROMISE_REJECTION_EVENT$1;
});

var promiseConstructorDetection = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR$5,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT$1,
  SUBCLASSING: SUBCLASSING
};

var newPromiseCapability$2 = {};

var aCallable$9 = aCallable$d;

var $TypeError$7 = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw new $TypeError$7('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable$9(resolve);
  this.reject = aCallable$9(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};

var $$m = _export;
var IS_NODE = environmentIsNode;
var globalThis$9 = globalThis_1;
var call$g = functionCall;
var defineBuiltIn$5 = defineBuiltIn$7;
var setPrototypeOf$3 = objectSetPrototypeOf;
var setToStringTag$3 = setToStringTag$4;
var setSpecies = setSpecies$1;
var aCallable$8 = aCallable$d;
var isCallable$b = isCallable$q;
var isObject$6 = isObject$e;
var anInstance$1 = anInstance$2;
var speciesConstructor = speciesConstructor$1;
var task = task$1.set;
var microtask = microtask_1;
var hostReportErrors = hostReportErrors$1;
var perform$2 = perform$3;
var Queue = queue$1;
var InternalStateModule$2 = internalState;
var NativePromiseConstructor$2 = promiseNativeConstructor;
var PromiseConstructorDetection = promiseConstructorDetection;
var newPromiseCapabilityModule$3 = newPromiseCapability$2;

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR$4 = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule$2.getterFor(PROMISE);
var setInternalState$2 = InternalStateModule$2.set;
var NativePromisePrototype$1 = NativePromiseConstructor$2 && NativePromiseConstructor$2.prototype;
var PromiseConstructor = NativePromiseConstructor$2;
var PromisePrototype = NativePromisePrototype$1;
var TypeError$1 = globalThis$9.TypeError;
var document$1 = globalThis$9.document;
var process = globalThis$9.process;
var newPromiseCapability$1 = newPromiseCapabilityModule$3.f;
var newGenericPromiseCapability = newPromiseCapability$1;

var DISPATCH_EVENT = !!(document$1 && document$1.createEvent && globalThis$9.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject$6(it) && isCallable$b(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(new TypeError$1('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call$g(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$1.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    globalThis$9.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = globalThis$9['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call$g(task, globalThis$9, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform$2(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call$g(task, globalThis$9, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$2 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw new TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call$g(then, value,
            bind$2(internalResolve, wrapper, state),
            bind$2(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR$4) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance$1(this, PromisePrototype);
    aCallable$8(executor);
    call$g(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind$2(internalResolve, state), bind$2(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$2(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: null
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn$5(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability$1(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable$b(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable$b(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind$2(internalResolve, state);
    this.reject = bind$2(internalReject, state);
  };

  newPromiseCapabilityModule$3.f = newPromiseCapability$1 = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (isCallable$b(NativePromiseConstructor$2) && NativePromisePrototype$1 !== Object.prototype) {
    nativeThen = NativePromisePrototype$1.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn$5(NativePromisePrototype$1, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call$g(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype$1.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf$3) {
      setPrototypeOf$3(NativePromisePrototype$1, PromisePrototype);
    }
  }
}

// `Promise` constructor
// https://tc39.es/ecma262/#sec-promise-executor
$$m({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR$4 }, {
  Promise: PromiseConstructor
});

setToStringTag$3(PromiseConstructor, PROMISE, false);
setSpecies(PROMISE);

var iterators = {};

var wellKnownSymbol$d = wellKnownSymbol$l;
var Iterators$4 = iterators;

var ITERATOR$7 = wellKnownSymbol$d('iterator');
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$1 = function (it) {
  return it !== undefined && (Iterators$4.Array === it || ArrayPrototype$1[ITERATOR$7] === it);
};

var classof$5 = classof$7;
var getMethod$3 = getMethod$5;
var isNullOrUndefined$1 = isNullOrUndefined$5;
var Iterators$3 = iterators;
var wellKnownSymbol$c = wellKnownSymbol$l;

var ITERATOR$6 = wellKnownSymbol$c('iterator');

var getIteratorMethod$3 = function (it) {
  if (!isNullOrUndefined$1(it)) return getMethod$3(it, ITERATOR$6)
    || getMethod$3(it, '@@iterator')
    || Iterators$3[classof$5(it)];
};

var call$f = functionCall;
var aCallable$7 = aCallable$d;
var anObject$f = anObject$j;
var tryToString$1 = tryToString$4;
var getIteratorMethod$2 = getIteratorMethod$3;

var $TypeError$6 = TypeError;

var getIterator$1 = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod$2(argument) : usingIterator;
  if (aCallable$7(iteratorMethod)) return anObject$f(call$f(iteratorMethod, argument));
  throw new $TypeError$6(tryToString$1(argument) + ' is not iterable');
};

var call$e = functionCall;
var anObject$e = anObject$j;
var getMethod$2 = getMethod$5;

var iteratorClose$4 = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject$e(iterator);
  try {
    innerResult = getMethod$2(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call$e(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject$e(innerResult);
  return value;
};

var bind$1 = functionBindContext;
var call$d = functionCall;
var anObject$d = anObject$j;
var tryToString = tryToString$4;
var isArrayIteratorMethod = isArrayIteratorMethod$1;
var lengthOfArrayLike$3 = lengthOfArrayLike$5;
var isPrototypeOf$2 = objectIsPrototypeOf;
var getIterator = getIterator$1;
var getIteratorMethod$1 = getIteratorMethod$3;
var iteratorClose$3 = iteratorClose$4;

var $TypeError$5 = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

var iterate$3 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$1(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose$3(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$d(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$1(iterable);
    if (!iterFn) throw new $TypeError$5(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike$3(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf$2(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call$d(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose$3(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf$2(ResultPrototype, result)) return result;
  } return new Result(false);
};

var wellKnownSymbol$b = wellKnownSymbol$l;

var ITERATOR$5 = wellKnownSymbol$b('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$5] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$1 = function (exec, SKIP_CLOSING) {
  try {
    if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  } catch (error) { return false; } // workaround of old WebKit + `eval` bug
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$5] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var NativePromiseConstructor$1 = promiseNativeConstructor;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$1;
var FORCED_PROMISE_CONSTRUCTOR$3 = promiseConstructorDetection.CONSTRUCTOR;

var promiseStaticsIncorrectIteration = FORCED_PROMISE_CONSTRUCTOR$3 || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor$1.all(iterable).then(undefined, function () { /* empty */ });
});

var $$l = _export;
var call$c = functionCall;
var aCallable$6 = aCallable$d;
var newPromiseCapabilityModule$2 = newPromiseCapability$2;
var perform$1 = perform$3;
var iterate$2 = iterate$3;
var PROMISE_STATICS_INCORRECT_ITERATION$1 = promiseStaticsIncorrectIteration;

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$$l({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION$1 }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$2.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform$1(function () {
      var $promiseResolve = aCallable$6(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$2(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call$c($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$k = _export;
var FORCED_PROMISE_CONSTRUCTOR$2 = promiseConstructorDetection.CONSTRUCTOR;
var NativePromiseConstructor = promiseNativeConstructor;
var getBuiltIn$3 = getBuiltIn$9;
var isCallable$a = isCallable$q;
var defineBuiltIn$4 = defineBuiltIn$7;

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$$k({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR$2, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (isCallable$a(NativePromiseConstructor)) {
  var method = getBuiltIn$3('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn$4(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}

var $$j = _export;
var call$b = functionCall;
var aCallable$5 = aCallable$d;
var newPromiseCapabilityModule$1 = newPromiseCapability$2;
var perform = perform$3;
var iterate$1 = iterate$3;
var PROMISE_STATICS_INCORRECT_ITERATION = promiseStaticsIncorrectIteration;

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$$j({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule$1.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable$5(C.resolve);
      iterate$1(iterable, function (promise) {
        call$b($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});

var $$i = _export;
var newPromiseCapabilityModule = newPromiseCapability$2;
var FORCED_PROMISE_CONSTRUCTOR$1 = promiseConstructorDetection.CONSTRUCTOR;

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$$i({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR$1 }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    var capabilityReject = capability.reject;
    capabilityReject(r);
    return capability.promise;
  }
});

var anObject$c = anObject$j;
var isObject$5 = isObject$e;
var newPromiseCapability = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$c(C);
  if (isObject$5(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

var $$h = _export;
var getBuiltIn$2 = getBuiltIn$9;
var FORCED_PROMISE_CONSTRUCTOR = promiseConstructorDetection.CONSTRUCTOR;
var promiseResolve = promiseResolve$1;

getBuiltIn$2('Promise');

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$$h({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

function cn(...inputs) {
  return twMerge(clsx(inputs));
}
var ResultCode;
(function (ResultCode) {
  ResultCode["InvalidCredentials"] = "INVALID_CREDENTIALS";
  ResultCode["InvalidSubmission"] = "INVALID_SUBMISSION";
  ResultCode["UserAlreadyExists"] = "USER_ALREADY_EXISTS";
  ResultCode["UnknownError"] = "UNKNOWN_ERROR";
  ResultCode["UserCreated"] = "USER_CREATED";
  ResultCode["UserLoggedIn"] = "USER_LOGGED_IN";
})(ResultCode || (ResultCode = {}));

const buttonVariants = cva('lumina-inline-flex lumina-flex lumina-items-center lumina-justify-center lumina-whitespace-nowrap lumina-text-sm lumina-font-medium lumina-transition-all focus-visible:lumina-outline-none focus-visible:lumina-ring-1 focus-visible:lumina-ring-ring disabled:lumina-pointer-events-none disabled:lumina-opacity-50 active:lumina-transform active:lumina-scale-95', {
  variants: {
    variant: {
      default: 'lumina-bg-primary lumina-text-primary-foreground lumina-shadow hover:lumina-bg-primary/90',
      destructive: 'lumina-bg-destructive lumina-text-destructive-foreground lumina-shadow-sm hover:lumina-bg-destructive/90',
      outline: 'lumina-border lumina-border-input lumina-bg-background lumina-shadow-sm hover:lumina-bg-foreground/5 hover:lumina-text-foreground',
      secondary: 'lumina-bg-secondary lumina-text-secondary-foreground lumina-shadow-sm hover:lumina-bg-secondary/80',
      ghost: 'hover:lumina-bg-foreground/10 hover:lumina-text-foreground',
      link: 'lumina-text-primary lumina-underline-offset-4 hover:lumina-underline'
    },
    size: {
      default: 'lumina-h-9 lumina-px-4 lumina-py-2 lumina-rounded-md',
      sm: 'lumina-h-8 lumina-rounded-md lumina-px-3 lumina-text-xs',
      lg: 'lumina-h-10 lumina-rounded-md lumina-px-8',
      icon: 'lumina-size-9 lumina-rounded-full'
    }
  },
  defaultVariants: {
    variant: 'default',
    size: 'default'
  }
});
const Button = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className,
      variant,
      size,
      asChild = false
    } = _a,
    props = __rest(_a, ["className", "variant", "size", "asChild"]);
  const Comp = asChild ? Slot : 'button';
  return jsx(Comp, Object.assign({
    className: cn(buttonVariants({
      variant,
      size,
      className
    })),
    ref: ref
  }, props));
});
Button.displayName = 'Button';

const Loader$1 = () => {
  return jsx("div", {
    className: "lumina-flex lumina-items-center lumina-justify-center lumina-animate-spin",
    children: jsx(Loader2, {
      size: 24,
      className: "lumina-text-foreground"
    })
  });
};

function NewThreadButton() {
  const {
    addThread,
    isCreatingThread,
    setIsCreatingNewThread
  } = useThreadStore();
  const {
    user
  } = useUserStore();
  useRouterStore();
  const onPress = () => __awaiter(this, void 0, void 0, function* () {
    if (!user || user.error) {
      console.error("No user found.");
      return;
    }
    setIsCreatingNewThread(true);
    const newThread = yield apiThreadCreate(user.id, new Intl.DateTimeFormat("en-US", {
      timeZoneName: "short",
      hour12: false,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(new Date()));
    setIsCreatingNewThread(false);
    addThread(newThread);
    navigate(`/chat/${newThread.id}`);
  });
  if (!user) {
    return null;
  }
  return jsxs(Button, {
    variant: "ghost",
    className: "lumina-flex lumina-flex-row lumina-items-center lumina-gap-2",
    size: "sm",
    onClick: onPress,
    disabled: isCreatingThread,
    children: [isCreatingThread ? jsx(Loader$1, {}) : jsx(Plus, {
      size: 24,
      className: "lumina-text-foreground"
    }), jsxs("p", {
      children: ["New Thread ", isCreatingThread]
    })]
  });
}

const AlertDialog = AlertDialogPrimitive.Root;
const AlertDialogTrigger = AlertDialogPrimitive.Trigger;
const AlertDialogPortal = AlertDialogPrimitive.Portal;
const AlertDialogOverlay = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(AlertDialogPrimitive.Overlay, Object.assign({
    className: cn('lumina-fixed lumina-inset-0 lumina-z-50 lumina-bg-black/80 data-[state=open]:lumina-animate-in data-[state=closed]:lumina-animate-out data-[state=closed]:lumina-fade-out-0 data-[state=open]:lumina-fade-in-0', className)
  }, props, {
    ref: ref
  }));
});
AlertDialogOverlay.displayName = AlertDialogPrimitive.Overlay.displayName;
const AlertDialogContent = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsxs(AlertDialogPortal, {
    children: [jsx(AlertDialogOverlay, {}), jsx(AlertDialogPrimitive.Content, Object.assign({
      ref: ref,
      className: cn('lumina-fixed lumina-left-[50%] lumina-top-[50%] lumina-z-50 lumina-grid lumina-w-full lumina-max-w-lg lumina-translate-x-[-50%] lumina-translate-y-[-50%] lumina-gap-4 lumina-border lumina-bg-background lumina-p-6 lumina-shadow-lg lumina-duration-200 data-[state=open]:lumina-animate-in data-[state=closed]:lumina-animate-out data-[state=closed]:lumina-fade-out-0 data-[state=open]:lumina-fade-in-0 data-[state=closed]:lumina-zoom-out-95 data-[state=open]:lumina-zoom-in-95 data-[state=closed]:lumina-slide-out-to-left-1/2 data-[state=closed]:lumina-slide-out-to-top-[48%] data-[state=open]:lumina-slide-in-from-left-1/2 data-[state=open]:lumina-slide-in-from-top-[48%] sm:lumina-rounded-lg', className)
    }, props))]
  });
});
AlertDialogContent.displayName = AlertDialogPrimitive.Content.displayName;
const AlertDialogHeader = _a => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("div", Object.assign({
    className: cn('lumina-flex lumina-flex-col lumina-space-y-2 lumina-text-center sm:lumina-text-left', className)
  }, props));
};
AlertDialogHeader.displayName = 'AlertDialogHeader';
const AlertDialogFooter = _a => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("div", Object.assign({
    className: cn('lumina-flex lumina-flex-col-reverse sm:lumina-flex-row sm:lumina-justify-end sm:lumina-space-x-2', className)
  }, props));
};
AlertDialogFooter.displayName = 'AlertDialogFooter';
const AlertDialogTitle = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(AlertDialogPrimitive.Title, Object.assign({
    ref: ref,
    className: cn('lumina-text-lg lumina-font-semibold', className)
  }, props));
});
AlertDialogTitle.displayName = AlertDialogPrimitive.Title.displayName;
const AlertDialogDescription = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(AlertDialogPrimitive.Description, Object.assign({
    ref: ref,
    className: cn('lumina-text-sm lumina-text-muted-foreground', className)
  }, props));
});
AlertDialogDescription.displayName = AlertDialogPrimitive.Description.displayName;
const AlertDialogAction = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(AlertDialogPrimitive.Action, Object.assign({
    ref: ref,
    className: cn(buttonVariants(), className)
  }, props));
});
AlertDialogAction.displayName = AlertDialogPrimitive.Action.displayName;
const AlertDialogCancel = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(AlertDialogPrimitive.Cancel, Object.assign({
    ref: ref,
    className: cn(buttonVariants({
      variant: 'outline'
    }), 'lumina-mt-2 sm:lumina-mt-0', className)
  }, props));
});
AlertDialogCancel.displayName = AlertDialogPrimitive.Cancel.displayName;

const badgeVariants = cva('lumina-inline-flex lumina-items-center lumina-rounded-md lumina-border lumina-px-2.5 lumina-py-0.5 lumina-text-xs lumina-font-semibold lumina-transition-colors focus:lumina-outline-none focus:lumina-ring-2 focus:lumina-ring-ring focus:lumina-ring-offset-2', {
  variants: {
    variant: {
      default: 'lumina-border-transparent lumina-bg-primary lumina-text-primary-foreground lumina-shadow hover:lumina-bg-primary/80',
      secondary: 'lumina-border-transparent lumina-bg-secondary lumina-text-secondary-foreground hover:lumina-bg-secondary/80',
      destructive: 'lumina-border-transparent lumina-bg-destructive lumina-text-destructive-foreground lumina-shadow hover:lumina-bg-destructive/80',
      outline: 'lumina-text-foreground'
    }
  },
  defaultVariants: {
    variant: 'default'
  }
});
function Badge(_a) {
  var {
      className,
      variant
    } = _a,
    props = __rest(_a, ["className", "variant"]);
  return jsx("div", Object.assign({
    className: cn(badgeVariants({
      variant
    }), className)
  }, props));
}

const Card = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("div", Object.assign({
    ref: ref,
    className: cn('lumina-border lumina-border-border lumina-bg-card lumina-text-card-foreground lumina-p-4 lumina-rounded-2xl', className)
  }, props));
});
Card.displayName = 'Card';
const CardHeader$1 = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("div", Object.assign({
    ref: ref,
    className: cn('lumina-flex lumina-flex-col lumina-space-y-1.5 lumina-p-6', className)
  }, props));
});
CardHeader$1.displayName = 'CardHeader';
const CardTitle = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("h3", Object.assign({
    ref: ref,
    className: cn('lumina-text-2xl lumina-font-semibold lumina-leading-none lumina-tracking-tight', className)
  }, props));
});
CardTitle.displayName = 'CardTitle';
const CardDescription = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("p", Object.assign({
    ref: ref,
    className: cn('lumina-text-sm lumina-text-muted-foreground', className)
  }, props));
});
CardDescription.displayName = 'CardDescription';
const CardContent$1 = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("div", Object.assign({
    ref: ref,
    className: cn('lumina-p-6 lumina-pt-0', className)
  }, props));
});
CardContent$1.displayName = 'CardContent';
const CardFooter = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("div", Object.assign({
    ref: ref,
    className: cn('lumina-flex lumina-items-center lumina-p-6 lumina-pt-0', className)
  }, props));
});
CardFooter.displayName = 'CardFooter';
const AnimCard = motion(Card);

const Dialog = DialogPrimitive.Root;
const DialogTrigger = DialogPrimitive.Trigger;
const DialogPortal = DialogPrimitive.Portal;
const DialogClose = DialogPrimitive.Close;
const DialogOverlay = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(DialogPrimitive.Overlay, Object.assign({
    ref: ref,
    className: cn('lumina-fixed lumina-inset-0 lumina-z-50 lumina-bg-black/80  data-[state=open]:lumina-animate-in data-[state=closed]:lumina-animate-out data-[state=closed]:lumina-fade-out-0 data-[state=open]:lumina-fade-in-0', className)
  }, props));
});
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;
const DialogContent = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className,
      children
    } = _a,
    props = __rest(_a, ["className", "children"]);
  return jsxs(DialogPortal, {
    children: [jsx(DialogOverlay, {}), jsxs(DialogPrimitive.Content, Object.assign({
      ref: ref,
      className: cn('lumina-fixed lumina-left-[50%] lumina-top-[50%] lumina-z-50 lumina-grid lumina-w-full lumina-max-w-lg lumina-translate-x-[-50%] lumina-translate-y-[-50%] lumina-gap-4 lumina-border lumina-bg-background lumina-p-6 lumina-shadow-lg lumina-duration-200 data-[state=open]:lumina-animate-in data-[state=closed]:lumina-animate-out data-[state=closed]:lumina-fade-out-0 data-[state=open]:lumina-fade-in-0 data-[state=closed]:lumina-zoom-out-95 data-[state=open]:lumina-zoom-in-95 data-[state=closed]:lumina-slide-out-to-left-1/2 data-[state=closed]:lumina-slide-out-to-top-[48%] data-[state=open]:lumina-slide-in-from-left-1/2 data-[state=open]:lumina-slide-in-from-top-[48%] sm:lumina-rounded-lg', className)
    }, props, {
      children: [children, jsxs(DialogPrimitive.Close, {
        className: "lumina-absolute lumina-right-4 lumina-top-4 lumina-rounded-sm lumina-opacity-70 lumina-ring-offset-background lumina-transition-opacity hover:lumina-opacity-100 focus:lumina-outline-none focus:lumina-ring-2 focus:lumina-ring-ring focus:lumina-ring-offset-2 disabled:lumina-pointer-events-none data-[state=open]:lumina-bg-accent data-[state=open]:lumina-text-muted-foreground",
        children: [jsx(Cross2Icon, {
          className: "lumina-size-4"
        }), jsx("span", {
          className: "lumina-sr-only",
          children: "Close"
        })]
      })]
    }))]
  });
});
DialogContent.displayName = DialogPrimitive.Content.displayName;
const DialogHeader = _a => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("div", Object.assign({
    className: cn('lumina-flex lumina-flex-col lumina-space-y-1.5 lumina-text-center sm:lumina-text-left', className)
  }, props));
};
DialogHeader.displayName = 'DialogHeader';
const DialogFooter = _a => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("div", Object.assign({
    className: cn('lumina-flex lumina-flex-col-reverse sm:lumina-flex-row sm:lumina-justify-end sm:lumina-space-x-2', className)
  }, props));
};
DialogFooter.displayName = 'DialogFooter';
const DialogTitle = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(DialogPrimitive.Title, Object.assign({
    ref: ref,
    className: cn('lumina-text-lg lumina-font-semibold lumina-leading-none lumina-tracking-tight', className)
  }, props));
});
DialogTitle.displayName = DialogPrimitive.Title.displayName;
const DialogDescription = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(DialogPrimitive.Description, Object.assign({
    ref: ref,
    className: cn('lumina-text-sm lumina-text-muted-foreground', className)
  }, props));
});
DialogDescription.displayName = DialogPrimitive.Description.displayName;

const DropdownMenu = DropdownMenuPrimitive.Root;
const DropdownMenuTrigger = DropdownMenuPrimitive.Trigger;
const DropdownMenuGroup = DropdownMenuPrimitive.Group;
const DropdownMenuPortal = DropdownMenuPrimitive.Portal;
const DropdownMenuSub = DropdownMenuPrimitive.Sub;
const DropdownMenuRadioGroup = DropdownMenuPrimitive.RadioGroup;
const DropdownMenuSubTrigger = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className,
      inset,
      children
    } = _a,
    props = __rest(_a, ["className", "inset", "children"]);
  return jsxs(DropdownMenuPrimitive.SubTrigger, Object.assign({
    ref: ref,
    className: cn('lumina-flex lumina-cursor-default lumina-select-none lumina-items-center lumina-rounded-sm lumina-px-2 lumina-py-1.5 lumina-text-sm lumina-outline-none focus:lumina-bg-accent data-[state=open]:lumina-bg-accent', inset && 'lumina-pl-8', className)
  }, props, {
    children: [children, jsx(ChevronRightIcon, {
      className: "lumina-ml-auto lumina-size-4"
    })]
  }));
});
DropdownMenuSubTrigger.displayName = DropdownMenuPrimitive.SubTrigger.displayName;
const DropdownMenuSubContent = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(DropdownMenuPrimitive.SubContent, Object.assign({
    ref: ref,
    className: cn('lumina-z-50 lumina-min-w-[8rem] lumina-overflow-hidden lumina-rounded-md lumina-border lumina-bg-popover lumina-p-1 lumina-text-foreground lumina-shadow-lg data-[state=open]:animate-in data-[state=closed]:lumina-animate-out data-[state=closed]:lumina-fade-out-0 data-[state=open]:lumina-fade-in-0 data-[state=closed]:lumina-zoom-out-95 data-[state=open]:lumina-zoom-in-95 data-[side=bottom]:lumina-slide-in-from-top-2 data-[side=left]:lumina-slide-in-from-right-2 data-[side=right]:lumina-slide-in-from-left-2 data-[side=top]:lumina-slide-in-from-bottom-2', className)
  }, props));
});
DropdownMenuSubContent.displayName = DropdownMenuPrimitive.SubContent.displayName;
const DropdownMenuContent = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className,
      sideOffset = 4
    } = _a,
    props = __rest(_a, ["className", "sideOffset"]);
  return jsx(DropdownMenuPrimitive.Portal, {
    children: jsx(DropdownMenuPrimitive.Content, Object.assign({
      ref: ref,
      sideOffset: sideOffset,
      className: cn('lumina-z-50 lumina-min-w-[8rem] lumina-overflow-hidden lumina-rounded-md lumina-border lumina-bg-popover lumina-p-1 lumina-text-foreground lumina-shadow-md', 'data-[state=open]:lumina-animate-in data-[state=closed]:lumina-animate-out data-[state=closed]:lumina-fade-out-0 data-[state=open]:lumina-fade-in-0 data-[state=closed]:lumina-zoom-out-95 data-[state=open]:lumina-zoom-in-95 data-[side=bottom]:lumina-slide-in-from-top-2 data-[side=left]:lumina-slide-in-from-right-2 data-[side=right]:lumina-slide-in-from-left-2 data-[side=top]:lumina-slide-in-from-bottom-2', className)
    }, props))
  });
});
DropdownMenuContent.displayName = DropdownMenuPrimitive.Content.displayName;
const DropdownMenuItem = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className,
      inset
    } = _a,
    props = __rest(_a, ["className", "inset"]);
  return jsx(DropdownMenuPrimitive.Item, Object.assign({
    ref: ref,
    className: cn('lumina-relative lumina-flex lumina-cursor-default lumina-select-none lumina-items-center lumina-rounded-sm lumina-px-2 lumina-py-1.5 lumina-text-sm lumina-outline-none lumina-transition-colors focus:lumina-bg-secondary focus:lumina-text-foreground data-[disabled]:lumina-pointer-events-none data-[disabled]:lumina-opacity-50', inset && 'lumina-pl-8', className)
  }, props));
});
DropdownMenuItem.displayName = DropdownMenuPrimitive.Item.displayName;
const DropdownMenuCheckboxItem = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className,
      children,
      checked
    } = _a,
    props = __rest(_a, ["className", "children", "checked"]);
  return jsxs(DropdownMenuPrimitive.CheckboxItem, Object.assign({
    ref: ref,
    className: cn('lumina-relative lumina-flex lumina-cursor-default lumina-select-none lumina-items-center lumina-rounded-sm lumina-py-1.5 lumina-pl-8 lumina-pr-2 lumina-text-sm lumina-outline-none lumina-transition-colors focus:lumina-bg-accent focus:lumina-text-foreground data-[disabled]:lumina-pointer-events-none data-[disabled]:lumina-opacity-50', className),
    checked: checked
  }, props, {
    children: [jsx("span", {
      className: "lumina-absolute lumina-left-2 lumina-flex lumina-size-3.5 lumina-items-center lumina-justify-center",
      children: jsx(DropdownMenuPrimitive.ItemIndicator, {
        children: jsx(CheckIcon, {
          className: "lumina-size-4"
        })
      })
    }), children]
  }));
});
DropdownMenuCheckboxItem.displayName = DropdownMenuPrimitive.CheckboxItem.displayName;
const DropdownMenuRadioItem = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className,
      children
    } = _a,
    props = __rest(_a, ["className", "children"]);
  return jsxs(DropdownMenuPrimitive.RadioItem, Object.assign({
    ref: ref,
    className: cn('lumina-relative lumina-flex lumina-cursor-default lumina-select-none lumina-items-center lumina-rounded-sm lumina-py-1.5 lumina-pl-8 lumina-pr-2 lumina-text-sm lumina-outline-none lumina-transition-colors focus:lumina-bg-accent focus:lumina-text-foreground data-[disabled]:lumina-pointer-events-none data-[disabled]:lumina-opacity-50', className)
  }, props, {
    children: [jsx("span", {
      className: "lumina-absolute lumina-left-2 lumina-flex lumina-size-3.5 lumina-items-center lumina-justify-center",
      children: jsx(DropdownMenuPrimitive.ItemIndicator, {
        children: jsx(DotFilledIcon, {
          className: "lumina-size-4 lumina-fill-current"
        })
      })
    }), children]
  }));
});
DropdownMenuRadioItem.displayName = DropdownMenuPrimitive.RadioItem.displayName;
const DropdownMenuLabel = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className,
      inset
    } = _a,
    props = __rest(_a, ["className", "inset"]);
  return jsx(DropdownMenuPrimitive.Label, Object.assign({
    ref: ref,
    className: cn('lumina-px-2 lumina-py-1.5 lumina-text-sm lumina-font-semibold', inset && 'lumina-pl-8', className)
  }, props));
});
DropdownMenuLabel.displayName = DropdownMenuPrimitive.Label.displayName;
const DropdownMenuSeparator = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(DropdownMenuPrimitive.Separator, Object.assign({
    ref: ref,
    className: cn('-lumina-mx-1 lumina-my-1 lumina-h-px lumina-bg-muted', className)
  }, props));
});
DropdownMenuSeparator.displayName = DropdownMenuPrimitive.Separator.displayName;
const DropdownMenuShortcut = _a => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("span", Object.assign({
    className: cn('lumina-ml-auto lumina-text-xs lumina-tracking-widest lumina-opacity-60', className)
  }, props));
};
DropdownMenuShortcut.displayName = 'DropdownMenuShortcut';

function IconNextChat(_a) {
  var {
      className,
      inverted
    } = _a,
    props = __rest(_a, ["className", "inverted"]);
  const id = React.useId();
  return jsxs("svg", Object.assign({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: cn('lumina-size-4', className)
  }, props, {
    children: [jsxs("defs", {
      children: [jsxs("linearGradient", {
        id: `gradient-${id}-1`,
        x1: "10.6889",
        y1: "10.3556",
        x2: "13.8445",
        y2: "14.2667",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: inverted ? 'white' : 'black'
        }), jsx("stop", {
          offset: 1,
          stopColor: inverted ? 'white' : 'black',
          stopOpacity: 0
        })]
      }), jsxs("linearGradient", {
        id: `gradient-${id}-2`,
        x1: "11.7555",
        y1: "4.8",
        x2: "11.7376",
        y2: "9.50002",
        gradientUnits: "userSpaceOnUse",
        children: [jsx("stop", {
          stopColor: inverted ? 'white' : 'black'
        }), jsx("stop", {
          offset: 1,
          stopColor: inverted ? 'white' : 'black',
          stopOpacity: 0
        })]
      })]
    }), jsx("path", {
      d: "M1 16L2.58314 11.2506C1.83084 9.74642 1.63835 8.02363 2.04013 6.39052C2.4419 4.75741 3.41171 3.32057 4.776 2.33712C6.1403 1.35367 7.81003 0.887808 9.4864 1.02289C11.1628 1.15798 12.7364 1.8852 13.9256 3.07442C15.1148 4.26363 15.842 5.83723 15.9771 7.5136C16.1122 9.18997 15.6463 10.8597 14.6629 12.224C13.6794 13.5883 12.2426 14.5581 10.6095 14.9599C8.97637 15.3616 7.25358 15.1692 5.74942 14.4169L1 16Z",
      fill: inverted ? 'black' : 'white',
      stroke: inverted ? 'black' : 'white',
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), jsx("mask", {
      id: "mask0_91_2047",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: 1,
      y: 0,
      width: 16,
      height: 16,
      children: jsx("circle", {
        cx: 9,
        cy: 8,
        r: 8,
        fill: inverted ? 'black' : 'white'
      })
    }), jsxs("g", {
      mask: "url(#mask0_91_2047)",
      children: [jsx("circle", {
        cx: 9,
        cy: 8,
        r: 8,
        fill: inverted ? 'black' : 'white'
      }), jsx("path", {
        d: "M14.2896 14.0018L7.146 4.8H5.80005V11.1973H6.87681V6.16743L13.4444 14.6529C13.7407 14.4545 14.0231 14.2369 14.2896 14.0018Z",
        fill: `url(#gradient-${id}-1)`
      }), jsx("rect", {
        x: "11.2222",
        y: "4.8",
        width: "1.06667",
        height: "6.4",
        fill: `url(#gradient-${id}-2)`
      })]
    })]
  }));
}
function IconOpenAI(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    className: cn('lumina-size-4', className)
  }, props, {
    children: [jsx("title", {
      children: "OpenAI icon"
    }), jsx("path", {
      d: "M22.2819 9.8211a5.9847 5.9847 0 0 0-.5157-4.9108 6.0462 6.0462 0 0 0-6.5098-2.9A6.0651 6.0651 0 0 0 4.9807 4.1818a5.9847 5.9847 0 0 0-3.9977 2.9 6.0462 6.0462 0 0 0 .7427 7.0966 5.98 5.98 0 0 0 .511 4.9107 6.051 6.051 0 0 0 6.5146 2.9001A5.9847 5.9847 0 0 0 13.2599 24a6.0557 6.0557 0 0 0 5.7718-4.2058 5.9894 5.9894 0 0 0 3.9977-2.9001 6.0557 6.0557 0 0 0-.7475-7.0729zm-9.022 12.6081a4.4755 4.4755 0 0 1-2.8764-1.0408l.1419-.0804 4.7783-2.7582a.7948.7948 0 0 0 .3927-.6813v-6.7369l2.02 1.1686a.071.071 0 0 1 .038.052v5.5826a4.504 4.504 0 0 1-4.4945 4.4944zm-9.6607-4.1254a4.4708 4.4708 0 0 1-.5346-3.0137l.142.0852 4.783 2.7582a.7712.7712 0 0 0 .7806 0l5.8428-3.3685v2.3324a.0804.0804 0 0 1-.0332.0615L9.74 19.9502a4.4992 4.4992 0 0 1-6.1408-1.6464zM2.3408 7.8956a4.485 4.485 0 0 1 2.3655-1.9728V11.6a.7664.7664 0 0 0 .3879.6765l5.8144 3.3543-2.0201 1.1685a.0757.0757 0 0 1-.071 0l-4.8303-2.7865A4.504 4.504 0 0 1 2.3408 7.872zm16.5963 3.8558L13.1038 8.364 15.1192 7.2a.0757.0757 0 0 1 .071 0l4.8303 2.7913a4.4944 4.4944 0 0 1-.6765 8.1042v-5.6772a.79.79 0 0 0-.407-.667zm2.0107-3.0231l-.142-.0852-4.7735-2.7818a.7759.7759 0 0 0-.7854 0L9.409 9.2297V6.8974a.0662.0662 0 0 1 .0284-.0615l4.8303-2.7866a4.4992 4.4992 0 0 1 6.6802 4.66zM8.3065 12.863l-2.02-1.1638a.0804.0804 0 0 1-.038-.0567V6.0742a4.4992 4.4992 0 0 1 7.3757-3.4537l-.142.0805L8.704 5.459a.7948.7948 0 0 0-.3927.6813zm1.0976-2.3654l2.602-1.4998 2.6069 1.4998v2.9994l-2.5974 1.4997-2.6067-1.4997Z"
    })]
  }));
}
function IconVercel(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    "aria-label": "Vercel logomark",
    role: "img",
    viewBox: "0 0 74 64",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "M37.5896 0.25L74.5396 64.25H0.639648L37.5896 0.25Z",
      fill: "currentColor"
    })
  }));
}
function IconGitHub(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsxs("svg", Object.assign({
    role: "img",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: [jsx("title", {
      children: "GitHub"
    }), jsx("path", {
      d: "M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"
    })]
  }));
}
function IconSeparator(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    fill: "none",
    shapeRendering: "geometricPrecision",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "M16.88 3.549L7.12 20.451"
    })
  }));
}
function IconArrowDown(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "m205.66 149.66-72 72a8 8 0 0 1-11.32 0l-72-72a8 8 0 0 1 11.32-11.32L120 196.69V40a8 8 0 0 1 16 0v156.69l58.34-58.35a8 8 0 0 1 11.32 11.32Z"
    })
  }));
}
function IconArrowRight(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "m221.66 133.66-72 72a8 8 0 0 1-11.32-11.32L196.69 136H40a8 8 0 0 1 0-16h156.69l-58.35-58.34a8 8 0 0 1 11.32-11.32l72 72a8 8 0 0 1 0 11.32Z"
    })
  }));
}
function IconUser(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "M230.92 212c-15.23-26.33-38.7-45.21-66.09-54.16a72 72 0 1 0-73.66 0c-27.39 8.94-50.86 27.82-66.09 54.16a8 8 0 1 0 13.85 8c18.84-32.56 52.14-52 89.07-52s70.23 19.44 89.07 52a8 8 0 1 0 13.85-8ZM72 96a56 56 0 1 1 56 56 56.06 56.06 0 0 1-56-56Z"
    })
  }));
}
function IconPlus(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "M224 128a8 8 0 0 1-8 8h-80v80a8 8 0 0 1-16 0v-80H40a8 8 0 0 1 0-16h80V40a8 8 0 0 1 16 0v80h80a8 8 0 0 1 8 8Z"
    })
  }));
}
function IconArrowElbow(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "M200 32v144a8 8 0 0 1-8 8H67.31l34.35 34.34a8 8 0 0 1-11.32 11.32l-48-48a8 8 0 0 1 0-11.32l48-48a8 8 0 0 1 11.32 11.32L67.31 168H184V32a8 8 0 0 1 16 0Z"
    })
  }));
}
function IconSpinner(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4 animate-spin', className)
  }, props, {
    children: jsx("path", {
      d: "M232 128a104 104 0 0 1-208 0c0-41 23.81-78.36 60.66-95.27a8 8 0 0 1 6.68 14.54C60.15 61.59 40 93.27 40 128a88 88 0 0 0 176 0c0-34.73-20.15-66.41-51.34-80.73a8 8 0 0 1 6.68-14.54C208.19 49.64 232 87 232 128Z"
    })
  }));
}
function IconMessage(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "M216 48H40a16 16 0 0 0-16 16v160a15.84 15.84 0 0 0 9.25 14.5A16.05 16.05 0 0 0 40 240a15.89 15.89 0 0 0 10.25-3.78.69.69 0 0 0 .13-.11L82.5 208H216a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16ZM40 224Zm176-32H82.5a16 16 0 0 0-10.3 3.75l-.12.11L40 224V64h176Z"
    })
  }));
}
function IconTrash(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "M216 48h-40v-8a24 24 0 0 0-24-24h-48a24 24 0 0 0-24 24v8H40a8 8 0 0 0 0 16h8v144a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V64h8a8 8 0 0 0 0-16ZM96 40a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v8H96Zm96 168H64V64h128Zm-80-104v64a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0Zm48 0v64a8 8 0 0 1-16 0v-64a8 8 0 0 1 16 0Z"
    })
  }));
}
function IconRefresh(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "M197.67 186.37a8 8 0 0 1 0 11.29C196.58 198.73 170.82 224 128 224c-37.39 0-64.53-22.4-80-39.85V208a8 8 0 0 1-16 0v-48a8 8 0 0 1 8-8h48a8 8 0 0 1 0 16H55.44C67.76 183.35 93 208 128 208c36 0 58.14-21.46 58.36-21.68a8 8 0 0 1 11.31.05ZM216 40a8 8 0 0 0-8 8v23.85C192.53 54.4 165.39 32 128 32c-42.82 0-68.58 25.27-69.66 26.34a8 8 0 0 0 11.3 11.34C69.86 69.46 92 48 128 48c35 0 60.24 24.65 72.56 40H168a8 8 0 0 0 0 16h48a8 8 0 0 0 8-8V48a8 8 0 0 0-8-8Z"
    })
  }));
}
function IconStop(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "M128 24a104 104 0 1 0 104 104A104.11 104.11 0 0 0 128 24Zm0 192a88 88 0 1 1 88-88 88.1 88.1 0 0 1-88 88Zm24-120h-48a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8Zm-8 48h-32v-32h32Z"
    })
  }));
}
function IconSidebar(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "M216 40H40a16 16 0 0 0-16 16v144a16 16 0 0 0 16 16h176a16 16 0 0 0 16-16V56a16 16 0 0 0-16-16ZM40 56h40v144H40Zm176 144H96V56h120v144Z"
    })
  }));
}
function IconMoon(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "M233.54 142.23a8 8 0 0 0-8-2 88.08 88.08 0 0 1-109.8-109.8 8 8 0 0 0-10-10 104.84 104.84 0 0 0-52.91 37A104 104 0 0 0 136 224a103.09 103.09 0 0 0 62.52-20.88 104.84 104.84 0 0 0 37-52.91 8 8 0 0 0-1.98-7.98Zm-44.64 48.11A88 88 0 0 1 65.66 67.11a89 89 0 0 1 31.4-26A106 106 0 0 0 96 56a104.11 104.11 0 0 0 104 104 106 106 0 0 0 14.92-1.06 89 89 0 0 1-26.02 31.4Z"
    })
  }));
}
function IconSun(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "M120 40V16a8 8 0 0 1 16 0v24a8 8 0 0 1-16 0Zm72 88a64 64 0 1 1-64-64 64.07 64.07 0 0 1 64 64Zm-16 0a48 48 0 1 0-48 48 48.05 48.05 0 0 0 48-48ZM58.34 69.66a8 8 0 0 0 11.32-11.32l-16-16a8 8 0 0 0-11.32 11.32Zm0 116.68-16 16a8 8 0 0 0 11.32 11.32l16-16a8 8 0 0 0-11.32-11.32ZM192 72a8 8 0 0 0 5.66-2.34l16-16a8 8 0 0 0-11.32-11.32l-16 16A8 8 0 0 0 192 72Zm5.66 114.34a8 8 0 0 0-11.32 11.32l16 16a8 8 0 0 0 11.32-11.32ZM48 128a8 8 0 0 0-8-8H16a8 8 0 0 0 0 16h24a8 8 0 0 0 8-8Zm80 80a8 8 0 0 0-8 8v24a8 8 0 0 0 16 0v-24a8 8 0 0 0-8-8Zm112-88h-24a8 8 0 0 0 0 16h24a8 8 0 0 0 0-16Z"
    })
  }));
}
function IconCopy(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "M216 32H88a8 8 0 0 0-8 8v40H40a8 8 0 0 0-8 8v128a8 8 0 0 0 8 8h128a8 8 0 0 0 8-8v-40h40a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8Zm-56 176H48V96h112Zm48-48h-32V88a8 8 0 0 0-8-8H96V48h112Z"
    })
  }));
}
function IconCheck(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "m229.66 77.66-128 128a8 8 0 0 1-11.32 0l-56-56a8 8 0 0 1 11.32-11.32L96 188.69 218.34 66.34a8 8 0 0 1 11.32 11.32Z"
    })
  }));
}
function IconDownload(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "M224 152v56a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16v-56a8 8 0 0 1 16 0v56h160v-56a8 8 0 0 1 16 0Zm-101.66 5.66a8 8 0 0 0 11.32 0l40-40a8 8 0 0 0-11.32-11.32L136 132.69V40a8 8 0 0 0-16 0v92.69l-26.34-26.35a8 8 0 0 0-11.32 11.32Z"
    })
  }));
}
function IconClose(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    fill: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      d: "M205.66 194.34a8 8 0 0 1-11.32 11.32L128 139.31l-66.34 66.35a8 8 0 0 1-11.32-11.32L116.69 128 50.34 61.66a8 8 0 0 1 11.32-11.32L128 116.69l66.34-66.35a8 8 0 0 1 11.32 11.32L139.31 128Z"
    })
  }));
}
function IconEdit(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 1.5,
    stroke: "currentColor",
    className: cn('lumina-size-4', className)
  }, props, {
    children: jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10"
    })
  }));
}
function IconShare(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    className: cn('lumina-size-4', className),
    viewBox: "0 0 256 256"
  }, props, {
    children: jsx("path", {
      d: "m237.66 106.35-80-80A8 8 0 0 0 144 32v40.35c-25.94 2.22-54.59 14.92-78.16 34.91-28.38 24.08-46.05 55.11-49.76 87.37a12 12 0 0 0 20.68 9.58c11-11.71 50.14-48.74 107.24-52V192a8 8 0 0 0 13.66 5.65l80-80a8 8 0 0 0 0-11.3ZM160 172.69V144a8 8 0 0 0-8-8c-28.08 0-55.43 7.33-81.29 21.8a196.17 196.17 0 0 0-36.57 26.52c5.8-23.84 20.42-46.51 42.05-64.86C99.41 99.77 127.75 88 152 88a8 8 0 0 0 8-8V51.32L220.69 112Z"
    })
  }));
}
function IconUsers(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    className: cn('lumina-size-4', className),
    viewBox: "0 0 256 256"
  }, props, {
    children: jsx("path", {
      d: "M117.25 157.92a60 60 0 1 0-66.5 0 95.83 95.83 0 0 0-47.22 37.71 8 8 0 1 0 13.4 8.74 80 80 0 0 1 134.14 0 8 8 0 0 0 13.4-8.74 95.83 95.83 0 0 0-47.22-37.71ZM40 108a44 44 0 1 1 44 44 44.05 44.05 0 0 1-44-44Zm210.14 98.7a8 8 0 0 1-11.07-2.33A79.83 79.83 0 0 0 172 168a8 8 0 0 1 0-16 44 44 0 1 0-16.34-84.87 8 8 0 1 1-5.94-14.85 60 60 0 0 1 55.53 105.64 95.83 95.83 0 0 1 47.22 37.71 8 8 0 0 1-2.33 11.07Z"
    })
  }));
}
function IconExternalLink(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    className: cn('lumina-size-4', className),
    viewBox: "0 0 256 256"
  }, props, {
    children: jsx("path", {
      d: "M224 104a8 8 0 0 1-16 0V59.32l-66.33 66.34a8 8 0 0 1-11.32-11.32L196.68 48H152a8 8 0 0 1 0-16h64a8 8 0 0 1 8 8Zm-40 24a8 8 0 0 0-8 8v72H48V80h72a8 8 0 0 0 0-16H48a16 16 0 0 0-16 16v128a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-72a8 8 0 0 0-8-8Z"
    })
  }));
}
function IconChevronUpDown(_a) {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    className: cn('lumina-size-4', className),
    viewBox: "0 0 256 256"
  }, props, {
    children: jsx("path", {
      d: "M181.66 170.34a8 8 0 0 1 0 11.32l-48 48a8 8 0 0 1-11.32 0l-48-48a8 8 0 0 1 11.32-11.32L128 212.69l42.34-42.35a8 8 0 0 1 11.32 0Zm-96-84.68L128 43.31l42.34 42.35a8 8 0 0 0 11.32-11.32l-48-48a8 8 0 0 0-11.32 0l-48 48a8 8 0 0 0 11.32 11.32Z"
    })
  }));
}

const Input = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className,
      type
    } = _a,
    props = __rest(_a, ["className", "type"]);
  return jsx("input", Object.assign({
    type: type,
    className: cn('flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50', className),
    ref: ref
  }, props));
});
Input.displayName = 'Input';

const labelVariants = cva('text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70');
const Label = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(LabelPrimitive.Root, Object.assign({
    ref: ref,
    className: cn(labelVariants(), className)
  }, props));
});
Label.displayName = LabelPrimitive.Root.displayName;

const Select = SelectPrimitive.Root;
const SelectGroup = SelectPrimitive.Group;
const SelectValue = SelectPrimitive.Value;
const SelectTrigger = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className,
      children
    } = _a,
    props = __rest(_a, ["className", "children"]);
  return jsxs(SelectPrimitive.Trigger, Object.assign({
    ref: ref,
    className: cn('lumina-flex lumina-h-9 lumina-w-full lumina-items-center lumina-justify-between lumina-whitespace-nowrap lumina-rounded-md lumina-border lumina-border-input lumina-bg-transparent lumina-px-3 lumina-py-2 lumina-text-sm lumina-shadow-sm lumina-ring-offset-background placeholder:lumina-text-muted-foreground focus:lumina-outline-none focus:lumina-ring-1 focus:lumina-ring-ring disabled:lumina-cursor-not-allowed disabled:opacity-50 [&>span]:lumina-line-clamp-1', className)
  }, props, {
    children: [children, jsx(SelectPrimitive.Icon, {
      asChild: true,
      children: jsx(CaretSortIcon, {
        className: "lumina-size-4 lumina-opacity-50"
      })
    })]
  }));
});
SelectTrigger.displayName = SelectPrimitive.Trigger.displayName;
const SelectScrollUpButton = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(SelectPrimitive.ScrollUpButton, Object.assign({
    ref: ref,
    className: cn('lumina-flex lumina-cursor-default lumina-items-center lumina-justify-center lumina-py-1', className)
  }, props, {
    children: jsx(ChevronUpIcon, {})
  }));
});
SelectScrollUpButton.displayName = SelectPrimitive.ScrollUpButton.displayName;
const SelectScrollDownButton = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(SelectPrimitive.ScrollDownButton, Object.assign({
    ref: ref,
    className: cn('lumina-flex lumina-cursor-default lumina-items-center lumina-justify-center lumina-py-1', className)
  }, props, {
    children: jsx(ChevronDownIcon, {})
  }));
});
SelectScrollDownButton.displayName = SelectPrimitive.ScrollDownButton.displayName;
const SelectContent = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className,
      children,
      position = 'popper'
    } = _a,
    props = __rest(_a, ["className", "children", "position"]);
  return jsx(SelectPrimitive.Portal, {
    children: jsxs(SelectPrimitive.Content, Object.assign({
      ref: ref,
      className: cn('lumina-relative lumina-z-50 lumina-max-h-96 lumina-min-w-[8rem] lumina-overflow-hidden lumina-rounded-md lumina-border lumina-bg-popover lumina-text-popover-foreground lumina-shadow-md data-[state=open]:lumina-animate-in data-[state=closed]:lumina-animate-out data-[state=closed]:lumina-fade-out-0 data-[state=open]:lumina-fade-in-0 data-[state=closed]:lumina-zoom-out-95 data-[state=open]:lumina-zoom-in-95 data-[side=bottom]:lumina-slide-in-from-top-2 data-[side=left]:lumina-slide-in-from-right-2 data-[side=right]:lumina-slide-in-from-left-2 data-[side=top]:lumina-slide-in-from-bottom-2', position === 'popper' && 'data-[side=bottom]:lumina-translate-y-1 data-[side=left]:lumina--translate-x-1 data-[side=right]:lumina-translate-x-1 data-[side=top]:lumina--translate-y-1', className),
      position: position
    }, props, {
      children: [jsx(SelectScrollUpButton, {}), jsx(SelectPrimitive.Viewport, {
        className: cn('lumina-p-1', position === 'popper' && 'lumina-h-[var(--radix-select-trigger-height)] lumina-w-full lumina-min-w-[var(--radix-select-trigger-width)]'),
        children: children
      }), jsx(SelectScrollDownButton, {})]
    }))
  });
});
SelectContent.displayName = SelectPrimitive.Content.displayName;
const SelectLabel = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(SelectPrimitive.Label, Object.assign({
    ref: ref,
    className: cn('lumina-px-2 lumina-py-1.5 lumina-text-sm lumina-font-semibold', className)
  }, props));
});
SelectLabel.displayName = SelectPrimitive.Label.displayName;
const SelectItem = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className,
      children
    } = _a,
    props = __rest(_a, ["className", "children"]);
  return jsxs(SelectPrimitive.Item, Object.assign({
    ref: ref,
    className: cn('lumina-relative lumina-flex lumina-w-full lumina-cursor-default lumina-select-none lumina-items-center lumina-rounded-sm lumina-py-1.5 lumina-pl-2 lumina-pr-8 lumina-text-sm lumina-outline-none focus:lumina-bg-accent focus:lumina-text-accent-foreground data-[disabled]:lumina-pointer-events-none data-[disabled]:lumina-opacity-50', className)
  }, props, {
    children: [jsx("span", {
      className: "lumina-absolute lumina-right-2 lumina-flex lumina-size-3.5 lumina-items-center lumina-justify-center",
      children: jsx(SelectPrimitive.ItemIndicator, {
        children: jsx(CheckIcon, {
          className: "lumina-size-4"
        })
      })
    }), jsx(SelectPrimitive.ItemText, {
      children: children
    })]
  }));
});
SelectItem.displayName = SelectPrimitive.Item.displayName;
const SelectSeparator = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(SelectPrimitive.Separator, Object.assign({
    ref: ref,
    className: cn('-lumina-mx-1 lumina-my-1 lumina-h-px lumina-bg-muted', className)
  }, props));
});
SelectSeparator.displayName = SelectPrimitive.Separator.displayName;

const Separator = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className,
      orientation = 'horizontal',
      decorative = true
    } = _a,
    props = __rest(_a, ["className", "orientation", "decorative"]);
  return jsx(SeparatorPrimitive.Root, Object.assign({
    ref: ref,
    decorative: decorative,
    orientation: orientation,
    className: cn('lumina-shrink-0 lumina-bg-border', orientation === 'horizontal' ? 'lumina-h-[1px] lumina-w-full' : 'lumina-h-full lumina-w-[1px]', className)
  }, props));
});
Separator.displayName = SeparatorPrimitive.Root.displayName;

const Sheet = DialogPrimitive.Root;
const SheetTrigger = DialogPrimitive.Trigger;
const SheetClose = DialogPrimitive.Close;
const SheetPortal = DialogPrimitive.Portal;
const SheetOverlay = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(DialogPrimitive.Overlay, Object.assign({
    className: cn('lumina-fixed lumina-inset-0 lumina-z-50 lumina-bg-black/80 data-[state=open]:lumina-animate-in data-[state=closed]:lumina-animate-out data-[state=closed]:lumina-fade-out-0 data-[state=open]:lumina-fade-in-0', className)
  }, props, {
    ref: ref
  }));
});
SheetOverlay.displayName = DialogPrimitive.Overlay.displayName;
const sheetVariants = cva('lumina-fixed lumina-z-50 lumina-gap-4 lumina-bg-background lumina-p-6 lumina-shadow-lg lumina-transition lumina-ease-in-out data-[state=open]:lumina-animate-in data-[state=closed]:lumina-animate-out data-[state=closed]:lumina-duration-300 data-[state=open]:lumina-duration-500', {
  variants: {
    side: {
      top: 'lumina-inset-x-0 lumina-top-0 lumina-border-b data-[state=closed]:lumina-slide-out-to-top data-[state=open]:lumina-slide-in-from-top',
      bottom: 'lumina-inset-x-0 lumina-bottom-0 lumina-border-t data-[state=closed]:lumina-slide-out-to-bottom data-[state=open]:lumina-slide-in-from-bottom',
      left: 'lumina-inset-y-0 lumina-left-0 lumina-h-full lumina-w-3/4 lumina-border-r data-[state=closed]:lumina-slide-out-to-left data-[state=open]:lumina-slide-in-from-left sm:lumina-max-w-sm',
      right: 'lumina-inset-y-0 lumina-right-0 lumina-h-full lumina-w-3/4 lumina-border-l data-[state=closed]:lumina-slide-out-to-right data-[state=open]:lumina-slide-in-from-right sm:lumina-max-w-sm'
    }
  },
  defaultVariants: {
    side: 'right'
  }
});
const SheetContent = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      side = 'right',
      className,
      children
    } = _a,
    props = __rest(_a, ["side", "className", "children"]);
  return jsxs(SheetPortal, {
    children: [jsx(SheetOverlay, {}), jsxs(DialogPrimitive.Content, Object.assign({
      ref: ref,
      className: cn(sheetVariants({
        side
      }), className)
    }, props, {
      children: [children, jsxs(DialogPrimitive.Close, {
        className: "lumina-absolute lumina-right-4 lumina-top-4 lumina-rounded-sm lumina-opacity-70 lumina-ring-offset-background lumina-transition-opacity hover:lumina-opacity-100 focus:lumina-outline-none focus:lumina-ring-2 focus:lumina-ring-ring focus:lumina-ring-offset-2 disabled:lumina-pointer-events-none data-[state=open]:lumina-bg-secondary",
        children: [jsx(Cross2Icon, {
          className: "lumina-size-4"
        }), jsx("span", {
          className: "lumina-sr-only",
          children: "Close"
        })]
      })]
    }))]
  });
});
SheetContent.displayName = DialogPrimitive.Content.displayName;
const SheetHeader = _a => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("div", Object.assign({
    className: cn('lumina-flex lumina-flex-col lumina-space-y-2 lumina-text-center sm:lumina-text-left', className)
  }, props));
};
SheetHeader.displayName = 'SheetHeader';
const SheetFooter = _a => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("div", Object.assign({
    className: cn('lumina-flex lumina-flex-col-reverse sm:lumina-flex-row sm:lumina-justify-end sm:lumina-space-x-2', className)
  }, props));
};
SheetFooter.displayName = 'SheetFooter';
const SheetTitle = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(DialogPrimitive.Title, Object.assign({
    ref: ref,
    className: cn('lumina-text-lg lumina-font-semibold lumina-text-foreground', className)
  }, props));
});
SheetTitle.displayName = DialogPrimitive.Title.displayName;
const SheetDescription = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(DialogPrimitive.Description, Object.assign({
    ref: ref,
    className: cn('lumina-text-sm lumina-text-muted-foreground', className)
  }, props));
});
SheetDescription.displayName = DialogPrimitive.Description.displayName;

const Skeleton = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className,
      children
    } = _a,
    props = __rest(_a, ["className", "children"]);
  return jsx("div", Object.assign({
    className: cn('lumina-animate-pulse lumina-rounded-md lumina-bg-muted', className),
    ref: ref
  }, props, {
    children: children
  }));
});
Skeleton.displayName = 'Skeleton';

const Toaster = _a => {
  var props = __rest(_a, []);
  const {
    theme = "system"
  } = useTheme();
  return jsx(Toaster$1, Object.assign({
    theme: theme,
    className: "lumina-toaster lumina-group",
    toastOptions: {
      classNames: {
        toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
        description: "group-[.toast]:text-muted-foreground",
        actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
        cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
      }
    }
  }, props));
};

const Switch = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx(SwitchPrimitives.Root, Object.assign({
    className: cn('lumina-peer lumina-inline-flex lumina-h-5 lumina-w-9 lumina-shrink-0 lumina-cursor-pointer lumina-items-center lumina-rounded-full lumina-border-2 lumina-border-transparent lumina-shadow-sm lumina-transition-colors focus-visible:lumina-outline-none focus-visible:lumina-ring-2 focus-visible:lumina-ring-ring focus-visible:lumina-ring-offset-2 focus-visible:lumina-ring-offset-background disabled:lumina-cursor-not-allowed disabled:lumina-opacity-50 data-[state=checked]:lumina-bg-primary data-[state=unchecked]:lumina-bg-input', className)
  }, props, {
    ref: ref,
    children: jsx(SwitchPrimitives.Thumb, {
      className: cn('lumina-pointer-events-none lumina-block lumina-size-4 lumina-rounded-full lumina-bg-background lumina-shadow-lg lumina-ring-0 lumina-transition-transform data-[state=checked]:lumina-translate-x-4 data-[state=unchecked]:lumina-translate-x-0')
    })
  }));
});
Switch.displayName = SwitchPrimitives.Root.displayName;

const Textarea = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className
    } = _a,
    props = __rest(_a, ["className"]);
  return jsx("textarea", Object.assign({
    className: cn('lumina-flex lumina-min-h-[60px] lumina-w-full lumina-rounded-md lumina-border lumina-border-input lumina-bg-transparent lumina-px-3 lumina-py-2 lumina-text-sm lumina-shadow-sm placeholder:lumina-text-muted-foreground focus-visible:lumina-outline-none focus-visible:lumina-ring-1 focus-visible:lumina-ring-ring disabled:lumina-cursor-not-allowed disabled:lumina-opacity-50', className),
    ref: ref
  }, props));
});
Textarea.displayName = 'Textarea';

const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;
const TooltipContent = /*#__PURE__*/React.forwardRef((_a, ref) => {
  var {
      className,
      sideOffset = 4
    } = _a,
    props = __rest(_a, ["className", "sideOffset"]);
  return jsx(TooltipPrimitive.Content, Object.assign({
    ref: ref,
    sideOffset: sideOffset,
    className: cn('lumina-z-50 lumina-overflow-hidden lumina-rounded-md lumina-bg-primary lumina-px-3 lumina-py-1.5 lumina-text-xs lumina-text-primary-foreground lumina-animate-in lumina-fade-in-0 lumina-zoom-in-95 data-[state=closed]:lumina-animate-out data-[state=closed]:lumina-fade-out-0 data-[state=closed]:lumina-zoom-out-95 data-[side=bottom]:lumina-slide-in-from-top-2 data-[side=left]:lumina-slide-in-from-right-2 data-[side=right]:lumina-slide-in-from-left-2 data-[side=top]:lumina-slide-in-from-bottom-2', className)
  }, props));
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

function SidebarToggle({
  hideOnExpand = false
}) {
  const {
    toggleSidebar,
    isSidebarOpen
  } = useSidebarStore();
  return jsxs(Button, {
    variant: "ghost",
    className: cn('lumina-transition-all lumina-overflow-hidden lumina-min-w-9 lumina-p-0', isSidebarOpen && hideOnExpand && 'lumina-w-0 lumina-p-0 lumina-opacity-0 -lumina-m-1'),
    onClick: () => {
      toggleSidebar();
    },
    children: [jsx(PanelRight, {
      size: 20,
      className: "lumina-text-foreground"
    }), jsx("p", {
      className: "lumina-sr-only",
      children: "Toggle Sidebar"
    })]
  });
}

var objectDefineProperties = {};

var DESCRIPTORS$6 = descriptors;
var V8_PROTOTYPE_DEFINE_BUG = v8PrototypeDefineBug;
var definePropertyModule$1 = objectDefineProperty;
var anObject$b = anObject$j;
var toIndexedObject$1 = toIndexedObject$5;
var objectKeys = objectKeys$2;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
objectDefineProperties.f = DESCRIPTORS$6 && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$b(O);
  var props = toIndexedObject$1(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$1.f(O, key = keys[index++], props[key]);
  return O;
};

/* global ActiveXObject -- old IE, WSH */
var anObject$a = anObject$j;
var definePropertiesModule = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys = hiddenKeys$4;
var html = html$2;
var documentCreateElement$1 = documentCreateElement$2;
var sharedKey$1 = sharedKey$3;

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO$1 = sharedKey$1('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
  activeXDocument = null;
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement$1('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject$a(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

var wellKnownSymbol$a = wellKnownSymbol$l;
var create$3 = objectCreate;
var defineProperty$2 = objectDefineProperty.f;

var UNSCOPABLES = wellKnownSymbol$a('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty$2(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$3(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$3 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var fails$d = fails$p;

var correctPrototypeGetter = !fails$d(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var hasOwn$3 = hasOwnProperty_1;
var isCallable$9 = isCallable$q;
var toObject$3 = toObject$6;
var sharedKey = sharedKey$3;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject$3(O);
  if (hasOwn$3(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable$9(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};

var fails$c = fails$p;
var isCallable$8 = isCallable$q;
var isObject$4 = isObject$e;
var getPrototypeOf$2 = objectGetPrototypeOf;
var defineBuiltIn$3 = defineBuiltIn$7;
var wellKnownSymbol$9 = wellKnownSymbol$l;

var ITERATOR$4 = wellKnownSymbol$9('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$4, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$2(getPrototypeOf$2(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$4 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject$4(IteratorPrototype$4) || fails$c(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$4[ITERATOR$4].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$4 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable$8(IteratorPrototype$4[ITERATOR$4])) {
  defineBuiltIn$3(IteratorPrototype$4, ITERATOR$4, function () {
    return this;
  });
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$4,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};

var IteratorPrototype$3 = iteratorsCore.IteratorPrototype;
var create$2 = objectCreate;
var createPropertyDescriptor$2 = createPropertyDescriptor$5;
var setToStringTag$2 = setToStringTag$4;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var iteratorCreateConstructor = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$2(IteratorPrototype$3, { next: createPropertyDescriptor$2(+!ENUMERABLE_NEXT, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var $$g = _export;
var call$a = functionCall;
var FunctionName = functionName;
var isCallable$7 = isCallable$q;
var createIteratorConstructor = iteratorCreateConstructor;
var getPrototypeOf$1 = objectGetPrototypeOf;
var setPrototypeOf$2 = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$4;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$9;
var defineBuiltIn$2 = defineBuiltIn$7;
var wellKnownSymbol$8 = wellKnownSymbol$l;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var PROPER_FUNCTION_NAME$1 = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype$2 = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$3 = wellKnownSymbol$8('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var iteratorDefine = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];

    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    }

    return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$3]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf$1(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf$1(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (setPrototypeOf$2) {
          setPrototypeOf$2(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (!isCallable$7(CurrentIteratorPrototype[ITERATOR$3])) {
          defineBuiltIn$2(CurrentIteratorPrototype, ITERATOR$3, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME$1 && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty$6(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call$a(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn$2(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$g({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if (IterablePrototype[ITERATOR$3] !== defaultIterator) {
    defineBuiltIn$2(IterablePrototype, ITERATOR$3, defaultIterator, { name: DEFAULT });
  }
  Iterators$1[NAME] = defaultIterator;

  return methods;
};

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
var createIterResultObject$2 = function (value, done) {
  return { value: value, done: done };
};

var toIndexedObject = toIndexedObject$5;
var addToUnscopables$2 = addToUnscopables$3;
var Iterators = iterators;
var InternalStateModule$1 = internalState;
var defineProperty$1 = objectDefineProperty.f;
var defineIterator = iteratorDefine;
var createIterResultObject$1 = createIterResultObject$2;
var DESCRIPTORS$5 = descriptors;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$1 = InternalStateModule$1.set;
var getInternalState$1 = InternalStateModule$1.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$1(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$1(this);
  var target = state.target;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = null;
    return createIterResultObject$1(undefined, true);
  }
  switch (state.kind) {
    case 'keys': return createIterResultObject$1(index, false);
    case 'values': return createIterResultObject$1(target[index], false);
  } return createIterResultObject$1([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$2('keys');
addToUnscopables$2('values');
addToUnscopables$2('entries');

// V8 ~ Chrome 45- bug
if (DESCRIPTORS$5 && values.name !== 'values') try {
  defineProperty$1(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = documentCreateElement$2;

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype$1 = classList && classList.constructor && classList.constructor.prototype;

var domTokenListPrototype = DOMTokenListPrototype$1 === Object.prototype ? undefined : DOMTokenListPrototype$1;

var globalThis$8 = globalThis_1;
var DOMIterables = domIterables;
var DOMTokenListPrototype = domTokenListPrototype;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$9;
var setToStringTag = setToStringTag$4;
var wellKnownSymbol$7 = wellKnownSymbol$l;

var ITERATOR$2 = wellKnownSymbol$7('iterator');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR$2] !== ArrayValues) try {
      createNonEnumerableProperty$5(CollectionPrototype, ITERATOR$2, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR$2] = ArrayValues;
    }
    setToStringTag(CollectionPrototype, COLLECTION_NAME, true);
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$5(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(globalThis$8[COLLECTION_NAME] && globalThis$8[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');

function CopyIdButton() {
  const {
    copyToClipboard,
    isCopied
  } = useCopyToClipboard({
    timeout: 1000
  });
  const {
    thread
  } = useChatStore();
  const [lastId, setLastId] = useState('');
  useEffect(() => {
    var _a;
    if (thread === null || thread === void 0 ? void 0 : thread.id) {
      setLastId((_a = thread.id) === null || _a === void 0 ? void 0 : _a.slice(0, 8));
    }
  }, [thread === null || thread === void 0 ? void 0 : thread.id]);
  return jsx("div", {
    className: cn('lumina-transition-all lumina-bg-foreground lumina-overflow-hidden lumina-rounded-full lumina-flex lumina-items-center lumina-justify-center lumina-duration-300 lumina-ease-in-out', (thread === null || thread === void 0 ? void 0 : thread.id) ? 'lumina-opacity-100 lumina-w-32' : 'lumina-opacity-0 lumina-w-0'),
    children: jsxs(Button, {
      variant: "ghost",
      size: "sm",
      onClick: () => {
        copyToClipboard((thread === null || thread === void 0 ? void 0 : thread.id) || '');
      },
      children: [jsx(Copy, {
        size: 15,
        className: cn('lumina-text-background lumina-transition-all lumina-duration-300 lumina-shrink-0', isCopied ? 'lumina-opacity-0 lumina-w-0' : 'lumina-opacity-100 lumina-w-[1rem] lumina-mr-2')
      }), jsx(CircleCheck, {
        size: 15,
        className: cn('lumina-text-background lumina-transition-all lumina-duration-300 lumina-shrink-0', isCopied ? 'lumina-opacity-100 lumina-mr-2' : 'lumina-opacity-0 lumina-w-0')
      }), jsx("div", {
        className: cn('lumina-transition-all lumina-duration-500 lumina-overflow-hidden', thread ? 'lumina-w-16' : 'lumina-w-0'),
        children: jsx("p", {
          className: "lumina-text-background lumina-text-sm",
          children: lastId
        })
      })]
    })
  });
}

function ThemeToggle() {
  const {
    setTheme
  } = useTheme();
  return jsxs(DropdownMenu, {
    children: [jsx(DropdownMenuTrigger, {
      asChild: true,
      children: jsxs(Button, {
        variant: "ghost",
        size: "icon",
        children: [jsx(Sun, {
          className: "lumina-h-[1.2rem] lumina-w-[1.2rem] lumina-rotate-0 lumina-scale-100 lumina-transition-all dark:lumina--rotate-90 dark:lumina-scale-0"
        }), jsx(Moon, {
          className: "lumina-absolute lumina-h-[1.2rem] lumina-w-[1.2rem] lumina-rotate-90 lumina-scale-0 lumina-transition-all dark:lumina-rotate-0 dark:lumina-scale-100"
        }), jsx("span", {
          className: "lumina-sr-only",
          children: "Toggle theme"
        })]
      })
    }), jsxs(DropdownMenuContent, {
      align: "end",
      children: [jsx(DropdownMenuItem, {
        onClick: () => setTheme('light'),
        children: "Light"
      }), jsx(DropdownMenuItem, {
        onClick: () => setTheme('dark'),
        children: "Dark"
      }), jsx(DropdownMenuItem, {
        onClick: () => setTheme('system'),
        children: "System"
      })]
    })]
  });
}

function UserMenu() {
  const {
    user
  } = useUserStore();
  return jsx("div", {
    className: "lumina-flex lumina-items-center lumina-justify-between",
    children: jsxs(DropdownMenu, {
      children: [(user === null || user === void 0 ? void 0 : user.role) === UserRole.admin && jsxs("div", {
        className: "lumina-flex lumina-flex-row lumina-bg-secondary lumina-gap-1 lumina-border-2 lumina-border-border lumina-rounded-lg lumina-px-2 lumina-items-center lumina-mr-1",
        children: [jsx(Terminal, {
          size: 22,
          className: "lumina-text-foreground"
        }), jsx("p", {
          className: "lumina-text-sm lumina-text-foreground",
          children: "Admin"
        })]
      }), jsx(DropdownMenuTrigger, {
        asChild: true,
        children: jsx(Button, {
          variant: "ghost",
          className: "lumina-rounded-full lumina-size-10",
          children: jsx("div", {
            className: "lumina-flex lumina-size-7 lumina-shrink-0 lumina-select-none lumina-items-center lumina-justify-center lumina-rounded-full lumina-bg-muted/50 lumina-text-xs lumina-font-medium lumina-uppercase lumina-text-muted-foreground",
            children: jsx(UserCircle, {
              className: "lumina-size-7 lumina-text-foreground"
            })
          })
        })
      }), jsxs(DropdownMenuContent, {
        sideOffset: 8,
        align: "start",
        className: "lumina-w-fit",
        children: [jsx(DropdownMenuItem, {
          className: "lumina-flex-col lumina-items-start",
          children: jsx("div", {
            className: "lumina-text-xs lumina-text-foreground",
            children: "User email"
          })
        }), jsx(DropdownMenuSeparator, {}), jsx("form", {
          children: jsx("button", {
            className: " lumina-relative lumina-flex lumina-w-full lumina-cursor-pointer lumina-select-none lumina-items-center lumina-rounded-sm lumina-px-2 lumina-py-1.5 lumina-text-xs lumina-outline-none lumina-transition-colors hover:lumina-bg-red-500 hover:lumina-text-white focus:lumina-bg-accent focus:lumina-text-accent-foreground data-[disabled]:lumina-pointer-events-none data-[disabled]:lumina-opacity-50",
            onClick: () => {
              navigate('/settings');
            },
            children: "Settings"
          })
        }), jsx("form", {
          children: jsx("button", {
            className: " lumina-relative lumina-flex lumina-w-full lumina-cursor-pointer lumina-select-none lumina-items-center lumina-rounded-sm lumina-px-2 lumina-py-1.5 lumina-text-xs lumina-outline-none lumina-transition-colors hover:lumina-bg-red-500 hover:lumina-text-white focus:lumina-bg-accent focus:lumina-text-accent-foreground data-[disabled]:lumina-pointer-events-none data-[disabled]:lumina-opacity-50",
            onClick: () => {
              navigate('/login');
            },
            children: "Sign Out"
          })
        })]
      })]
    })
  });
}

function ActionMenu() {
  const {
    isSidebarOpen
  } = useSidebarStore();
  return jsxs("div", {
    className: "lumina-p-1 lumina-flex lumina-flex-row lumina-items-center lumina-justify-between lumina-bg-background",
    children: [jsxs("div", {
      className: "lumina-flex lumina-flex-row lumina-items-center lumina-gap-2",
      children: [!isSidebarOpen && jsx(SidebarToggle, {}), jsx(NewThreadButton, {}), jsx(CopyIdButton, {})]
    }), jsxs("div", {
      className: "lumina-flex lumina-flex-row lumina-items-center lumina-gap-2",
      children: [jsx(UserMenu, {}), jsx(ThemeToggle, {})]
    })]
  });
}

const BrandLily = props =>
// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
jsx("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: "100%",
  height: "100%",
  fill: "none",
  viewBox: "0 0 438 438"
}, props, {
  children: jsxs("g", {
    filter: "url(#a)",
    children: [jsx("circle", {
      cx: 219.079,
      cy: 219.079,
      r: 104.533,
      fill: "#555DD0",
      stroke: "#fff",
      strokeWidth: 9.093
    }), jsx("path", {
      fill: "#555DD0",
      fillRule: "evenodd",
      d: "M217.695 209.231c1.535-18.021 9.941-41.658 53.159-42.118 1.381 17.249-7.132 49.105-43.457 50.582 18.022 1.534 41.665 9.936 42.125 53.159-17.248 1.382-49.101-7.13-50.581-43.451-1.536 18.021-9.942 41.658-53.159 42.118-1.382-17.249 7.132-49.104 43.456-50.582-18.021-1.533-41.664-9.936-42.124-53.159 17.247-1.382 49.101 7.131 50.581 43.451Zm-.159 8.156a82.05 82.05 0 0 1-.149 1.712c.566.043 1.137.092 1.713.148.043-.565.093-1.135.149-1.712a81.501 81.501 0 0 1-1.713-.148Z",
      clipRule: "evenodd"
    }), jsx("path", {
      fill: "#fff",
      d: "m270.854 167.113 4.532-.363a4.547 4.547 0 0 0-4.581-4.183l.049 4.546Zm-53.159 42.118-4.543.185a4.547 4.547 0 0 0 9.073.201l-4.53-.386Zm9.702 8.464-.184-4.543a4.547 4.547 0 0 0-.201 9.073l.385-4.53Zm42.125 53.159.363 4.532a4.546 4.546 0 0 0 4.183-4.58l-4.546.048Zm-50.581-43.451 4.543-.185a4.547 4.547 0 0 0-9.073-.2l4.53.385Zm-53.159 42.118-4.532.363a4.547 4.547 0 0 0 4.581 4.183l-.049-4.546Zm43.456-50.582.185 4.543a4.547 4.547 0 0 0 .201-9.073l-.386 4.53Zm-42.124-53.159-.363-4.532a4.548 4.548 0 0 0-4.184 4.581l4.547-.049Zm50.422 51.607.44-4.525a4.545 4.545 0 0 0-4.974 4.182l4.534.343Zm-.149 1.712-4.525-.44a4.547 4.547 0 0 0 4.182 4.974l.343-4.534Zm1.713.148-.44 4.525a4.544 4.544 0 0 0 4.974-4.182l-4.534-.343Zm.149-1.712 4.525.44a4.545 4.545 0 0 0-4.182-4.973l-.343 4.533Zm51.556-54.968c-22.438.239-36.692 6.525-45.48 15.912-8.702 9.294-11.354 20.904-12.16 30.366l9.06.772c.729-8.558 3.048-17.778 9.738-24.923 6.602-7.051 18.16-12.813 38.939-13.034l-.097-9.093Zm-43.223 59.671c19.708-.802 32.263-9.969 39.53-21.495 7.114-11.285 9.028-24.582 8.274-33.993l-9.065.727c.628 7.837-1.024 19.093-6.902 28.417-5.726 9.083-15.59 16.582-32.206 17.258l.369 9.086Zm46.486 48.568c-.238-22.442-6.527-36.696-15.916-45.484-9.295-8.701-20.906-11.352-30.369-12.157l-.771 9.06c8.559.729 17.78 3.046 24.926 9.735 7.053 6.602 12.817 18.161 13.038 38.942l9.092-.096Zm-59.67-43.217c.803 19.705 9.97 32.259 21.496 39.524 11.285 7.114 24.581 9.027 33.991 8.273l-.726-9.064c-7.838.628-19.092-1.024-28.416-6.901-9.083-5.726-16.582-15.588-17.259-32.203l-9.086.371Zm-48.567 46.478c22.438-.239 36.691-6.525 45.48-15.912 8.702-9.294 11.354-20.903 12.16-30.366l-9.06-.771c-.73 8.558-3.048 17.777-9.738 24.922-6.602 7.052-18.16 12.813-38.939 13.034l.097 9.093Zm43.223-59.671c-19.708.802-32.264 9.969-39.53 21.495-7.114 11.285-9.028 24.582-8.274 33.993l9.064-.726c-.627-7.838 1.025-19.094 6.903-28.418 5.726-9.083 15.589-16.582 32.206-17.258l-.369-9.086Zm.57.013c-8.559-.728-17.78-3.046-24.926-9.735-7.053-6.602-12.817-18.161-13.038-38.942l-9.093.097c.239 22.441 6.527 36.695 15.916 45.484 9.296 8.701 20.907 11.351 30.37 12.156l.771-9.06Zm-42.147-44.097c7.838-.628 19.092 1.024 28.416 6.901 9.083 5.726 16.582 15.589 17.259 32.203l9.086-.37c-.803-19.706-9.97-32.26-21.496-39.525-11.285-7.114-24.581-9.027-33.991-8.273l.726 9.064Zm45.525 46.732c-.04.532-.087 1.07-.14 1.615l9.051.88a83.96 83.96 0 0 0 .156-1.809l-9.067-.686Zm6.538-2.322a83.544 83.544 0 0 0-1.81-.157l-.686 9.068c.533.04 1.071.086 1.616.139l.88-9.05Zm-4.817 2.373a83.96 83.96 0 0 0-.156 1.809l9.067.686c.04-.532.087-1.07.14-1.615l-9.051-.88Zm2.372 4.817c.609.059 1.212.112 1.81.157l.687-9.067a79.687 79.687 0 0 1-1.616-.14l-.881 9.05Z"
    })]
  })
}));

var classof$4 = classof$7;

var $String$1 = String;

var toString$a = function (argument) {
  if (classof$4(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
  return $String$1(argument);
};

// a string of all valid unicode whitespaces
var whitespaces$3 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var uncurryThis$b = functionUncurryThis;
var requireObjectCoercible$4 = requireObjectCoercible$8;
var toString$9 = toString$a;
var whitespaces$2 = whitespaces$3;

var replace$5 = uncurryThis$b(''.replace);
var ltrim = RegExp('^[' + whitespaces$2 + ']+');
var rtrim = RegExp('(^|[^' + whitespaces$2 + '])[' + whitespaces$2 + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$1 = function (TYPE) {
  return function ($this) {
    var string = toString$9(requireObjectCoercible$4($this));
    if (TYPE & 1) string = replace$5(string, ltrim, '');
    if (TYPE & 2) string = replace$5(string, rtrim, '$1');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$1(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$1(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$1(3)
};

var PROPER_FUNCTION_NAME = functionName.PROPER;
var fails$b = fails$p;
var whitespaces$1 = whitespaces$3;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails$b(function () {
    return !!whitespaces$1[METHOD_NAME]()
      || non[METHOD_NAME]() !== non
      || (PROPER_FUNCTION_NAME && whitespaces$1[METHOD_NAME].name !== METHOD_NAME);
  });
};

var $$f = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$$f({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});

// `GetIteratorDirect(obj)` abstract operation
// https://tc39.es/proposal-iterator-helpers/#sec-getiteratordirect
var getIteratorDirect$5 = function (obj) {
  return {
    iterator: obj,
    next: obj.next,
    done: false
  };
};

var defineBuiltIn$1 = defineBuiltIn$7;

var defineBuiltIns$1 = function (target, src, options) {
  for (var key in src) defineBuiltIn$1(target, key, src[key], options);
  return target;
};

var call$9 = functionCall;
var create$1 = objectCreate;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$9;
var defineBuiltIns = defineBuiltIns$1;
var wellKnownSymbol$6 = wellKnownSymbol$l;
var InternalStateModule = internalState;
var getMethod$1 = getMethod$5;
var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var createIterResultObject = createIterResultObject$2;
var iteratorClose$2 = iteratorClose$4;

var TO_STRING_TAG$1 = wellKnownSymbol$6('toStringTag');
var ITERATOR_HELPER = 'IteratorHelper';
var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
var setInternalState = InternalStateModule.set;

var createIteratorProxyPrototype = function (IS_ITERATOR) {
  var getInternalState = InternalStateModule.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);

  return defineBuiltIns(create$1(IteratorPrototype$1), {
    next: function next() {
      var state = getInternalState(this);
      // for simplification:
      //   for `%WrapForValidIteratorPrototype%.next` our `nextHandler` returns `IterResultObject`
      //   for `%IteratorHelperPrototype%.next` - just a value
      if (IS_ITERATOR) return state.nextHandler();
      try {
        var result = state.done ? undefined : state.nextHandler();
        return createIterResultObject(result, state.done);
      } catch (error) {
        state.done = true;
        throw error;
      }
    },
    'return': function () {
      var state = getInternalState(this);
      var iterator = state.iterator;
      state.done = true;
      if (IS_ITERATOR) {
        var returnMethod = getMethod$1(iterator, 'return');
        return returnMethod ? call$9(returnMethod, iterator) : createIterResultObject(undefined, true);
      }
      if (state.inner) try {
        iteratorClose$2(state.inner.iterator, 'normal');
      } catch (error) {
        return iteratorClose$2(iterator, 'throw', error);
      }
      if (iterator) iteratorClose$2(iterator, 'normal');
      return createIterResultObject(undefined, true);
    }
  });
};

var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
var IteratorHelperPrototype = createIteratorProxyPrototype(false);

createNonEnumerableProperty$4(IteratorHelperPrototype, TO_STRING_TAG$1, 'Iterator Helper');

var iteratorCreateProxy = function (nextHandler, IS_ITERATOR) {
  var IteratorProxy = function Iterator(record, state) {
    if (state) {
      state.iterator = record.iterator;
      state.next = record.next;
    } else state = record;
    state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
    state.nextHandler = nextHandler;
    state.counter = 0;
    state.done = false;
    setInternalState(this, state);
  };

  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;

  return IteratorProxy;
};

var anObject$9 = anObject$j;
var iteratorClose$1 = iteratorClose$4;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$2 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$9(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose$1(iterator, 'throw', error);
  }
};

var call$8 = functionCall;
var aCallable$4 = aCallable$d;
var anObject$8 = anObject$j;
var getIteratorDirect$4 = getIteratorDirect$5;
var createIteratorProxy$2 = iteratorCreateProxy;
var callWithSafeIterationClosing$1 = callWithSafeIterationClosing$2;

var IteratorProxy$2 = createIteratorProxy$2(function () {
  var iterator = this.iterator;
  var result = anObject$8(call$8(this.next, iterator));
  var done = this.done = !!result.done;
  if (!done) return callWithSafeIterationClosing$1(iterator, this.mapper, [result.value, this.counter++], true);
});

// `Iterator.prototype.map` method
// https://github.com/tc39/proposal-iterator-helpers
var iteratorMap = function map(mapper) {
  anObject$8(this);
  aCallable$4(mapper);
  return new IteratorProxy$2(getIteratorDirect$4(this), {
    mapper: mapper
  });
};

var $$e = _export;
var map = iteratorMap;
var IS_PURE$2 = isPure;

// `Iterator.prototype.map` method
// https://tc39.es/ecma262/#sec-iterator.prototype.map
$$e({ target: 'Iterator', proto: true, real: true, forced: IS_PURE$2 }, {
  map: map
});

var $$d = _export;
var $includes = arrayIncludes.includes;
var fails$a = fails$p;
var addToUnscopables$1 = addToUnscopables$3;

// FF99+ bug
var BROKEN_ON_SPARSE = fails$a(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$d({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('includes');

var classof$3 = classofRaw$2;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$4 = Array.isArray || function isArray(argument) {
  return classof$3(argument) === 'Array';
};

var uncurryThis$a = functionUncurryThis;
var isArray$3 = isArray$4;
var isCallable$6 = isCallable$q;
var classof$2 = classofRaw$2;
var toString$8 = toString$a;

var push$1 = uncurryThis$a([].push);

var getJsonReplacerFunction = function (replacer) {
  if (isCallable$6(replacer)) return replacer;
  if (!isArray$3(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push$1(keys, element);
    else if (typeof element == 'number' || classof$2(element) === 'Number' || classof$2(element) === 'String') push$1(keys, toString$8(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray$3(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};

var $$c = _export;
var getBuiltIn$1 = getBuiltIn$9;
var apply$2 = functionApply;
var call$7 = functionCall;
var uncurryThis$9 = functionUncurryThis;
var fails$9 = fails$p;
var isCallable$5 = isCallable$q;
var isSymbol = isSymbol$3;
var arraySlice = arraySlice$2;
var getReplacerFunction = getJsonReplacerFunction;
var NATIVE_SYMBOL$1 = symbolConstructorDetection;

var $String = String;
var $stringify = getBuiltIn$1('JSON', 'stringify');
var exec$2 = uncurryThis$9(/./.exec);
var charAt$4 = uncurryThis$9(''.charAt);
var charCodeAt$1 = uncurryThis$9(''.charCodeAt);
var replace$4 = uncurryThis$9(''.replace);
var numberToString = uncurryThis$9(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL$1 || fails$9(function () {
  var symbol = getBuiltIn$1('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) !== '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails$9(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable$5($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable$5($replacer)) value = call$7($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply$2($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt$4(string, offset - 1);
  var next = charAt$4(string, offset + 1);
  if ((exec$2(low, match) && !exec$2(hi, next)) || (exec$2(hi, match) && !exec$2(low, prev))) {
    return '\\u' + numberToString(charCodeAt$1(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $$c({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply$2(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace$4(result, tester, fixIllFormed) : result;
    }
  });
}

var isObject$3 = isObject$e;
var classof$1 = classofRaw$2;
var wellKnownSymbol$5 = wellKnownSymbol$l;

var MATCH$1 = wellKnownSymbol$5('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$3(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$1(it) === 'RegExp');
};

var isRegExp = isRegexp;

var $TypeError$4 = TypeError;

var notARegexp = function (it) {
  if (isRegExp(it)) {
    throw new $TypeError$4("The method doesn't accept regular expressions");
  } return it;
};

var wellKnownSymbol$4 = wellKnownSymbol$l;

var MATCH = wellKnownSymbol$4('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

var $$b = _export;
var uncurryThis$8 = functionUncurryThis;
var notARegExp$1 = notARegexp;
var requireObjectCoercible$3 = requireObjectCoercible$8;
var toString$7 = toString$a;
var correctIsRegExpLogic$1 = correctIsRegexpLogic;

var stringIndexOf$1 = uncurryThis$8(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$b({ target: 'String', proto: true, forced: !correctIsRegExpLogic$1('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf$1(
      toString$7(requireObjectCoercible$3(this)),
      toString$7(notARegExp$1(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});

const ChatSuggestions = ({
  suggestions,
  handleSuggestion
}) => {
  const [animatedSuggestions, setAnimatedSuggestions] = useState(suggestions);
  const containerRef = useRef(null);
  useEffect(() => {
    setAnimatedSuggestions(suggestions);
    if (containerRef.current) {
      containerRef.current.scrollTo({
        left: 0,
        behavior: 'smooth'
      });
    }
  }, [suggestions]);
  const onPress = suggestion => {
    if (suggestion.toLocaleLowerCase().includes('suggestions unavailable')) return;
    handleSuggestion(suggestion);
  };
  return jsx("div", {
    ref: containerRef,
    className: "lumina-absolute -lumina-translate-y-12 lumina-flex lumina-flex-row lumina-w-full lumina-gap-2 lumina-justify-start lumina-overflow-y-hidden lumina-overflow-x-scroll lumina-scroll-snap-type-x-mandatory no-scrollbar",
    children: jsx(AnimatePresence, {
      mode: "wait",
      children: jsx(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        exit: {
          opacity: 0,
          y: -20
        },
        transition: {
          duration: 0.3
        },
        className: "lumina-flex lumina-flex-row lumina-gap-2 lumina-bg-background lumina-pt-1 lumina-rounded-t-2xl",
        children: animatedSuggestions.map(suggestion => jsx("div", {
          className: "lumina-border-2 lumina-border-accent lumina-py-2 lumina-px-3 lumina-rounded-3xl lumina-group hover:lumina-bg-accent lumina-scroll-snap-align-start lumina-bg-background lumina-cursor-pointer",
          onClick: () => onPress(suggestion),
          onKeyDown: e => {
            if (e.key === 'Enter' || e.key === ' ') {
              onPress(suggestion);
            }
          },
          children: jsx("p", {
            className: "lumina-text-accent lumina-text-sm group-hover:lumina-text-accent-foreground lumina-text-nowrap",
            children: suggestion
          })
        }, suggestion))
      }, suggestions.join(','))
    })
  });
};

var anObject$7 = anObject$j;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$7(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};

var fails$8 = fails$p;
var globalThis$7 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp$2 = globalThis$7.RegExp;

var UNSUPPORTED_Y$1 = fails$8(function () {
  var re = $RegExp$2('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y$1 || fails$8(function () {
  return !$RegExp$2('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y$1 || fails$8(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp$2('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

var regexpStickyHelpers = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y$1
};

var fails$7 = fails$p;
var globalThis$6 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp$1 = globalThis$6.RegExp;

var regexpUnsupportedDotAll = fails$7(function () {
  var re = $RegExp$1('.', 's');
  return !(re.dotAll && re.test('\n') && re.flags === 's');
});

var fails$6 = fails$p;
var globalThis$5 = globalThis_1;

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = globalThis$5.RegExp;

var regexpUnsupportedNcg = fails$6(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call$6 = functionCall;
var uncurryThis$7 = functionUncurryThis;
var toString$6 = toString$a;
var regexpFlags = regexpFlags$1;
var stickyHelpers = regexpStickyHelpers;
var shared = shared$4;
var create = objectCreate;
var getInternalState = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt$3 = uncurryThis$7(''.charAt);
var indexOf = uncurryThis$7(''.indexOf);
var replace$3 = uncurryThis$7(''.replace);
var stringSlice$5 = uncurryThis$7(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call$6(nativeExec, re1, 'a');
  call$6(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString$6(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call$6(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call$6(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace$3(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice$5(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt$3(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call$6(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice$5(match.input, charsAdded);
        match[0] = stringSlice$5(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call$6(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$2 = patchedExec;

var $$a = _export;
var exec$1 = regexpExec$2;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$a({ target: 'RegExp', proto: true, forced: /./.exec !== exec$1 }, {
  exec: exec$1
});

// TODO: Remove from `core-js@4` since it's moved to entry points

var call$5 = functionCall;
var defineBuiltIn = defineBuiltIn$7;
var regexpExec$1 = regexpExec$2;
var fails$5 = fails$p;
var wellKnownSymbol$3 = wellKnownSymbol$l;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$9;

var SPECIES$1 = wellKnownSymbol$3('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$3(KEY);

  var DELEGATES_TO_SYMBOL = !fails$5(function () {
    // String methods call symbol-named RegExp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$5(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$1] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () {
      execCalled = true;
      return null;
    };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$1 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: call$5(nativeRegExpMethod, regexp, str, arg2) };
        }
        return { done: true, value: call$5(nativeMethod, str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty$3(RegExpPrototype[SYMBOL], 'sham', true);
};

var uncurryThis$6 = functionUncurryThis;
var toIntegerOrInfinity$1 = toIntegerOrInfinity$4;
var toString$5 = toString$a;
var requireObjectCoercible$2 = requireObjectCoercible$8;

var charAt$2 = uncurryThis$6(''.charAt);
var charCodeAt = uncurryThis$6(''.charCodeAt);
var stringSlice$4 = uncurryThis$6(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString$5(requireObjectCoercible$2($this));
    var position = toIntegerOrInfinity$1(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt$2(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice$4(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};

var charAt$1 = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$1 = function (S, index, unicode) {
  return index + (unicode ? charAt$1(S, index).length : 1);
};

var uncurryThis$5 = functionUncurryThis;
var toObject$2 = toObject$6;

var floor = Math.floor;
var charAt = uncurryThis$5(''.charAt);
var replace$2 = uncurryThis$5(''.replace);
var stringSlice$3 = uncurryThis$5(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$2(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$2(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice$3(str, 0, position);
      case "'": return stringSlice$3(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice$3(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var call$4 = functionCall;
var anObject$6 = anObject$j;
var isCallable$4 = isCallable$q;
var classof = classofRaw$2;
var regexpExec = regexpExec$2;

var $TypeError$3 = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (isCallable$4(exec)) {
    var result = call$4(exec, R, S);
    if (result !== null) anObject$6(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call$4(regexpExec, R, S);
  throw new $TypeError$3('RegExp#exec called on incompatible receiver');
};

var apply$1 = functionApply;
var call$3 = functionCall;
var uncurryThis$4 = functionUncurryThis;
var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var fails$4 = fails$p;
var anObject$5 = anObject$j;
var isCallable$3 = isCallable$q;
var isNullOrUndefined = isNullOrUndefined$5;
var toIntegerOrInfinity = toIntegerOrInfinity$4;
var toLength$1 = toLength$3;
var toString$4 = toString$a;
var requireObjectCoercible$1 = requireObjectCoercible$8;
var advanceStringIndex = advanceStringIndex$1;
var getMethod = getMethod$5;
var getSubstitution = getSubstitution$1;
var regExpExec = regexpExecAbstract;
var wellKnownSymbol$2 = wellKnownSymbol$l;

var REPLACE = wellKnownSymbol$2('replace');
var max = Math.max;
var min$1 = Math.min;
var concat = uncurryThis$4([].concat);
var push = uncurryThis$4([].push);
var stringIndexOf = uncurryThis$4(''.indexOf);
var stringSlice$2 = uncurryThis$4(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$4(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$1(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call$3(replacer, searchValue, O, replaceValue)
        : call$3(nativeReplace, toString$4(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject$5(this);
      var S = toString$4(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable$3(replaceValue);
      if (!functionalReplace) replaceValue = toString$4(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString$4(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength$1(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString$4(result[0]);
        var position = max(min$1(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          replacement = toString$4(apply$1(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice$2(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice$2(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

const INVISIBLE = "[**INVISIBLE**]";
const affiliatesJSON = {
  RISK: {
    name: "Risk Management",
    providers: [{
      code: "AGP",
      name: "Accordant Global Partners",
      overview: 'Accordant Global Partners (AGP) serves as a premier Family Office and Ultra High Net Worth advisory firm. We are a global network of security & risk professionals serving some of the most prominent families, corporations, and business leaders in the world. \nWe act as your outsourced Chief Security Officer and operations team, protecting the safety, privacy, and security of your family and/or business. \nWe specialize in comprehensively addressing the specific and real risks inherent to Family Offices and Ultra High Net Worth individuals. Our role involves advising on safety, protection, privacy, and security risks, adopting the perspective of a Chief Security Officer/Chief Risk Officer within a family office setting. \nOur approach is grounded in understanding the "why" behind the risks before delving into the "what\'s" and "how\'s" of available solutions. We connect our clients with top-tier service providers globally, ensuring access to the best expertise in the field. \nUtilizing a team-based strategy, Accordant Global Partners safeguards clients against non-financial risks, encompassing security, safety, privacy, and personal protection. AGP draws strength from the extensive experience of our Senior Risk Advisors, Risk Advisory Council, and world-class technical experts and service providers. \nWith a cumulative 150+ years of high-end risk management and protection experience, our team members have supported Governments, Corporations, Family Offices, and Ultra High Net Worth individuals. Proactively manage your security and risk needs. \n',
      services: "- Risk Management Consulting – Your on-call, outsourced Chief Security Officer/Chief Risk Officer with an established, world-class panel of technical experts and service providers to mitigate risk and solve complex and sensitive challenges. \n-Advisory, Implementation and Program Management - We evaluate, coordinate, and execute tailored strategies for each family, aiming to minimize risks across five key pillars efficiently and economically. These pillars are: \n i. Medical Risk \n ii. Physical & Personal Risk \n iii. Travel Risk \n iv. Cyber, Digital & Technology Risk \n v. Bespoke Risk \n",
      benefits: "",
      notes: "",
      url: "https://www.accordantglobal.com/",
      emails: ["archer@accordantglobal.com"]
    }]
  },
  DILIGENCE: {
    name: "Due Diligence",
    providers: [{
      code: "HGA",
      name: "Hilton Global Associates",
      overview: "Hilton Global Associates is a professional investigative research firm providing best-in-class due diligence and white-glove client service. Utilizing sophisticated, time-proven methodologies developed over decades, we specialize in tailor-made investigations, placing particular emphasis on exploring the context of a client’s needs and sourcing the information required to make critical business and investment decisions.",
      services: "- Individual Due Diligence - Careful vetting of key parties protects your reputation \n- Business Due Diligence - Investigative Due Diligence of all parties at every level \n- Investment Due Diligence - Uncovering crucial information to avoid headline and reputational risk \n",
      benefits: "",
      notes: "",
      url: "https://hiltonglobalassociates.com/",
      emails: ["randy@hiltonglobalassociates.com"]
    }]
  },
  ADV: {
    name: "Advisory & Assessments",
    providers: [{
      code: "TAP",
      name: "Tapestry Associates",
      overview: "Tapestry Associates is a luxury residential property and personal services management consultancy for families of substantial wealth and their advisors. Tapestry’s unique experience positions us to be your trusted partner as you integrate EstateSpace into your organization. Tapestry believes your personal asset ecosystem should be managed with the same rigor as your financial holdings. Engaging Tapestry as your objective “Estate Whisperer,” helps you optimize your EstateSpace investment and establishes a trusted resource for your evolving asset management and personal service needs.",
      services: "- Property & Household Operations Assessments \n- Personal Staffing Assessment & Placement \n- Owner Representation Luxury Design & Construction \n- Complex Event Management & Logistics \n- Trusted Advisor to UHNW Families & their Family Offices \n",
      benefits: "- Develop an Operational Master Plan to provide a roadmap for enhanced service delivery, increased efficiency, and improved return on investment \n- Continuing guidance and support provided virtually or on-site to ensure successful implementation \n- Optimizes adoption and integration of the EstateSpace platform across your entire infrastructure \n",
      notes: "",
      url: "https://www.tallc.com/",
      emails: ["info@tallc.com", "anne@tallc.com", "judy@tallc.com"]
    }, {
      code: "EOC",
      name: "Ellen Connects",
      overview: "Ellen O’Neill is family office specialist uniquely qualified to handle all aspects of family office and personal planning – specialties include working with Ultra High Net Worth Individuals by aligning parties with her unique skills to develop and maintain extraordinary standards while seamlessly reaching specific goals. Ellen helps you match talent and creativity with need, creating synergies resulting in tangible benefits.",
      services: "- Acting Principal Liaison \n- Family Office Structuring \n- Owner’s Representative and Project Manager \n- Risk Management Assessments \n",
      benefits: "- As a trusted, loyal, and discerning asset and resource, my role is to create a seamless, functioning, and thriving environment with the highest level of discretion and integrity \n- The ability to align with my Principal’s thinking while defining objectives and executing them is my niche \n- The ability to think with high emotional and social intelligence, combined with foresight, produces problem solving with a high level of efficiency \n",
      notes: "",
      url: "http://ellenconnects.com/",
      emails: ["e@ellenconnects.com"]
    }]
  },
  DES: {
    name: "Design Build",
    providers: [{
      code: "REIS",
      name: "Reis Contracting",
      overview: "At Reis, we are redefining the project experience for our clients and delivering a higher standard of construction based on the innovative application of technology and thoughtful leadership. Reis has offices in New York City, Los Angeles, and Long Island, allowing us to build regionally, as well as nationally for select projects.",
      services: "- Pre-Construction & Consulting \n- Construction Management \n- Stipulated Sum / Fixed Price \n- Maintenance & Alterations \n",
      benefits: "",
      notes: "",
      url: "https://reiscontracting.com/",
      emails: ["ereis@reiscontracting.com", "yreis@reiscontracting.com", "hmpost@reiscontracting.com", "emclaughlin@reiscontracting.com"]
    }, {
      code: "KKH",
      name: "Kathy Kuo Home",
      overview: "Kathy Kuo Home is a premier e-commerce destination for an expertly curated collection of luxury furniture and decor essentials, across a variety of popular design styles, and from a slate of trusted home vendors.\n\nAdditionally, KKH is proud to operate a best-in-class Interior Design Studio with options for projects of any scope and size, and a robust Trade Program serving a wide range of home industry professionals.",
      services: "- Home Products \n- Interior Design Services \n",
      benefits: "- Our mission is to help you create a space that is exceptional yet accessible -- enabling you to love where you live \n",
      notes: "",
      url: "https://www.kathykuohome.com/",
      emails: ["designspecialist@kathykuohome.com"]
    }, {
      code: "ZDI",
      name: "ZDesign",
      overview: "Zdesign is an architectural design company. We specialize in commercial, private Jet, nautical, and High end residential design. We have been a leader in the luxury community for over 20 years working in LA and NYC. We love extreme transformations and fully adapt in remodeling/renovation as well as new builds.",
      services: "- Architectural and Landscape Design \n- Nautical and Private Jet Design \n- Mechanical and Sructural Engineering \n- Pool and Pond Design \n- Construction Management \n- Procurement \n",
      benefits: "- We offer unique timeless design, we identify ways to improve design upfront \n- We create realistic budgets, and hold contractors to the task of completing on time and in budget \n- We are big client advocates and strive to make the process as fun and enjoyable as possible for our clients \n",
      notes: "",
      url: "https://zdesigninc.com/",
      emails: ["tom.zulawski@zdesigninc.com"]
    }, {
      code: "PKP",
      name: "Peak Projects",
      overview: "Peak Projects is a steadfast client advocate throughout the life of high-end residential real-estate projects. Our goal is to make designing and building a home an enjoyable and memorable experience.\n\nWe  believe  that  exceptional  and  successful  projects  start  with  carefully  calibrated expectations.  Helping  our  clients  build  these  is  always  the  first  step  of  The  Peak Process. From there, we work to assemble a stellar, incentivized project team. Acting as  the  client's  representative,  Peak  engages  with  the  team  in  an  empathetic  and collaborative manner to ensure the interests of the client and project are always kept in focus.\n\nBy tailoring every aspect of the client experience, Peak Projects brings clarity to the process, reduces budget and schedule risk, and saves the client a meaningful amount of time.",
      services: "- Owner Representation \n- Budget and Schedule Management \n- Procurement Due Diligence \n- Risk Management \n- Construction Management",
      benefits: "",
      notes: "",
      url: "https://www.peakprojects.com/",
      emails: ["info@peakprojects.com"]
    }, {
      code: "TIG",
      name: "The Integrum Group",
      overview: "The Integrum Group specializes in luxury residential and hospitality construction, as well as estate care, primarily concentrating on the Caribbean, Central, and South America regions. Serving as a comprehensive development and construction company, Integrum boasts extensive expertise in crafting custom luxury homes and villas. Comprising a team of creative problem solvers and efficient project managers, Integrum takes pride in delivering high-quality designs even in challenging global environments. Our services include pre-construction consultancy, guiding clients through the design and material selection process. With established relationships with industry leaders in material acquisition and logistics, Integrum plays a crucial role in the success of projects, particularly those situated in unique and hard-to-reach locales.",
      services: "- Construction Management – Management of projects from pre-construction to design and build \n- Development – Strategy and analysis for large scale development and project capital sourcing \n- Estate Management – Personalized management and care of your home, with concierge services for fulfillment",
      benefits: "",
      notes: "",
      url: "https://theintegrumgroup.com/",
      emails: ["davidchekemian@theintegrumgroup.com"]
    }]
  },
  FIN: {
    name: "Financial",
    providers: [{
      code: "VAL",
      name: "Value Pros",
      overview: "ValuePros is a nationwide appraisal management company that produces confidential, USPAP-compliant reports that meet the highest professional standards for Family offices, Lenders, Insurers, Government Agencies (DOJ, IRS), Courts, Estates, Trusts, and Society at Large.\n\nThe firm independently appraises residential and commercial: Real Estate, Personal Property, Equipment, Vehicles, and Special Collections.\n\nWith their staff of accredited appraisal professionals, ValuePros is positioned to provide examination and appraisal services in any national or international location you require. In addition to conducting onsite appraisal examinations in homes, offices, law enforcement agencies, and secure facilities, the firm provides unlimited service reach, scheduling virtual appraisals via live video-recorded examination sessions.\n\nThe company was founded in Naples, FL, in 1976 by Ray Nugent Jr. and is now managed by second and third-generation family members Ray Nugent, Gwen Nugent, and Olivia Collins.",
      services: "- Real Estate Appraisals \n- Personal Property Appraisals \n- Valuation Services \n- Asset Sales Consultation \n",
      benefits: "",
      notes: "",
      url: "https://premier.valuepros.com",
      emails: ["cynthia@valuepros.com", "ray@valuepros.com"]
    }]
  },
  INS: {
    name: "Insurance",
    providers: [{
      code: "NFP",
      name: "NFP Private Client Group",
      overview: "NFP PCG is a leading property and casualty insurance advisor for affluent and high net worth families throughout North America. We are expert designers and negotiators of customized insurance programs to meet the needs of our clients. We maintain strong relationships with the insurance companies that serve this market and they include: AIG, Chubb, Cincinnati, Pure, Nationwide Private Client, Berkley One, and Vault. NFP also has full access to the excess and surplus market to aid in the placement of tough and unique risks.",
      services: "- Comprehensive review program \n- Insurance program to protect assets and lifestyle \n- Ongoing proactive services model \n",
      benefits: "- An organization that is 100% focused on providing insurance services to this segment of the market \n- None of our 200+ employees are commission based sales people \n- This allows us to always perform our services in the best interest of the client with no conflicts of interest \n- Clients are confident that their insurance program is always up to date and customized for them specifically \n",
      notes: "",
      url: "https://www.nfp.com/",
      emails: ["brett.woodward@nfp.com"]
    }]
  },
  INV: {
    name: "Inventory",
    providers: [{
      code: "SER",
      name: "Seriatim",
      overview: "Seriatim is a New York-based company that provides inventory management, organization, and relocation solutions for businesses and individuals. We specialize in creating detailed processes that create harmony and prioritize your needs during change-of-control events or times of transition. Whether we are photographing and cataloguing physical assets in one room or at multiple locations, we will manage the project and help you move forward in a supported, positive direction. We’ll also work collaboratively with your household staff or personnel. Seriatim can handle any project with the professionalism, sensitivity, and meticulousness necessary to get the job done.",
      services: "- Digital Inventory \n- Photographs & Dimensions \n- Evaluation & Valuation \n",
      benefits: "- Peace of mind \n- Knowing what you own and what it’s worth \n",
      notes: "We create a document of your valuables, including photographs, measurements, categories, and values. We digitally photograph all valuable items, measuring furniture and artwork. We cross-reference photographs with receipts (when applicable) and your own replacement-value assessments.",
      url: "https://www.seriatim.net/",
      emails: ["sonya@seriatim.net"]
    }]
  },
  SEC: {
    name: "Security",
    providers: [{
      code: "R5S",
      name: "Red 5 Security",
      overview: "Red Five advises corporations and private families around the world on how to maintain their privacy and be more secure. Our planning and execution makes our Clients more resilient and better prepared both personally and professionally. We ensure bad things don't happen to good people. Our team has served royal families, heads of state, CEOs, recognized brands and private family offices around the world. We’ll partner with you to ensure your long-term privacy, security, and resiliency needs are met.",
      services: "- Non-Financial Due Diligence & Investigations \n- Cybersecurity & Digital Privacy \n- Physical Security \n- Privacy Audits \n- Technical Surveillance Countermeasures \n",
      benefits: "- Bespoke solutions—we know every Client is different \n- Global experience—gives us the ability to go where you need us most \n- Unmatched pedigree and integrity—ensures you get our very best \n",
      notes: "No matter the situation we can help you solve for it. We support your needs across multiple dimensions and all stages of life. From helping you figure out what you need to know to make key decisions on new hires, joint ventures, acquisitions, or philanthropic donations. To providing a holistic report on where your information is on the deep, dark, and open web with proactive recommendations. Safeguard today and tomorrow with Red Five’s proactive, wholistic services.",
      url: "https://www.red5security.com/",
      emails: ["contact@red5security.com", "kris@red5security.com"]
    }]
  },
  LIFE: {
    name: "Lifestyle",
    providers: []
  },
  EMGMT: {
    name: "Estate Management",
    providers: [{
      code: "CES",
      name: "Crown Estate Services",
      overview: "At Crown Estate Services, our mission is simple: To serve as a seamless solution for comprehensive luxury estate and lifestyle needs. Above all, we recognize that each family and property is unique, preferences are specific and needs often shift. Crown Estate Services was formed to provide solutions, understand needs, tailor and fine-tune services to meet each need and to refine over time - all with a commitment to meet and to surpass expectations with the  utmost confidentiality. The professionals at Crown Estate Services draw from deep and wide fields of expertise honed over combined decades of experience in service to HNW and UHNW people and private properties.",
      services: "- Director of Estates \n- Technology and Security Assessments \n- Equestrian Facility Design \n- Construction Design Consulting \n- Owner Representation \n",
      benefits: "- Crown Estate Services has over fifty combined years of experience in the lifestyle, operation and planning requirements of families and family offices with significant assets \n- We provide exemplary service to principals, estate and household managers, individuals, architects and builders \n- We work behind the scenes to deliver solutions tailored to match client needs, enhance your experiences and improve efficiency \n- We are in the business of creating time for our clients and understand the need for a service environment that appears effortless, warm and inviting \n",
      notes: "",
      url: "https://crownestateservices.com/",
      emails: ["tammy@crownestateservices.com", "charles@crownestateservices.com"]
    }]
  },
  WGLV: {
    name: "White Glove",
    providers: [{
      code: "LANG",
      name: "Langford Hospitality",
      overview: "Langford Hospitality specializes in seamlessly integrating ultra-high-net-worth individuals' intricate asset portfolios with EstateSpace through a curated white-glove implementation service. As an endorsed partner by EstateSpace, our Owner's Representative, equipped with a profound understanding of managing private portfolios and collaborating with family offices, ensures a tailored approach for each unique client. Our services encompass the entire initial setup phase, offering comprehensive outsourcing solutions. \nBeginning with customizing the EstateSpace framework, we meticulously populate it with data points from diverse sources, conducting onsite inventories for accurate room-by-room information. Our team configures and builds the platform, providing onboarding, training, and ongoing support through annual service subscriptions. Recognized for professionalism and discretion, we maximize the potential of EstateSpace, eliminating the need for additional headcount and ensuring seamless workflows for our esteemed clients.\n",
      services: "- Client Onboarding: helping your teams get up and running faster on EstateSpace. \n- Program Management: helping to address something as simple as scheduling work, to training the team and creating operational budgets for your holdings. \n- Inventory: complete cataloging of your properties and physical assets. \n- Project Management: helping to manage projects from design and built, to turnover and long-term care. \n- SOPs: developing the digital standard operating procedures to maintain your specific assets with your desired level of care.",
      benefits: "",
      notes: "",
      url: "https://langfordhospitality.com/sylvi",
      emails: ["langfordhospitality@gmail.com"]
    }]
  },
  STF: {
    name: "Staffing",
    providers: [{
      code: "PHM",
      name: "Precise Home Management",
      overview: "Placing just the right staff to take care of your unique household needs is just a starting point. When you work with Precise Home Management, you receive our 100% investment in the ongoing success of our relationship with you. This is why we have earned the honor of serving thousands of discerning clients worldwide since 1998. We put a premium not just on delivering exceptional service, but on the lasting relationships we develop with our clients and candidates. We work hard to earn your trust through integrity, honesty, transparency and an unwavering commitment to your best interests.",
      services: "- Domestic Staffing \n- Consulting & Training \n- Residence Management \n",
      benefits: "- For over 21 years we've been trusted advisors for exceptional staffing \n- We are uniquely qualified to ensure your staff is expertly trained in a wide variety of specialized household tasks and etiquette \n- Expertise in resourcing, hiring and managing just the right private service professionals for a unique situation to include conflict resolution \n",
      notes: "",
      url: "https://precisehome.com/",
      emails: ["tiffany@precisehome.com"]
    }, {
      code: "TAC",
      name: "Tack Advisors",
      overview: "Tack Advisors is a full-service consulting agency dedicated to progressing the role of private service professionals and administrative professionals. Helping the world’s most influential and innovative companies and families develop administrative talent to leverage their success is our passion and expertise. We help our clients achieve excellence through private service and administrative professional training and development, management consulting, and recruitment.",
      services: "- Coaching & Training \n- Consulting \n- Recruiting \n",
      benefits: "- Career coaching is designed to help you map out where you are, where you want to go, and the path to achieving your goals \n- Our #1 goal is to provide you with effective recommendations to increase productivity, create competitive advantage, and directly impact your bottom line \n- Our staffing strategy aligns your recruitment efforts to achieve the best, most sustainable results possible \n",
      notes: "",
      url: "https://www.tackadvisors.co/",
      emails: ["meagan@tackadvisors.co", "info@tackadvisors.co"]
    }, {
      code: "PENN",
      name: "Pennyworth Projects",
      overview: "Pennyworth takes pride in being the benchmark of excellence, a trusted boutique specializing in personalized placement and consultation services. We stand out by providing comprehensive support services, and expertly matching professionals with both full-time and part-time positions. Our team of seasoned professionals excels in delivering high-end personal and business administrative and operational support. At Pennyworth, our focus extends beyond mere recruitment; we are dedicated to the placement and ongoing excellence of crucial structural roles that enhance our clients' lives. From Executive Assistants and Personal Assistants to Chiefs of Staff, Family Assistants, House Managers, Estate Managers, and other operational professionals, we are committed to delivering unparalleled service tailored to your unique needs.\n\nOur curated and personal approach mirrors the art of matchmaking, recognizing that the ideal support extends beyond mere resume qualifications. We are a boutique agency focused on positions that play a pivotal role in the daily success and productivity of our clients. With an unwavering commitment to excellence, we ensure you receive unparalleled service, empowering you to not just succeed but thrive. We cater to a diverse clientele - from investors and executives to entrepreneurs and busy households and take pride in identifying solutions based on each individual’s needs.\n\nAt the core of our mission is the dedication to provide unmatched service for our client’s evolving lifestyle and business demands.",
      services: "- Exclusive Personal Connections – Elevate your household with our tailored and exclusive network searches, linking discerning clients with candidates boasting impressive experience and finely tuned skills. From adept Executive and Personal Assistants to seasoned Estate Managers and Personal Chiefs of Staff, we curate matches that redefine excellence \n- Strategic Professional Engagements – Meet your corporate or business staffing needs by being introduced to those who have the most aligned skills and expertise. Whether you're seeking high-level Executive Assistants or proficient Project Managers, our professional placements ensure your business thrives with the right talent. \n- Virtual Executive Excellence – For those who demand a different approach to support, we cater to clients valuing experience, confidentiality, and resourcefulness. Our Virtual Executive Support is designed to elevate your operations, providing unmatched assistance that aligns with your vision for success from anywhere, to anywhere. \n",
      benefits: "",
      notes: "",
      url: "https://pennyworthprojects.com/",
      emails: ["julia@pennyworthprojects.com", "lisa@pennyworthprojects.com"]
    }]
  },
  TECH: {
    name: "Technology",
    providers: [{
      code: "INI",
      name: "INI",
      overview: "INI takes pride in being a comprehensive technology provider catering to the residential, commercial, and marine markets. Our commitment spans from the initial design and consultation stages to structural wiring and integration. We strive to offer solutions that showcase fine craftsmanship, exceptional value, user-friendliness, and scalability.\n\nIn line with our sense of professional responsibility, INI is proud to be a green-certified business, reflecting our dedication to environmental responsibility. Upholding superlative customer service is at the core of every project we undertake. We believe that this level of service is best delivered by a technician with whom you can build a personal relationship—someone who embodies both reliability and rapport.\n\nEstablished two decades ago, our founding objective was to provide products and services that grow with our clients and their evolving needs. This commitment remains steadfast, even as technology undergoes rapid evolution. In this ever-changing landscape, INI offers the stability of a well-established provider, bringing a blend of experience and innovation to your project. Our goal is to handle the heavy work, allowing you to rest assured that you are well-prepared for both today and the future.",
      services: "- Consultation and Design – Management of projects from pre-construction to design and build \n- Wireless Network – Wi-Fi solutions and security of your network, in whatever the situation requires \n- Home Automation – Personalized management and care of your home, with concierge services for fulfillment \n- Management and monitoring – Remote and onsite services to ensure the health and continuity of your systems \n",
      benefits: "",
      notes: "",
      url: "https://iniav.com/",
      emails: ["sales@iniav.com", "jim@iniav.com"]
    }]
  },
  TRA: {
    name: "Training & Coaching",
    providers: [{
      code: "TAC",
      name: "Tack Advisors",
      overview: "Tack Advisors is a full-service consulting agency dedicated to progressing the role of private service professionals and administrative professionals. Helping the world’s most influential and innovative companies and families develop administrative talent to leverage their success is our passion and expertise. We help our clients achieve excellence through private service and administrative professional training and development, management consulting, and recruitment.",
      services: "- Coaching & Training \n- Consulting \n- Recruiting \n",
      benefits: "- Career coaching is designed to help you map out where you are, where you want to go, and the path to achieving your goals \n- Our #1 goal is to provide you with effective recommendations to increase productivity, create competitive advantage, and directly impact your bottom line \n- Our staffing strategy aligns your recruitment efforts to achieve the best, most sustainable results possible \n",
      notes: "",
      url: "https://www.tackadvisors.co/",
      emails: ["meagan@tackadvisors.co", "info@tackadvisors.co"]
    }]
  },
  TVL: {
    name: "Travel",
    providers: [{
      code: "BTT",
      name: "Black Tie Travel",
      overview: "Black Tie is a multi-award winning Luxury Travel Concierge, committed to delivering fully customized travel experiences and adventures. A Black Tie travel itinerary is based entirely on who you are, what you love, your goals and most importantly, your 'why' of travel.\n\nBlack Tie leverages 30 years of knowledge and expertise, accessing our specialist global relationships to conjure unique access; unforgettable memories all sprinkled with local knowledge and in-destination support. A Black Tie client never feels like a tourist, we create un-googleable leisure itineraries with you. Ultimately, it's all about you, who, where and what you care about.",
      services: "- Fully Curated Leisure Travel – Dreams Crafted \n- Event and Unique VIP access to global events \n- Front of the Plane Club \n- 10,000 luxury villas across the world \n- Luxury Company Escapes and Adventures for company leaders and their top clients (MICE) \n- World’s best Culinary, Wine and Gourmet Experiences \n- Global Luxury Yacht Access \n- Private Jets and Security \n",
      benefits: "",
      notes: "",
      url: "https://blacktietravel.com/",
      emails: ["a.newman@blacktietravel.com", "k.evensen@blacktietravel.com"]
    }, {
      code: "HVN",
      name: "HVN Travel Group",
      overview: "Inspiring spaces. Immersive experiences. A unique sense of place. HVN is your passport to the world’s most unique private residences, homes, suites, villas, and novelty stays: havens bringing together the best of hospitality and home.\n\nWhether booking a penthouse in Miami, a villa in Mexico, or an estate in Mykonos, every experience is managed by a professional local hospitality team and backed by an industry-leading peace of mind Haven Guarantee. Enjoy access to exclusive perks, booking flexibility, 24/7 support, and more.",
      services: "Brought to you in partnership with Black Tie Travel\n- Expert trip designers to curate your perfect stay \n- Concierge itinerary coordination with HVN \n- Personalized VIP experiences (food, excursions, etc.) \n",
      benefits: "",
      notes: "",
      url: "https://stayhvn.com/home",
      emails: ["estatespace@stayhvn.com"]
    }, {
      code: "UNJ",
      name: "Unity Jets",
      overview: "Unity Jets, has revolutionized the private flying experience by removing all the bureaucratic hurdles. Our approach is all about simplicity, offering a trip-by-trip solution with no long-term commitments or capital requirements, and no peak day flight restrictions. We focus on delivering exceptional value, ensuring you get the most out of every journey while saving compared to jet cards and fractional alternatives.\n\nJET HEDGING, our innovative offering, empowers savvy travelers to choose between Fractional Share, Jet Card, or One-Time Charter on a trip-by-trip basis at no extra cost. With over 30 years of combined experience in fractional ownership, jet cards, and charters, you'll work directly with an expert, providing 24/7-365 assistance, without call centers, wait times, or transfers, for a seamless and personalized experience.\n\nWe are dedicated to the highest level of safety standards, and it is at the forefront of everything we do.",
      services: "Private Aviation - Careful vetted fleet of planes and operators \n- Transportation Logistics - Ground transportation to and from airport, in-flight dining \n- Travel Arrangements - Exclusive restaurant bookings, business and personal needs \n",
      benefits: "",
      notes: "",
      url: "http://unityjets.com/",
      emails: ["garrett@unityjets.com", "kevin@unityjets.com"]
    }]
  },
  WARD: {
    name: "Wardrobe",
    providers: [{
      code: "GAR",
      name: "Garde Robe",
      overview: "Garde Robe pioneered the luxury wardrobe management and Cyber Closet valet concept to service the needs of couture collectors, city residents with inadequate closet space, business travelers, globetrotters, multiple home owners, and fashion designers. The only service of its kind, Garde Robe’s raison d’être is museum-quality garment storage for its members’ precious clothing, footwear, furs and accessories collections, and providing on-demand accessibility whenever, wherever.",
      services: "- Archival Couture Preservation \n- Seasonal Wardrobe Storage \n- Travel Wardrobe Storage \n- Fashion Designer Archiving \n- Wardrobe Inventory & Photography \n- Consultation & Personal White-Glove Services \n",
      benefits: "- Premier museum-quality wardrobe storage and preservation \n- Ready-to-wear delivery for all items placed in our care \n- Complimentary same-day pick up \n- Professional wardrobe photography and signature Cyber Closet application \n- Access to your wardrobe anytime, anywhere \n- Luggage-packing and shipping services; and many thoughtful garment care and valet services \n",
      notes: "We are able to facilitating appraisals and guidance on textile-specific insurance coverage options for UHNW couture collectors.",
      url: "https://garderobeonline.com/pricing/",
      emails: ["info@garderobeonline.com", "doug@garderobeonline.com"]
    }]
  },
  QS: {
    name: "QuickStart",
    providers: [{
      code: "ES",
      name: "QuickStart™",
      overview: "At EstateSpace, we provide our QuickStart service to guarantee a seamless setup process.",
      services: "- Setting up a single property with your custom spaces \n- Configuring roles for vendors, clients, and staff \n- Adding essential assets like HVAC, plumbing, and electrical systems \n- Scheduling maintenance tasks for essential asset upkeep \n- Uploading property files \n- Importing contacts and vendors \n- Creating dedicated communication channels for housekeeping, maintenance, and family \n- Tailoring tenant owner preferences to perfection \n",
      benefits: "- With QuickStart, we ensure that your experience with EstateSpace is fine-tuned to meet your exact needs \n",
      notes: "",
      url: "",
      emails: ["customersuccess@estatespace.com"]
    }]
  }
};

function ChatField({
  input,
  handleInputChange,
  handleSubmit,
  isLoading,
  suggestions,
  showSendBtn = true,
  metadata = [],
  setMetadata,
  stop,
  append
}) {
  const textareaRef = useRef(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const lastProcessedPathnameRef = useRef('');
  const isProcessingInvisibleMessageRef = useRef(false);
  const lastInvisibleMessageTimeRef = useRef(0); // Add this line
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = `${Math.min(scrollHeight, 500)}px`;
    }
  }, [input]);
  useEffect(() => {
    // Handle invisible messages
    if (input.includes(INVISIBLE) && !isProcessingInvisibleMessageRef.current) {
      isProcessingInvisibleMessageRef.current = true;
      setIsSubmitting(true);
      handleSubmit();
      setIsSubmitting(false);
      // Reset the flag after a short delay to allow the message to be processed
      setTimeout(() => {
        isProcessingInvisibleMessageRef.current = false;
      }, 1000);
      return;
    }
    // Handle regular submissions
    if (isSubmitting && !isLoading && !input.includes(INVISIBLE)) {
      handleSubmit();
      setIsSubmitting(false);
    }
  }, [isLoading, isSubmitting, input]);
  const handleKeyDown = e => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!isLoading) handleSubmit(e);
    }
  };
  const handleSuggestion = suggestion => {
    if (isLoading) return;
    handleInputChange({
      target: {
        value: suggestion
      }
    });
    setIsSubmitting(true);
  };
  /**
   * Handle sending invisible messages based on context switching to assets route
   */
  useEffect(() => {
    // Prevent multiple processing
    if (isProcessingInvisibleMessageRef.current || isLoading) return;
    // if metadata is too short, do nothing
    if (metadata.length <= 1) return;
    const lastMetadata = metadata[metadata.length - 1];
    const lastPathname = lastMetadata.location.pathname;
    // Check if this is a new assets route that we haven't processed yet
    if (lastPathname.includes('assets') && lastPathname !== '/assets' && lastPathname !== lastProcessedPathnameRef.current && !isLoading) {
      const now = Date.now();
      const timeSinceLastMessage = now - lastInvisibleMessageTimeRef.current;
      const fifteenSeconds = 15 * 1000; // 15 seconds in milliseconds
      if (timeSinceLastMessage >= fifteenSeconds) {
        lastInvisibleMessageTimeRef.current = now; // Update timestamp
        lastProcessedPathnameRef.current = lastPathname; // Update processed pathname
        append({
          role: Role.user,
          content: `${INVISIBLE}Use this data to review my assets. ${JSON.stringify(metadata)}`
        }).catch(console.error);
        setMetadata(prev => prev.slice(-1));
      }
    }
  }, [metadata, isLoading]); // Removed handleInputChange from dependencies to prevent unnecessary re-runs
  const buttonClicked = () => {
    if (isLoading) {
      stop();
    } else {
      handleSubmit();
    }
  };
  return jsxs("div", {
    className: "lumina-relative lumina-m-4",
    children: [jsx("div", {
      className: "lumina-flex-grow lumina-overflow-hidden",
      children: jsx(ChatSuggestions, {
        suggestions: suggestions,
        handleSuggestion: handleSuggestion
      })
    }), jsx(Textarea, {
      ref: textareaRef,
      className: cn('lumina-flex-grow no-scrollbar lumina-resize-none lumina-px-3 lumina-pt-4 lumina-bg-transparent focus-visible:lumina-ring-0 lumina-outline-none focus:lumina-outline-none active:lumina-outline-none focus:lumina-ring-0 focus:lumina-shadow-none lumina-overflow-y-auto lumina-transition-all lumina-flex lumina-flex-row lumina-items-end lumina-border-2 lumina-rounded-lg focus:lumina-border-accent/30'),
      style: {
        paddingRight: '3rem'
      },
      placeholder: "Enter your chat here",
      value: input,
      onChange: handleInputChange,
      onKeyDown: handleKeyDown
    }), jsx(Button, {
      className: cn('lumina-absolute lumina-right-0 lumina-top-0 lumina-size-9 !lumina-rounded-full lumina-mx-3 lumina-my-4 lumina-transition-all lumina-group lumina-flex lumina-items-center lumina-justify-center', !showSendBtn && !isLoading && 'lumina-bg-transparent lumina-shadow-none lumina-pointer-events-none'),
      onClick: buttonClicked,
      children: jsxs("div", {
        className: "lumina-relative lumina-w-[1.2rem] lumina-h-[1.2rem] lumina-flex lumina-items-center lumina-justify-center",
        children: [jsx("div", {
          className: `lumina-absolute lumina-inset-0 lumina-transition-all lumina-duration-200 lumina-transform lumina-flex lumina-items-center lumina-justify-center
          ${isLoading ? 'lumina-opacity-100 lumina-scale-100' : 'lumina-opacity-0 lumina-scale-50 lumina-pointer-events-none'}`,
          children: jsx(X, {
            className: "lumina-min-w-[1.2rem] lumina-min-h-[1.2rem] lumina-text-background"
          })
        }), jsx("div", {
          className: `lumina-absolute lumina-inset-0 lumina-transition-all lumina-duration-200 lumina-transform lumina-flex lumina-items-center lumina-justify-center
          ${!isLoading && showSendBtn ? 'lumina-opacity-100 lumina-scale-100' : 'lumina-opacity-0 lumina-scale-50 lumina-pointer-events-none'}`,
          children: jsx(ArrowUp, {
            className: "lumina-min-w-[1.2rem] lumina-min-h-[1.2rem] lumina-text-background"
          })
        }), jsx("div", {
          className: `lumina-absolute lumina-inset-0 lumina-transition-all lumina-duration-200 lumina-transform lumina-flex lumina-items-center lumina-justify-center
          ${!isLoading && !showSendBtn ? 'lumina-opacity-100 lumina-scale-100' : 'lumina-opacity-0 lumina-scale-50 lumina-pointer-events-none'}`,
          children: jsx(X, {
            className: "lumina-min-w-[1.2rem] lumina-min-h-[1.2rem] lumina-text-background"
          })
        })]
      })
    })]
  });
}

function AnalyzeBidById({
  result
}) {
  return jsxs(Card, {
    className: "lumina-flex lumina-flex-col lumina-gap-3 lumina-w-full sm:lumina-min-w-72 lumina-bg-background",
    children: [jsxs("div", {
      className: "lumina-flex lumina-flex-row lumina-justify-between lumina-items-center lumina-w-full",
      children: [jsxs("div", {
        className: "lumina-flex lumina-flex-row lumina-gap-3 lumina-items-center",
        children: [jsx(ChartNoAxesGantt, {
          className: "lumina-size-10 lumina-bg-accent lumina-text-background lumina-p-2 lumina-rounded-2xl"
        }), jsx("p", {
          className: "lumina-text-xl lumina-font-semibold lumina-text-foreground",
          children: "Analyzing Bid"
        })]
      }), jsx(Loader$1, {})]
    }), jsx(Separator, {}), jsx("p", {
      className: "lumina-text-foreground",
      children: result
    })]
  });
}

var $$9 = _export;
var uncurryThis$3 = functionUncurryThisClause;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var toLength = toLength$3;
var toString$3 = toString$a;
var notARegExp = notARegexp;
var requireObjectCoercible = requireObjectCoercible$8;
var correctIsRegExpLogic = correctIsRegexpLogic;

var stringSlice$1 = uncurryThis$3(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor$1(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$$9({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString$3(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString$3(searchString);
    return stringSlice$1(that, index, index + search.length) === search;
  }
});

var defineProperty = objectDefineProperty.f;

var proxyAccessor$1 = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};

var isCallable$2 = isCallable$q;
var isObject$2 = isObject$e;
var setPrototypeOf$1 = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$1 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf$1 &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable$2(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject$2(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf$1($this, NewTargetPrototype);
  return $this;
};

var toString$2 = toString$a;

var normalizeStringArgument$1 = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString$2(argument);
};

var isObject$1 = isObject$e;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$9;

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
var installErrorCause$1 = function (O, options) {
  if (isObject$1(options) && 'cause' in options) {
    createNonEnumerableProperty$2(O, 'cause', options.cause);
  }
};

var uncurryThis$2 = functionUncurryThis;

var $Error = Error;
var replace$1 = uncurryThis$2(''.replace);

var TEST = (function (arg) { return String(new $Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable, sonarjs/slow-regex -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

var errorStackClear = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace$1(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};

var fails$3 = fails$p;
var createPropertyDescriptor$1 = createPropertyDescriptor$5;

var errorStackInstallable = !fails$3(function () {
  var error = new Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor$1(1, 7));
  return error.stack !== 7;
});

var createNonEnumerableProperty$1 = createNonEnumerableProperty$9;
var clearErrorStack = errorStackClear;
var ERROR_STACK_INSTALLABLE = errorStackInstallable;

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

var errorStackInstall = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty$1(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};

var getBuiltIn = getBuiltIn$9;
var hasOwn$2 = hasOwnProperty_1;
var createNonEnumerableProperty = createNonEnumerableProperty$9;
var isPrototypeOf$1 = objectIsPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var copyConstructorProperties$1 = copyConstructorProperties$3;
var proxyAccessor = proxyAccessor$1;
var inheritIfRequired = inheritIfRequired$1;
var normalizeStringArgument = normalizeStringArgument$1;
var installErrorCause = installErrorCause$1;
var installErrorStack = errorStackInstall;
var DESCRIPTORS$4 = descriptors;

var wrapErrorConstructorWithCause$1 = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (hasOwn$2(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    installErrorStack(result, WrappedError, result.stack, 2);
    if (this && isPrototypeOf$1(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties$1(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS$4 && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties$1(WrappedError, OriginalError);

  try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $$8 = _export;
var globalThis$4 = globalThis_1;
var apply = functionApply;
var wrapErrorConstructorWithCause = wrapErrorConstructorWithCause$1;

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = globalThis$4[WEB_ASSEMBLY];

// eslint-disable-next-line es/no-error-cause -- feature detection
var FORCED$3 = new Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED$3);
  $$8({ global: true, constructor: true, arity: 1, forced: FORCED$3 }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED$3);
    $$8({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED$3 }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});

var globalThis$3 = globalThis_1;
var fails$2 = fails$p;
var uncurryThis$1 = functionUncurryThis;
var toString$1 = toString$a;
var trim = stringTrim.trim;
var whitespaces = whitespaces$3;

var $parseInt = globalThis$3.parseInt;
var Symbol$1 = globalThis$3.Symbol;
var ITERATOR$1 = Symbol$1 && Symbol$1.iterator;
var hex = /^[+-]?0x/i;
var exec = uncurryThis$1(hex.exec);
var FORCED$2 = $parseInt(whitespaces + '08') !== 8 || $parseInt(whitespaces + '0x16') !== 22
  // MS Edge 18- broken with boxed symbols
  || (ITERATOR$1 && !fails$2(function () { $parseInt(Object(ITERATOR$1)); }));

// `parseInt` method
// https://tc39.es/ecma262/#sec-parseint-string-radix
var numberParseInt = FORCED$2 ? function parseInt(string, radix) {
  var S = trim(toString$1(string));
  return $parseInt(S, (radix >>> 0) || (exec(hex, S) ? 16 : 10));
} : $parseInt;

var $$7 = _export;
var parseInt = numberParseInt;

// `Number.parseInt` method
// https://tc39.es/ecma262/#sec-number.parseint
// eslint-disable-next-line es/no-number-parseint -- required for testing
$$7({ target: 'Number', stat: true, forced: Number.parseInt !== parseInt }, {
  parseInt: parseInt
});

var DESCRIPTORS$3 = descriptors;
var definePropertyModule = objectDefineProperty;
var createPropertyDescriptor = createPropertyDescriptor$5;

var createProperty$1 = function (object, key, value) {
  if (DESCRIPTORS$3) definePropertyModule.f(object, key, createPropertyDescriptor(0, value));
  else object[key] = value;
};

var $$6 = _export;
var globalThis$2 = globalThis_1;
var anInstance = anInstance$2;
var anObject$4 = anObject$j;
var isCallable$1 = isCallable$q;
var getPrototypeOf = objectGetPrototypeOf;
var defineBuiltInAccessor$1 = defineBuiltInAccessor$3;
var createProperty = createProperty$1;
var fails$1 = fails$p;
var hasOwn$1 = hasOwnProperty_1;
var wellKnownSymbol$1 = wellKnownSymbol$l;
var IteratorPrototype = iteratorsCore.IteratorPrototype;
var DESCRIPTORS$2 = descriptors;

var CONSTRUCTOR = 'constructor';
var ITERATOR = 'Iterator';
var TO_STRING_TAG = wellKnownSymbol$1('toStringTag');

var $TypeError$2 = TypeError;
var NativeIterator = globalThis$2[ITERATOR];

// FF56- have non-standard global helper `Iterator`
var FORCED$1 = !isCallable$1(NativeIterator)
  || NativeIterator.prototype !== IteratorPrototype
  // FF44- non-standard `Iterator` passes previous tests
  || !fails$1(function () { NativeIterator({}); });

var IteratorConstructor = function Iterator() {
  anInstance(this, IteratorPrototype);
  if (getPrototypeOf(this) === IteratorPrototype) throw new $TypeError$2('Abstract class Iterator not directly constructable');
};

var defineIteratorPrototypeAccessor = function (key, value) {
  if (DESCRIPTORS$2) {
    defineBuiltInAccessor$1(IteratorPrototype, key, {
      configurable: true,
      get: function () {
        return value;
      },
      set: function (replacement) {
        anObject$4(this);
        if (this === IteratorPrototype) throw new $TypeError$2("You can't redefine this property");
        if (hasOwn$1(this, key)) this[key] = replacement;
        else createProperty(this, key, replacement);
      }
    });
  } else IteratorPrototype[key] = value;
};

if (!hasOwn$1(IteratorPrototype, TO_STRING_TAG)) defineIteratorPrototypeAccessor(TO_STRING_TAG, ITERATOR);

if (FORCED$1 || !hasOwn$1(IteratorPrototype, CONSTRUCTOR) || IteratorPrototype[CONSTRUCTOR] === Object) {
  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
}

IteratorConstructor.prototype = IteratorPrototype;

// `Iterator` constructor
// https://tc39.es/ecma262/#sec-iterator
$$6({ global: true, constructor: true, forced: FORCED$1 }, {
  Iterator: IteratorConstructor
});

var $$5 = _export;
var iterate = iterate$3;
var aCallable$3 = aCallable$d;
var anObject$3 = anObject$j;
var getIteratorDirect$3 = getIteratorDirect$5;

// `Iterator.prototype.find` method
// https://tc39.es/ecma262/#sec-iterator.prototype.find
$$5({ target: 'Iterator', proto: true, real: true }, {
  find: function find(predicate) {
    anObject$3(this);
    aCallable$3(predicate);
    var record = getIteratorDirect$3(this);
    var counter = 0;
    return iterate(record, function (value, stop) {
      if (predicate(value, counter++)) return stop(value);
    }, { IS_RECORD: true, INTERRUPTED: true }).result;
  }
});

const iconStyles = "lumina-min-w-6 lumina-min-h-6 lumina-max-w-6 lumina-max-h-6 lumina-text-foreground/80";
const iconHeaderStyles = "lumina-min-w-6 lumina-min-h-6 lumina-max-w-6 lumina-max-h-6 lumina-text-accent";
const iconHeaderErrorStyles = "lumina-min-w-6 lumina-min-h-6 lumina-max-w-6 lumina-max-h-6 lumina-text-red-600";
const iconSmStyles = "lumina-min-w-5 lumina-min-h-5 lumina-max-w-5 lumina-max-h-5 lumina-text-foreground/80";
const iconStylesGreen = "lumina-min-w-5 lumina-min-h-5 lumina-max-w-5 lumina-max-h-5 lumina-text-green-500";

const formatDate = dateString => {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    timeZone: 'UTC'
  }).format(date);
};
const getRecurrenceText = recurrenceRule => {
  if (!recurrenceRule) return 'Non-recurring';
  const ruleLines = recurrenceRule.split('\n');
  const rruleLine = ruleLines.find(line => line.startsWith('RRULE:'));
  if (!rruleLine) return 'Non-recurring';
  const ruleParts = rruleLine.replace('RRULE:', '').split(';');
  let frequency = '';
  let interval = 1;
  for (const part of ruleParts) {
    if (part.startsWith('FREQ=')) {
      frequency = part.split('=')[1];
    }
    if (part.startsWith('INTERVAL=')) {
      interval = Number.parseInt(part.split('=')[1], 10);
    }
  }
  switch (frequency) {
    case 'DAILY':
      return interval === 1 ? 'Every day' : `Every ${interval} days`;
    case 'WEEKLY':
      return interval === 1 ? 'Every week' : `Every ${interval} weeks`;
    case 'MONTHLY':
      return interval === 1 ? 'Every month' : `Every ${interval} months`;
    case 'YEARLY':
      return interval === 1 ? 'Every year' : `Every ${interval} years`;
    default:
      return 'Recurring';
  }
};
function CardWrapper({
  children,
  fullHeight = false
}) {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 100);
    return () => clearTimeout(timer);
  }, []);
  const cardStyles = cn('lumina-flex lumina-rounded-2xl lumina-flex-col lumina-overflow-hidden lumina-w-full', 'lumina-border-[1px] lumina-border-border lumina-max-w-xl lumina-bg-background', 'lumina-transform lumina-transition-all lumina-duration-300 lumina-ease-out', isVisible ? 'lumina-opacity-100 lumina-scale-100' : 'lumina-opacity-0 lumina-scale-75');
  return jsx(ErrorBoundary, {
    fallbackRender: ({
      error,
      resetErrorBoundary
    }) => jsx("div", {
      className: cardStyles,
      children: jsxs("div", {
        className: cn('lumina-flex lumina-flex-col lumina-w-full lumina-gap-2 lumina-overflow-y-auto', !fullHeight && 'lumina-max-h-72'),
        children: [jsx(CardHeader, {
          Icon: ShieldAlert,
          title: error.message
        }), error && jsx(CardItem, {
          title: error.message || 'An error occurred',
          Icon: Info
        })]
      })
    }),
    children: jsx("div", {
      className: cardStyles,
      children: children
    })
  });
}
function CardContent({
  children,
  fullHeight = false
}) {
  return jsx("div", {
    className: cn('lumina-flex lumina-flex-col lumina-gap-2 lumina-p-3 lumina-overflow-y-auto', !fullHeight && 'lumina-max-h-72'),
    children: children
  });
}
function CardHeader({
  title,
  Icon,
  size = 'sm',
  link,
  error = false
}) {
  return jsxs("div", {
    className: "lumina-flex lumina-flex-row lumina-gap-2 lumina-items-center lumina-bg-secondary lumina-px-3 lumina-py-2 lumina-justify-between",
    children: [jsxs("div", {
      className: "lumina-flex lumina-flex-row lumina-gap-2 lumina-items-center",
      children: [Icon && jsx(Icon, {
        className: error ? iconHeaderErrorStyles : iconHeaderStyles
      }), jsx("p", {
        className: cn('lumina-font-semibold lumina-text-foreground', size === 'sm' ? 'lumina-text-sm' : 'lumina-text-md'),
        children: title
      })]
    }), link && jsx(CardLink, {
      link: link
    })]
  });
}
function LoadingCard({
  title,
  Icon,
  size = 'sm'
}) {
  return jsx(CardWrapper, {
    children: jsxs("div", {
      className: "lumina-flex lumina-flex-row lumina-gap-2 lumina-items-center lumina-bg-secondary lumina-p-3",
      children: [Icon && jsx(Icon, {
        className: iconHeaderStyles
      }), jsx("p", {
        className: cn('lumina-font-semibold lumina-text-foreground', size === 'sm' ? 'lumina-text-sm' : 'lumina-text-md'),
        children: title
      }), jsx(Loader$1, {})]
    })
  });
}
function ErrorCard({
  title,
  error,
  userMessage
}) {
  console.error(`Error occured for ${title}\n${error || 'Unknown error'}\nUser message was ${userMessage}`);
  return jsxs(CardWrapper, {
    children: [jsx(CardHeader, {
      Icon: ShieldAlert,
      title: title,
      error: true
    }), userMessage && jsx(CardContent, {
      children: jsx(CardItem, {
        title: userMessage,
        Icon: Info
      })
    })]
  });
}
function CardItem({
  title,
  Icon,
  size = 'sm',
  filled = false,
  bold = false
}) {
  return jsxs("div", {
    className: cn('lumina-flex lumina-flex-row lumina-gap-2 lumina-max-w-full', filled && 'lumina-bg-secondary lumina-rounded-lg lumina-p-2'),
    children: [Icon && jsx(Icon, {
      className: size === 'sm' ? iconSmStyles : iconStyles
    }), jsx("p", {
      className: cn('lumina-text-foreground', size === 'lg' ? 'lumina-text-sm' : 'lumina-text-xs', bold && 'lumina-font-semibold'),
      children: title
    })]
  });
}
function ValueItem({
  title,
  value,
  unit,
  size = 'sm',
  filled = true
}) {
  return jsxs("div", {
    className: cn('lumina-grid lumina-grid-cols-2 lumina-gap-2 lumina-max-w-full lumina-items-center', filled && 'lumina-bg-secondary lumina-rounded-lg lumina-p-2'),
    children: [jsx("p", {
      className: cn('lumina-text-foreground lumina-font-semibold', size === 'lg' ? 'lumina-text-sm' : 'lumina-text-xs'),
      children: title
    }), jsxs("div", {
      className: "lumina-flex lumina-flex-row lumina-gap-1 lumina-items-center",
      children: [value && jsx(DollarSign, {
        className: iconStylesGreen
      }), jsx("p", {
        className: cn('lumina-text-foreground lumina-font-semibold', size === 'lg' ? 'lumina-text-sm' : 'lumina-text-xs'),
        children: value ? `${unit !== '$' ? '' : '$'}${value}` : 'Requires estimate'
      })]
    })]
  });
}
function ItemList({
  items,
  size = 'sm'
}) {
  return jsx("div", {
    className: "lumina-flex lumina-flex-col lumina-gap-2 lumina-w-full",
    children: items.map(({
      detail,
      value
    }) => jsxs("div", {
      className: "lumina-flex lumina-gap-2 lumina-flex-row lumina-p-2 lumina-bg-secondary lumina-rounded-lg",
      children: [jsx(CornerDownRight, {
        className: iconSmStyles
      }), jsx("span", {
        className: cn('lumina-font-semibold', size === 'sm' ? 'lumina-text-sm' : 'lumina-text-xs'),
        children: detail
      }), jsx("p", {
        className: cn(size === 'sm' ? 'lumina-text-sm' : 'lumina-text-xs'),
        children: value
      })]
    }, detail))
  });
}
function ItemListDouble({
  items,
  size = 'sm',
  showIcon = true
}) {
  return jsx("div", {
    className: "lumina-grid lumina-grid-cols-2 lumina-gap-2 lumina-w-full",
    children: items.map(({
      detail,
      value
    }) => jsxs("div", {
      className: "lumina-flex lumina-gap-2 lumina-flex-row lumina-p-2 lumina-bg-secondary lumina-rounded-lg",
      children: [showIcon && jsx(CornerDownRight, {
        className: iconSmStyles
      }), jsx("span", {
        className: cn('lumina-font-semibold', size === 'sm' ? 'lumina-text-sm' : 'lumina-text-xs'),
        children: detail
      }), jsx("p", {
        className: cn(size === 'sm' ? 'lumina-text-sm' : 'lumina-text-xs'),
        children: value
      })]
    }, detail))
  });
}
function ItemListSimple({
  items
}) {
  return jsx("div", {
    className: "lumina-flex lumina-flex-col lumina-gap-2 lumina-w-full",
    children: items.map(item => jsxs("div", {
      className: "lumina-flex lumina-gap-2 lumina-flex-row lumina-p-2 lumina-bg-secondary lumina-rounded-lg",
      children: [jsx(CornerDownRight, {
        className: iconSmStyles
      }), jsx("span", {
        className: "lumina-font-semibold lumina-text-sm",
        children: item
      })]
    }, item))
  });
}
const InfoFooter = ({
  title
}) => {
  return jsxs("div", {
    className: "lumina-flex lumina-flex-row gap-2 lumina-text-foreground lumina-p-2 lumina-bg-secondary lumina-rounded-lg lumina-items-center",
    children: [jsx(Info, {
      className: iconSmStyles
    }), jsx("p", {
      className: "lumina-text-foreground lumina-text-xs lumina-font-semibold",
      children: title
    })]
  });
};
const CardLink = ({
  title,
  link
}) => {
  return jsx("div", {
    className: "lumina-min-w-10 lumina-min-h-10 lumina-aspect-square",
    children: jsxs(Button, {
      className: "lumina-text-foreground lumina-text-sm lumina-font-semibold lumina-gap-2",
      onClick: () => navigate(link),
      size: "icon",
      children: [jsx(Search, {
        className: "lumina-min-w-4 lumina-max-w-4 lumina-min-h-4 lumina-max-h-4 lumina-text-background"
      }), title && title]
    })
  });
};
const CitationLink = ({
  title,
  link,
  textCutoff: _textCutoff = 15
}) => {
  const truncatedTitle = title ? title.length > _textCutoff ? `${title.substring(0, _textCutoff)}...` : title : '';
  return jsx("div", {
    className: "lumina-min-w-8 lumina-min-h-8 lumina-max-h-8",
    children: jsxs(Button, {
      className: "lumina-text-foreground lumina-text-xs lumina-font-semibold lumina-gap-1",
      onClick: () => navigate(link),
      variant: "outline",
      size: "sm",
      children: [jsx(Link, {
        className: "lumina-text-foreground lumina-min-h-4 lumina-max-h-4 lumina-min-w-4 lumina-max-w-4"
      }), jsx("p", {
        className: "lumina-text-foreground",
        children: truncatedTitle
      })]
    })
  });
};
const ButtonLink = ({
  title,
  link,
  Icon
}) => {
  return jsx("div", {
    className: "lumina-min-h-8 lumina-w-full",
    children: jsxs(Button, {
      className: "lumina-text-foreground lumina-text-xs lumina-font-semibold lumina-gap-1",
      onClick: () => navigate(link),
      variant: "default",
      children: [Icon && jsx(Icon, {
        className: "lumina-text-background lumina-min-h-4 lumina-max-h-4 lumina-min-w-4 lumina-max-w-4"
      }), jsx("p", {
        className: "lumina-text-background",
        children: title
      })]
    })
  });
};

function JsonMessage(_a) {
  var props = __rest(_a, []);
  try {
    const parsedRes = JSON.parse(props.result || '{}');
    if ((parsedRes === null || parsedRes === void 0 ? void 0 : parsedRes.error) || (parsedRes === null || parsedRes === void 0 ? void 0 : parsedRes.userMessage)) {
      return jsx(ErrorCard, {
        title: "Sorry! There was an error.",
        error: parsedRes === null || parsedRes === void 0 ? void 0 : parsedRes.error,
        userMessage: parsedRes === null || parsedRes === void 0 ? void 0 : parsedRes.userMessage
      });
    }
    switch (props.toolName) {
      case 'weather':
        return jsx(WeatherMessage, Object.assign({}, props));
      case 'analyzeBidById':
        return jsx(AnalyzeBidById, Object.assign({}, props));
      case 'fetchBidById':
        return jsx(FetchBidById, Object.assign({}, props));
      case 'getProperties':
        return jsx(GetProperties, Object.assign({}, props));
      case 'getProjects':
        return jsx(GetProjects, Object.assign({}, props));
      case 'getFAQ':
        return jsx(GetFAQ, Object.assign({}, props));
      case 'addAsset':
        return jsx(AddAsset, Object.assign({}, props));
      case 'displayAssets':
        return jsx(DisplayAssets, Object.assign({}, props));
      case 'getVendorContact':
        return jsx(GetVendorContact, Object.assign({}, props));
      case 'getPropertyAssetValue':
        return jsx(GetPropertyAssetValue, Object.assign({}, props));
      case 'reviewAsset':
        return jsx(ReviewAsset, Object.assign({}, props));
      case 'reviewProperty':
        return jsx(ReviewProperty, Object.assign({}, props));
      case 'editAsset':
        return jsx(EditAsset, Object.assign({}, props));
      case 'editProperty':
        return jsx(EditProperty, Object.assign({}, props));
      case 'addSpace':
        return jsx(AddSpace, Object.assign({}, props));
      case 'editTask':
        return jsx(EditTask, Object.assign({}, props));
      case 'editSOP':
        return jsx(EditSOP, Object.assign({}, props));
      case 'addTask':
      case 'addPropertyTask':
        return jsx(AddTask, Object.assign({}, props));
      case 'addProperty':
        return jsx(AddProperty, Object.assign({}, props));
      case 'estimateProperty':
        return jsx(EstimateProperty, Object.assign({}, props));
      case 'serviceRequest':
        return jsx(ServiceRequest, Object.assign({}, props));
      case 'getSupport':
        return jsx(GetSupport, Object.assign({}, props));
      case 'getServiceRequests':
        return jsx(GetServiceRequests, Object.assign({}, props));
      case 'getAsset':
      case 'getProperty':
        return jsx(GetItem, Object.assign({}, props));
      case 'addSOP':
        return jsx(AddSOP, Object.assign({}, props));
      case 'findSOPs':
        return jsx(FindSOPs, Object.assign({}, props));
      case 'refreshAssets':
        return jsx(RefreshAssets, Object.assign({}, props));
      case 'refreshTasks':
        return jsx(RefreshTasks, Object.assign({}, props));
      case 'research':
        return jsx(Research, Object.assign({}, props));
      case 'estimateAsset':
        return jsx(EstimateAsset, Object.assign({}, props));
      case 'taskSummary':
        return jsx(TaskSummary, Object.assign({}, props));
      default:
        throw new Error(`No tool call template found. ${JSON.stringify(props)}`);
    }
  } catch (error) {
    console.error(`Error parsing JSON message. \n${JSON.stringify(props)}\n${error instanceof Error ? error.message : JSON.stringify(error)}`);
    return jsx(ErrorCard, {
      title: "Sorry! There was an error.",
      error: error instanceof Error ? error.message : JSON.stringify(error)
    });
  }
}

const BasicMessage = /*#__PURE__*/React__default.memo(({
  message,
  showAvatar: _showAvatar = true
}) => {
  var _a;
  const isAssistant = (message === null || message === void 0 ? void 0 : message.role) === Role.assistant;
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), 50);
    return () => clearTimeout(timer);
  }, []);
  const content = message === null || message === void 0 ? void 0 : message.content;
  if (content === null || content === void 0 ? void 0 : content.startsWith(INVISIBLE)) {
    return null;
  }
  const messageAnimationClass = cn('lumina-transform lumina-transition-all lumina-duration-300 lumina-ease-out', isVisible ? 'lumina-opacity-100 lumina-translate-y-0' : isAssistant ? 'lumina-opacity-0 -lumina-translate-y-4' : 'lumina-opacity-0 lumina-translate-y-4');
  return jsx("div", {
    className: cn('lumina-w-full lumina-flex', isAssistant ? 'lumina-justify-start' : 'lumina-justify-end', messageAnimationClass),
    children: jsxs("div", {
      className: cn('lumina-flex lumina-items-start lumina-gap-2 lumina-w-full lumina-max-w-3xl', isAssistant ? 'lumina-flex-row' : 'lumina-flex-row-reverse'),
      children: [isAssistant && _showAvatar && jsx(ChartNoAxesGantt, {
        className: "lumina-text-foreground lumina-min-w-6 lumina-min-h-6 lumina-mt-2"
      }), jsxs("div", {
        className: "lumina-flex lumina-flex-col lumina-gap-2 lumina-max-w-full",
        children: [(_a = message === null || message === void 0 ? void 0 : message.toolInvocations) === null || _a === void 0 ? void 0 : _a.map((toolInvocation, index) => jsx("div", {
          className: "lumina-pl-2",
          children: jsx(JsonMessage, {
            toolName: toolInvocation.toolName,
            result: toolInvocation.result
          })
        }, toolInvocation.id)), content && jsx("div", {
          className: cn('lumina-py-2 lumina-px-4 lumina-rounded-2xl', isAssistant ? 'lumina-bg-secondary/60' : 'lumina-bg-foreground/90'),
          children: jsx(Markdown, {
            remarkPlugins: [remarkGfm],
            className: cn('lumina-whitespace-normal lumina-break-words', isAssistant ? 'lumina-text-foreground' : 'lumina-text-background'),
            children: content
          })
        })]
      })]
    })
  });
});

const EditItemSchema = z.object({
  id: z.string(),
  detail: z.string(),
  value: z.union([z.string(), z.number()]).nullish(),
  reason: z.string().nullish()
});
const TEditItem = z.object({
  detail: z.string().nullish().describe("The detail of the attribute"),
  value: z.string().nullish()
});
const PatchSchema = z.object({
  op: z.string(),
  value: z.any(),
  path: z.string()
});

function WeatherMessage({
  result
}) {
  return jsxs(Card, {
    className: "lumina-flex lumina-flex-col lumina-gap-3 lumina-w-full lumina-max-w-xl lumina-bg-background",
    children: [jsxs("div", {
      className: "lumina-flex lumina-flex-row lumina-justify-between lumina-items-center lumina-w-full",
      children: [jsxs("div", {
        className: "lumina-flex lumina-flex-row lumina-gap-3 lumina-items-center",
        children: [jsx(CloudSunRain, {
          className: "lumina-size-10 lumina-bg-orange-4000 lumina-text-accent lumina-p-2 lumina-rounded-2xl"
        }), jsx("p", {
          className: "lumina-text-xl lumina-font-semibold lumina-text-foreground",
          children: "Weather forecast"
        })]
      }), jsx("div", {
        className: "lumina-flex lumina-flex-row lumina-gap-3 lumina-items-center lumina-animate-pulse-and-rotate",
        children: jsx(Sun, {
          className: "lumina-text-orange-400",
          size: 25
        })
      })]
    }), jsx(Separator, {}), jsx("p", {
      className: "lumina-text-foreground",
      children: result
    })]
  });
}

function FetchBidById({
  result
}) {
  return jsxs(Card, {
    className: "lumina-flex lumina-flex-col lumina-gap-3 lumina-w-full sm:lumina-min-w-72 lumina-bg-background",
    children: [jsxs("div", {
      className: "lumina-flex lumina-flex-row lumina-justify-between lumina-items-center",
      children: [jsxs("div", {
        className: "lumina-flex lumina-flex-row lumina-gap-3 lumina-items-center",
        children: [jsx(Search, {
          className: "lumina-size-10 lumina-bg-accent lumina-text-background lumina-p-2 lumina-rounded-2xl"
        }), jsx("p", {
          className: "lumina-text-xl lumina-font-semibold lumina-text-foreground",
          children: "Fetching Bid"
        })]
      }), jsx(Loader$1, {})]
    }), jsx(Separator, {}), jsx("p", {
      className: "lumina-text-foreground",
      children: result
    }), jsx(Skeleton, {
      className: "lumina-w-full lumina-h-32"
    })]
  });
}

var $$4 = _export;
var DESCRIPTORS$1 = descriptors;
var globalThis$1 = globalThis_1;
var uncurryThis = functionUncurryThis;
var hasOwn = hasOwnProperty_1;
var isCallable = isCallable$q;
var isPrototypeOf = objectIsPrototypeOf;
var toString = toString$a;
var defineBuiltInAccessor = defineBuiltInAccessor$3;
var copyConstructorProperties = copyConstructorProperties$3;

var NativeSymbol = globalThis$1.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS$1 && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      // eslint-disable-next-line sonarjs/inconsistent-function-call -- ok
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$4({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

const assetSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string()
});
function AddAsset({
  result
}) {
  try {
    if (!result) {
      return jsx(LoadingCard, {
        Icon: Box,
        title: "Adding Asset"
      });
    }
    const asset = assetSchema.parse(JSON.parse(result));
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        Icon: Box,
        title: "Asset Added",
        link: `/assets/${asset.id}`
      }), jsxs(CardContent, {
        children: [jsx(CardItem, {
          title: asset.name,
          Icon: FolderPen,
          bold: true
        }), jsx(CardItem, {
          title: asset.description,
          Icon: Sparkles,
          size: "sm"
        })]
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: "Error adding asset",
        error: error.message
      });
    }
    return jsx(ErrorCard, {
      title: "Error adding asset"
    });
  }
}

const AssetSchema = z.object({
  resource: z.object({
    id: z.string(),
    name: z.string().nullish(),
    description: z.string().nullish(),
    project: z.string().nullish(),
    property: z.string().nullish()
  })
});
const AssetsSchema = z.object({
  entries: z.array(AssetSchema)
});
/**
 *
 * @param result - A json object containing the user's properties
 * @returns
 */
function DisplayAssets({
  result
}) {
  try {
    if (!result) {
      return jsx(LoadingCard, {
        title: "Gathering Assets",
        Icon: PackageOpen
      });
    }
    const assets = AssetsSchema.parse(JSON.parse(result));
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: "Your Assets",
        Icon: PackageOpen
      }), assets.entries.length > 0 && jsx(CardContent, {
        children: jsx("div", {
          className: "lumina-w-full lumina-max-h-64 lumina-flex lumina-flex-col lumina-gap-1 lumina-overflow-y-auto",
          children: assets === null || assets === void 0 ? void 0 : assets.entries.map((asset, index) => jsxs(React__default.Fragment, {
            children: [jsx(CardItem, {
              title: asset.resource.name || "Unnamed",
              Icon: Package,
              bold: true
            }), jsx(CardItem, {
              title: asset.resource.description || "No description",
              Icon: Text
            }), index < assets.entries.length - 1 && jsx(Separator, {})]
          }, asset.resource.id))
        })
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      jsx(ErrorCard, {
        title: "Error getting user assets",
        error: error.message
      });
    }
    return jsx(ErrorCard, {
      title: "Error getting user assets",
      error: JSON.stringify(error)
    });
  }
}

const VendorSchema = z.object({
  vendorName: z.string(),
  vendorPhone: z.string(),
  vendorEmail: z.string()
});
/**
 *
 * @param result - A json object containing the vendors properties
 * @returns
 */
function GetVendorContact({
  result
}) {
  try {
    if (!result) {
      return jsx(LoadingCard, {
        title: "Gathering Vendor Details",
        Icon: PhoneCall
      });
    }
    const {
      vendorName,
      vendorPhone,
      vendorEmail
    } = VendorSchema.parse(JSON.parse(result));
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: vendorName,
        Icon: Phone
      }), jsxs(CardContent, {
        children: [vendorPhone && jsx(CardItem, {
          title: vendorPhone,
          Icon: Phone,
          bold: true
        }), vendorEmail && jsx(CardItem, {
          title: vendorEmail,
          Icon: Mail,
          bold: true
        })]
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: "Error getting vendor contact",
        error: error.message
      });
    }
    return jsx(ErrorCard, {
      title: "Error getting vendor contact"
    });
  }
}

const PropertiesSchema = z.array(z.object({
  propertyId: z.string(),
  title: z.string(),
  address: z.array(z.object({
    street: z.string().nullish(),
    city: z.string().nullish(),
    state: z.string().nullish()
  }).nullish())
}));
/**
 *
 * @param result - A json object containing the user's properties
 * @returns
 */
function GetProperties({
  result
}) {
  try {
    if (!result) {
      return jsx(LoadingCard, {
        title: "Your properties",
        Icon: HousePlus
      });
    }
    const entries = PropertiesSchema.parse(JSON.parse(result));
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: "Your properties",
        Icon: HousePlus
      }), jsxs(CardContent, {
        children: [entries === null || entries === void 0 ? void 0 : entries.map(entry => {
          const addr = entry === null || entry === void 0 ? void 0 : entry.address[0];
          return jsxs("div", {
            className: "lumina-flex lumina-flex-row lumina-gap-2 lumina-items-center lumina-w-full",
            children: [jsx(MapPinHouse, {
              className: iconSmStyles
            }), jsxs("div", {
              children: [jsx("p", {
                className: "lumina-text-foreground lumina-font-medium",
                children: entry === null || entry === void 0 ? void 0 : entry.title
              }), jsx("p", {
                className: "lumina-text-foreground lumina-text-xs",
                children: addr ? `${addr.street || ""} ${addr.city || ""} ${addr.city || ""} ${addr.state || ""}` : "No address"
              })]
            })]
          }, entry.propertyId);
        }), (entries === null || entries === void 0 ? void 0 : entries.length) === 0 && jsx("p", {
          className: "lumina-text-foreground",
          children: "End of properties."
        })]
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: "Error getting user properties",
        error: error.message
      });
    }
    return jsx(ErrorCard, {
      title: "Error getting user properties"
    });
  }
}

const ProjectsSchema = z.array(z.object({
  name: z.string(),
  projectId: z.string()
}));
/**
 *
 * @param result - A json object containing the user's properties
 * @returns
 */
function GetProjects({
  result
}) {
  try {
    if (!result) {
      return jsx(LoadingCard, {
        title: "Your projects",
        Icon: Folders
      });
    }
    const props = ProjectsSchema.parse(JSON.parse(result));
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: "Your projects",
        Icon: Folders
      }), jsxs(CardContent, {
        children: [props.length === 0 && jsx("p", {
          className: "lumina-text-foreground",
          children: "You have no projects. Add a project to get started."
        }), props.map(entry => {
          return jsx(CardItem, {
            title: entry.name,
            Icon: ScrollText
          }, entry.projectId);
        })]
      })]
    });
  } catch (error) {
    if (error instanceof Error) return jsx(ErrorCard, {
      title: "Error getting user projects",
      error: error.message
    });
    return jsx(ErrorCard, {
      title: "Error getting user projects"
    });
  }
}

const AssetModSchema$1 = z.object({
  id: z.string(),
  title: z.string(),
  additionalInfo: z.array(EditItemSchema)
});
/**
 *
 * @param result - A json object containing the user's properties
 * @returns
 */
function ReviewAsset({
  result
}) {
  var _a;
  try {
    if (!result) {
      return jsx(LoadingCard, {
        title: "Reviewing Asset",
        Icon: FolderSearch
      });
    }
    const mod = AssetModSchema$1.parse(JSON.parse(result));
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        Icon: FolderSearch,
        title: `Suggested Edits for ${mod === null || mod === void 0 ? void 0 : mod.title}`,
        link: `/assets/${mod === null || mod === void 0 ? void 0 : mod.id}`
      }), jsxs(CardContent, {
        children: [jsx("div", {
          className: "lumina-flex lumina-flex-col lumina-gap-1 lumina-w-full",
          children: jsx(ItemList, {
            items: mod === null || mod === void 0 ? void 0 : mod.additionalInfo
          })
        }), ((_a = mod === null || mod === void 0 ? void 0 : mod.additionalInfo) === null || _a === void 0 ? void 0 : _a.length) === 0 && jsx(InfoFooter, {
          title: "No edits needed"
        })]
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: 'Error reviewing asset',
        error: error.message
      });
    }
    return jsx(ErrorCard, {
      title: "Error reviewing asset"
    });
  }
}

const AddTask = ({
  result
}) => {
  if (!result) {
    return jsx(LoadingCard, {
      title: "Generating Task",
      Icon: Calendar
    });
  }
  const parsedResult = JSON.parse(result);
  if ((parsedResult === null || parsedResult === void 0 ? void 0 : parsedResult.error) || (parsedResult === null || parsedResult === void 0 ? void 0 : parsedResult.userMessage)) {
    return jsx(ErrorCard, {
      title: parsedResult === null || parsedResult === void 0 ? void 0 : parsedResult.error,
      userMessage: parsedResult === null || parsedResult === void 0 ? void 0 : parsedResult.userMessage
    });
  }
  const TaskSchema = z.object({
    name: z.string(),
    id: z.string().uuid(),
    startDate: z.string(),
    recurrence: z.string().nullish(),
    priority: z.string(),
    sops: z.array(z.object({
      id: z.string().uuid(),
      name: z.string()
    })),
    timezone: z.string()
  });
  const task = TaskSchema.parse(parsedResult);
  return jsxs(CardWrapper, {
    children: [jsx(CardHeader, {
      title: task.name,
      Icon: Calendar,
      link: `/tasks/${task.id}`
    }), jsxs(CardContent, {
      children: [jsx(CardItem, {
        title: `${formatDate(task.startDate)} ${task.timezone}`,
        Icon: Clock,
        size: "sm"
      }), (task === null || task === void 0 ? void 0 : task.recurrence) && jsx(CardItem, {
        title: getRecurrenceText(task.recurrence),
        Icon: Repeat,
        size: "sm"
      }), jsx(CardItem, {
        title: `Priority: ${task.priority}`,
        Icon: AlertCircle,
        size: "sm"
      }), jsx("div", {
        className: "lumina-flex lumina-flex-col lumina-gap-2 lumina-w-full",
        children: task.sops.map(sop => jsxs("div", {
          className: "lumina-flex lumina-gap-2 lumina-flex-row lumina-p-2 lumina-bg-secondary lumina-rounded-lg",
          children: [jsx(Check, {
            className: iconSmStyles
          }), jsx("span", {
            className: "lumina-text-sm lumina-font-semibold",
            children: sop.name
          })]
        }, sop.id))
      })]
    })]
  });
};

const AddPropertySchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  address: z.array(z.object({
    street: z.string().nullish(),
    city: z.string().nullish(),
    state: z.string().nullish(),
    zip: z.string().nullish()
  }))
});
const AddProperty = ({
  result
}) => {
  var _a, _b, _c, _d;
  if (!result) {
    return jsx(LoadingCard, {
      Icon: House,
      title: "Generating Property"
    });
  }
  try {
    const property = AddPropertySchema.parse(JSON.parse(result));
    const street = (_a = property === null || property === void 0 ? void 0 : property.address[0]) === null || _a === void 0 ? void 0 : _a.street;
    const city = (_b = property === null || property === void 0 ? void 0 : property.address[0]) === null || _b === void 0 ? void 0 : _b.city;
    const state = (_c = property === null || property === void 0 ? void 0 : property.address[0]) === null || _c === void 0 ? void 0 : _c.state;
    const zip = (_d = property === null || property === void 0 ? void 0 : property.address[0]) === null || _d === void 0 ? void 0 : _d.zip;
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: property.title,
        Icon: House,
        link: `/properties/${property.id}`
      }), jsx(CardContent, {
        children: jsxs("div", {
          className: "lumina-flex lumina-flex-row gap-2 lumina-items-center",
          children: [jsx(MapPinHouse, {
            className: iconStyles
          }), jsxs("span", {
            className: "lumina-text-sm",
            children: [street, city && `, ${city}`, state && `, ${state}`, " ", zip]
          })]
        })
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: "Error creating property",
        error: error.message
      });
    }
    return jsx(ErrorCard, {
      title: "Error creating property"
    });
  }
};

const AssetModSchema = z.object({
  id: z.string(),
  title: z.string(),
  additionalInfo: z.array(EditItemSchema)
});
/**
 *
 * @param result - A json object containing the user's properties
 * @returns
 */
function EditAsset({
  result
}) {
  var _a;
  try {
    if (!result) {
      return jsx(LoadingCard, {
        title: "Editing Asset",
        Icon: FolderSearch
      });
    }
    const mod = AssetModSchema.parse(JSON.parse(result));
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        Icon: FolderSearch,
        title: `${mod === null || mod === void 0 ? void 0 : mod.title} Edited`,
        link: `/assets/${mod.id}`
      }), jsxs(CardContent, {
        children: [jsx("div", {
          className: "lumina-flex lumina-flex-col lumina-gap-1 lumina-w-full",
          children: jsx(ItemList, {
            items: mod === null || mod === void 0 ? void 0 : mod.additionalInfo
          })
        }), ((_a = mod === null || mod === void 0 ? void 0 : mod.additionalInfo) === null || _a === void 0 ? void 0 : _a.length) === 0 && jsx(CardFooter, {
          title: "No edits made"
        })]
      })]
    });
  } catch (error) {
    console.error(`Error editing asset: ${JSON.stringify(error)}`);
    return jsx(ErrorCard, {
      title: "Error editing asset",
      error: JSON.stringify(error)
    });
  }
}

const EstimatePropertySchema = z.object({
  id: z.string(),
  title: z.string(),
  patch: z.array(PatchSchema)
});
const EstimateProperty = ({
  result
}) => {
  if (!result) {
    return jsx(LoadingCard, {
      Icon: House,
      title: "Estimating Property"
    });
  }
  try {
    const property = EstimatePropertySchema.parse(JSON.parse(result));
    const renderPropertyDetail = (icon, label, value) => jsxs("div", {
      className: "lumina-flex lumina-flex-row lumina-gap-2 lumina-items-center",
      children: [icon, jsx("span", {
        className: "lumina-text-sm lumina-font-medium",
        children: label
      }), jsx("span", {
        className: "lumina-text-sm",
        children: value
      })]
    });
    const getPropertyValue = path => {
      var _a, _b, _c, _d, _e;
      const patchItem = (_a = property === null || property === void 0 ? void 0 : property.patch) === null || _a === void 0 ? void 0 : _a.find(item => item.path === path);
      return (_e = (_c = (_b = patchItem === null || patchItem === void 0 ? void 0 : patchItem.value) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : (_d = patchItem === null || patchItem === void 0 ? void 0 : patchItem.value) === null || _d === void 0 ? void 0 : _d.price) !== null && _e !== void 0 ? _e : patchItem === null || patchItem === void 0 ? void 0 : patchItem.value;
    };
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: property.title || "Property Estimate",
        Icon: House,
        link: `/properties/${property.id}`
      }), jsx(CardContent, {
        children: getPropertyValue("/estimatedValue") && renderPropertyDetail(jsx(CircleDollarSign, {
          className: iconStyles
        }), "Estimated Value", getPropertyValue("/estimatedValue"))
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: "Failed to estimate property.",
        error: error.message
      });
    }
    return jsx(ErrorCard, {
      title: "Failed to estimate property."
    });
  }
};

const ServiceRequestSchema$1 = z.object({
  categoryCode: z.string(),
  providerCode: z.string(),
  notes: z.string()
});
function ServiceRequest({
  result
}) {
  var _a;
  try {
    if (typeof result !== 'string' || result.trim() === '') {
      return jsx(LoadingCard, {
        title: "Requesting Service",
        Icon: PhoneOutgoing
      });
    }
    const req = ServiceRequestSchema$1.parse(JSON.parse(result));
    const category = affiliatesJSON === null || affiliatesJSON === void 0 ? void 0 : affiliatesJSON[req.categoryCode];
    const provider = (_a = category === null || category === void 0 ? void 0 : category.providers) === null || _a === void 0 ? void 0 : _a.find(p => p.code === req.providerCode);
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: "Service Requested",
        Icon: PhoneIncoming
      }), jsxs(CardContent, {
        children: [jsxs("div", {
          className: "lumina-grid lumina-grid-cols-2 lumina-gap-2 lumina-w-full",
          children: [jsx(CardItem, {
            title: (category === null || category === void 0 ? void 0 : category.name) || 'Category',
            Icon: ConciergeBell,
            filled: true
          }), jsx(CardItem, {
            title: (provider === null || provider === void 0 ? void 0 : provider.name) || 'Unknown Provider',
            Icon: Store,
            filled: true
          })]
        }), jsx(CardItem, {
          title: req.notes,
          Icon: Notebook,
          size: "sm",
          filled: true
        })]
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: "Error requesting service",
        error: error.message
      });
    }
    console.error(error);
    return jsx(ErrorCard, {
      title: "Error requesting service"
    });
  }
}

const StepSchema = z.object({
  position: z.number(),
  description: z.string()
});
const SOPSchema$1 = z.object({
  resource: z.object({
    name: z.string(),
    id: z.string().uuid(),
    description: z.string().nullish(),
    steps: z.array(StepSchema)
  })
});
/**
 *
 * @param result - A json object containing the user's properties
 * @returns
 */
function AddSOP({
  result
}) {
  try {
    if (!result) {
      return jsx(LoadingCard, {
        Icon: Route,
        title: "Adding SOP"
      });
    }
    const sop = SOPSchema$1.parse(JSON.parse(result)).resource;
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: `${sop.name} Added`,
        Icon: Route,
        link: `/sops/${sop.id}`
      }), jsxs(CardContent, {
        children: [jsx(CardItem, {
          title: sop.description || "No description provided",
          Icon: NotebookText
        }), jsxs("div", {
          className: "lumina-flex lumina-flex-col gap-2 lumina-text-foreground lumina-p-2 lumina-w-full",
          children: [jsx("p", {
            className: "lumina-text-foreground lumina-text-lg lumina-font-semibold",
            children: "Steps"
          }), sop.steps.map(step => jsxs("div", {
            className: "lumina-flex lumina-gap-2 lumina-flex-row",
            children: [jsx(SquareCheck, {
              className: iconSmStyles
            }), jsxs("p", {
              className: "lumina-text-foreground lumina-text-xs",
              children: [jsx("span", {
                className: "lumina-font-bold",
                children: step.position
              }), ' ', step.description]
            })]
          }, step.position))]
        })]
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: "Error Adding SOP",
        error: error.message
      });
    }
    return jsx(ErrorCard, {
      title: "Error adding SOP"
    });
  }
}

const RefreshAssets = ({
  toolName,
  result
}) => {
  if (!result) {
    return jsx(LoadingCard, {
      title: "Refreshing Asset Memory",
      Icon: Sparkles
    });
  }
  return jsx(CardWrapper, {
    children: jsx(CardHeader, {
      title: "Asset Memory Refreshed",
      Icon: Sparkles,
      size: 'sm'
    })
  });
};

const RefreshTasks = ({
  toolName,
  result
}) => {
  if (!result) {
    return jsx(LoadingCard, {
      Icon: Sparkles,
      title: "Refreshing Task Memory"
    });
  }
  return jsx(CardWrapper, {
    children: jsx(CardHeader, {
      title: "Task Memory Refreshed",
      Icon: Sparkles,
      size: 'sm'
    })
  });
};

const Research = ({
  toolName,
  result
}) => {
  if (!result) {
    return jsx(LoadingCard, {
      Icon: Microscope,
      title: "Researching"
    });
  }
  const ResearchSchema = z.array(z.object({
    detail: z.string(),
    value: z.string()
  }));
  try {
    const research = ResearchSchema.parse(JSON.parse(result));
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: "Researched",
        Icon: Microscope,
        size: "sm"
      }), jsx(CardContent, {
        children: jsx(ItemList, {
          items: research,
          size: "xs"
        })
      })]
    });
  } catch (e) {
    if (e instanceof Error) {
      return jsx(ErrorCard, {
        title: "Error researching",
        error: e.message
      });
    }
    return jsx(ErrorCard, {
      title: "Error researching"
    });
  }
};

const EstimateSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  estimatedValue: z.number()
});
const EstimateAsset = ({
  toolName,
  result
}) => {
  if (!result) {
    return jsx(LoadingCard, {
      Icon: Package,
      title: "Estimating Asset Value"
    });
  }
  try {
    const estimate = EstimateSchema.parse(JSON.parse(result));
    const formattedValue = estimate.estimatedValue.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: `${estimate.title} Estimate` || 'Asset Estimate',
        Icon: Package,
        link: `/assets/${estimate.id}`
      }), jsx(CardContent, {
        children: jsx(CardItem, {
          title: formattedValue,
          Icon: CircleDollarSign
        })
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: "Error estimating asset",
        error: error.message
      });
    }
    return jsx(ErrorCard, {
      title: 'Failed to estimate asset.'
    });
  }
};

const TaskItem = z.object({
  id: z.string(),
  name: z.string(),
  startDate: z.string()
});
const TaskSummarySchema = z.object({
  tasksToday: z.array(TaskItem),
  upcomingTasks: z.array(TaskItem),
  overdueTasks: z.array(TaskItem)
});
const TaskSummary = ({
  toolName,
  result
}) => {
  if (!result) {
    return jsx(LoadingCard, {
      Icon: Calendar,
      title: "Loading Tasks"
    });
  }
  try {
    const tasks = TaskSummarySchema.parse(JSON.parse(result));
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: "Tasks Today"
      }), jsxs(CardContent, {
        children: [tasks.tasksToday.length === 0 && jsx("p", {
          className: "lumina-text-xs",
          children: "No Tasks For Today"
        }), tasks.tasksToday.map(task => jsx(CardItem, {
          title: `${formatDate(task.startDate)} - ${task.name}`,
          Icon: AlarmClockCheck
        }, task.id))]
      }), jsx(CardHeader, {
        title: "Next Month"
      }), jsxs(CardContent, {
        children: [tasks.upcomingTasks.length === 0 && jsx("p", {
          className: "lumina-text-xs",
          children: "No Upcoming Tasks"
        }), tasks.upcomingTasks.map(task => jsx(CardItem, {
          title: `${formatDate(task.startDate)} - ${task.name}`,
          Icon: AlarmClockCheck
        }, task.id))]
      }), jsx(CardHeader, {
        title: "Past Month"
      }), jsxs(CardContent, {
        children: [tasks.overdueTasks.length === 0 && jsx("p", {
          className: "lumina-text-xs",
          children: "No Overdue Tasks"
        }), tasks.overdueTasks.map(task => jsx(CardItem, {
          title: `${formatDate(task.startDate)} - ${task.name}`,
          Icon: AlarmClockCheck
        }, task.id))]
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: "Error getting tasks",
        error: error.message
      });
    }
    return jsx(ErrorCard, {
      title: "Error getting tasks"
    });
  }
};

const ReviewSchema$1 = z.object({
  id: z.string().uuid(),
  title: z.string(),
  generalInfo: z.object({
    lotSize: z.number().nullish(),
    bedrooms: z.number().nullish(),
    bathrooms: z.number().nullish(),
    area: z.number().nullish()
  }).nullish(),
  additionalInfo: z.array(EditItemSchema)
});
/**
 * Displays asset modification patches from the result JSON object.
 * @param result - A JSON string containing the user's properties and modifications.
 * @returns JSX rendering the modifications or an error/loading state.
 */
function ReviewProperty({
  result
}) {
  var _a, _b;
  try {
    if (!result) {
      return jsx(LoadingCard, {
        title: "Reviewing Property",
        Icon: House
      });
    }
    const rev = ReviewSchema$1.parse(JSON.parse(result));
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: `${rev === null || rev === void 0 ? void 0 : rev.title} Suggested Edits`,
        Icon: House,
        link: `/properties/${rev.id}`
      }), jsxs(CardContent, {
        children: [((_a = rev === null || rev === void 0 ? void 0 : rev.additionalInfo) === null || _a === void 0 ? void 0 : _a.length) > 0 && jsx(ItemList, {
          items: rev === null || rev === void 0 ? void 0 : rev.additionalInfo,
          size: "xs"
        }), ((_b = rev === null || rev === void 0 ? void 0 : rev.additionalInfo) === null || _b === void 0 ? void 0 : _b.length) === 0 && jsx(InfoFooter, {
          title: "No edits needed"
        })]
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: "Error reviewing property",
        error: error.message
      });
    }
    return jsx(ErrorCard, {
      title: "Error reviewing property"
    });
  }
}

const ReviewSchema = z.object({
  id: z.string(),
  title: z.string(),
  additionalInfo: z.array(EditItemSchema)
});
/**
 * Displays asset modification patches from the result JSON object.
 * @param result - A JSON string containing the user's properties and modifications.
 * @returns JSX rendering the modifications or an error/loading state.
 */
function EditProperty({
  result
}) {
  var _a;
  try {
    if (!result) {
      return jsx(LoadingCard, {
        title: "Editing Property",
        Icon: House
      });
    }
    const rev = ReviewSchema.parse(JSON.parse(result));
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: `${rev === null || rev === void 0 ? void 0 : rev.title} Edited`,
        Icon: House,
        link: `/properties/${rev.id}`
      }), jsx(CardContent, {
        children: ((_a = rev === null || rev === void 0 ? void 0 : rev.additionalInfo) === null || _a === void 0 ? void 0 : _a.length) > 0 ? jsx(ItemList, {
          items: rev.additionalInfo,
          size: "xs"
        }) : jsx(InfoFooter, {
          title: "No edits"
        })
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: "Error editing property",
        error: error.message
      });
    }
    return jsx(ErrorCard, {
      title: "Error editing property"
    });
  }
}

const SOPItemSchema = z.object({
  id: z.string(),
  name: z.string()
});
const SOPSchema = z.object({
  sops: z.array(SOPItemSchema)
});
/**
 *
 * @param result - A json object containing the user's properties
 * @returns
 */
function FindSOPs({
  result
}) {
  try {
    if (!result) {
      return jsx(LoadingCard, {
        Icon: Route,
        title: "Finding Related SOPs"
      });
    }
    const sops = SOPSchema.parse(JSON.parse(result)).sops;
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: "Related SOPs",
        Icon: Route
      }), jsxs(CardContent, {
        children: [sops.map(sop => jsxs("div", {
          className: "lumina-flex lumina-gap-2 lumina-flex-row lumina-justify-between lumina-items-center",
          children: [jsx(CardItem, {
            title: sop.name,
            Icon: Notebook
          }, sop.id), jsx(CardLink, {
            title: "",
            link: `/sops/${sop.id}`
          })]
        }, sop.id)), sops.length === 0 && jsx(InfoFooter, {
          title: "No related SOPs found"
        })]
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: 'Error finding SOPs',
        error: error.message
      });
    }
    return jsx(ErrorCard, {
      title: 'Error finding SOPs'
    });
  }
}

const TaskSOPSchema = z.object({
  id: z.string(),
  name: z.string()
});
const ParsedTaskSchema = z.object({
  id: z.string().uuid(),
  startDate: z.string(),
  name: z.string(),
  sops: z.array(TaskSOPSchema),
  timezone: z.string(),
  recurrence: z.string().nullish()
});
const EditTask = ({
  toolName,
  result
}) => {
  if (!result) {
    return jsx(LoadingCard, {
      title: "Editing Task",
      Icon: Calendar
    });
  }
  try {
    const task = ParsedTaskSchema.parse(JSON.parse(result));
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: task.name,
        Icon: Calendar,
        link: `/tasks/${task.id}`
      }), jsxs(CardContent, {
        children: [jsx(CardItem, {
          title: `${formatDate(task.startDate)} ${task.timezone}`,
          Icon: Clock,
          size: "sm"
        }), (task === null || task === void 0 ? void 0 : task.recurrence) && jsx(CardItem, {
          title: getRecurrenceText(task.recurrence),
          Icon: Repeat,
          size: "sm"
        }), jsx(CardItem, {
          title: "SOPs Added to Task",
          Icon: CopyPlus,
          bold: true
        }), jsx("div", {
          className: "lumina-flex lumina-flex-col lumina-gap-2 lumina-w-full",
          children: task.sops.length === 0 ? jsx("p", {
            className: "lumina-text-sm lumina-text-gray-500",
            children: "No SOPs added to this task"
          }) : task.sops.map(sop => jsxs("div", {
            className: "lumina-flex lumina-gap-2 lumina-flex-row lumina-p-2 lumina-bg-secondary lumina-rounded-lg",
            children: [jsx(Check, {
              className: iconSmStyles
            }), jsx("span", {
              className: "lumina-text-sm lumina-font-semibold",
              children: sop.name
            })]
          }, sop.id))
        })]
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: "Error editing task",
        error: error.message
      });
    }
    return jsx(ErrorCard, {
      title: "Error editing task"
    });
  }
};

const ServiceRequestSchema = z.array(z.object({
  categoryCode: z.string(),
  providerCode: z.string(),
  status: z.string(),
  notes: z.string(),
  dateRequested: z.string()
}));
function GetServiceRequests({
  result
}) {
  try {
    if (typeof result !== 'string' || result.trim() === '') {
      return jsx(LoadingCard, {
        title: "Getting Requested Services",
        Icon: PhoneOutgoing
      });
    }
    const serviceReq = ServiceRequestSchema.parse(JSON.parse(result));
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: "Requested Services",
        Icon: PhoneIncoming
      }), jsxs(CardContent, {
        children: [serviceReq.map((req, index) => {
          var _a;
          const category = affiliatesJSON === null || affiliatesJSON === void 0 ? void 0 : affiliatesJSON[req.categoryCode];
          const provider = (_a = category === null || category === void 0 ? void 0 : category.providers) === null || _a === void 0 ? void 0 : _a.find(p => p.code === req.providerCode);
          return jsxs("div", {
            className: "lumina-flex lumina-flex-col lumina-gap-2 lumina-p-2 lumina-rounded-lg lumina-bg-secondary",
            children: [jsxs("div", {
              className: "lumina-grid lumina-grid-cols-3 lumina-gap-2 lumina-w-full",
              children: [jsx("div", {
                className: "lumina-flex lumina-items-center",
                children: jsx(CardItem, {
                  title: (provider === null || provider === void 0 ? void 0 : provider.name) || 'Unknown Provider',
                  Icon: Store
                })
              }), jsx("div", {
                className: "lumina-flex lumina-items-center",
                children: jsx(CardItem, {
                  title: req.status,
                  Icon: Loader$2
                })
              }), jsx("div", {
                className: "lumina-flex lumina-items-center",
                children: jsx(CardItem, {
                  title: new Date(req.dateRequested).toLocaleDateString(),
                  Icon: Calendar
                })
              })]
            }), jsx(CardItem, {
              title: req.notes,
              Icon: Notebook,
              size: "sm"
            })]
          }, index);
        }), jsx(InfoFooter, {
          title: "Note that only requests for 1 month prior are displayed"
        })]
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: "Error requesting service",
        error: error.message
      });
    }
    console.error(error);
    return jsx(ErrorCard, {
      title: "Error requesting service"
    });
  }
}

var DESCRIPTORS = descriptors;
var isArray$2 = isArray$4;

var $TypeError$1 = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray$2(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw new $TypeError$1('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

var doesNotExceedSafeInteger$2 = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};

var $$3 = _export;
var toObject$1 = toObject$6;
var lengthOfArrayLike$2 = lengthOfArrayLike$5;
var setArrayLength = arraySetLength;
var doesNotExceedSafeInteger$1 = doesNotExceedSafeInteger$2;
var fails = fails$p;

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$$3({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject$1(this);
    var len = lengthOfArrayLike$2(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger$1(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});

const GetItem = ({
  result
}) => {
  var _a;
  try {
    if (!result) {
      return jsx(LoadingCard, {
        title: "Getting Item"
      });
    }
    const ItemSchema = z.object({
      item: z.object({
        name: z.string(),
        id: z.string().uuid(),
        type: z.enum(['asset', 'property'])
      }),
      tasks: z.array(z.object({
        name: z.string(),
        id: z.string().uuid(),
        startDate: z.string(),
        recurrence: z.string().nullish()
      })),
      suggestedTasks: z.array(z.string()),
      additionalInfo: z.array(TEditItem).default([]),
      value: z.string().nullish()
    });
    const item = ItemSchema.parse(JSON.parse(result));
    const overviewItems = [];
    const targetDetails = ['area', 'bathroom', 'bedroom', 'lotSize', 'brand', 'MPG', 'Exterior Color', 'Travel Distance (miles)', 'Year Made'];
    for (const info of item.additionalInfo) {
      if (info.detail && targetDetails.includes(info.detail)) {
        overviewItems.push({
          detail: info.detail,
          value: info.value
        });
      }
    }
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        title: item.item.name,
        link: `/${item.item.type === 'asset' ? 'assets' : 'properties'}/${item.item.id}`
      }), jsxs(CardContent, {
        children: [jsx(CardItem, {
          title: "Overview",
          bold: true
        }), (item === null || item === void 0 ? void 0 : item.value) && jsx(ValueItem, {
          title: "Value Est.",
          value: item === null || item === void 0 ? void 0 : item.value
        }), jsx(ItemListDouble, {
          items: overviewItems,
          showIcon: false
        })]
      }), jsx(Separator, {}), jsxs(CardContent, {
        children: [jsx(CardItem, {
          title: "Tasks",
          Icon: Wrench,
          bold: true
        }), item.tasks.map((task, index) => jsxs("div", {
          className: "lumina-flex lumina-flex-col lumina-w-full lumina-gap-2",
          children: [jsxs("div", {
            children: [jsx(CardItem, {
              title: task.name,
              bold: true
            }), jsx(CardItem, {
              title: `${formatDate(task.startDate)} ${task.recurrence ? getRecurrenceText(task.recurrence) : 'Non-recurring'}`
            })]
          }), index !== item.tasks.length - 1 && jsx(Separator, {})]
        }, task.id)), ((_a = item.tasks) === null || _a === void 0 ? void 0 : _a.length) === 0 && jsx(InfoFooter, {
          title: 'No current tasks'
        }), jsx(CardItem, {
          title: "Suggested Tasks",
          Icon: Wrench,
          bold: true
        }), jsx(ItemListSimple, {
          items: item.suggestedTasks
        })]
      })]
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: "Error getting item",
        error: error.message
      });
    }
    return jsx(ErrorCard, {
      title: "Error getting item"
    });
  }
};

const SOPEditSchema = z.object({
  id: z.string(),
  title: z.string(),
  changes: z.string()
});
/**
 *
 * @param result - A json object containing the user's properties
 * @returns
 */
function EditSOP({
  result
}) {
  try {
    if (!result) {
      return jsx(LoadingCard, {
        title: "Editing SOP",
        Icon: Route
      });
    }
    const edit = SOPEditSchema.parse(JSON.parse(result));
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        Icon: Route,
        title: `${edit.title} Edited`,
        link: `/sops/${edit.id}`
      }), jsx(CardContent, {
        children: jsx(CardItem, {
          title: edit.changes,
          Icon: Info,
          bold: true
        })
      })]
    });
  } catch (error) {
    console.error(`Error editing SOP: ${JSON.stringify(error)}`);
    return jsx(ErrorCard, {
      title: "Error editing SOP",
      error: JSON.stringify(error)
    });
  }
}

const PropertyAssetValues = z.array(z.object({
  id: z.string().uuid(),
  name: z.string(),
  value: z.string().nullish(),
  units: z.string().nullish()
}));
const GetPropertyAssetValue = ({
  toolName,
  result
}) => {
  if (!result) {
    return jsx(LoadingCard, {
      Icon: Package,
      title: "Collecting Property Assets"
    });
  }
  try {
    const assets = PropertyAssetValues.parse(JSON.parse(result));
    return jsx(CardWrapper, {
      children: jsx(CardContent, {
        children: assets.map(asset => jsx(ValueItem, {
          title: asset.name,
          unit: asset.units || 'N/A',
          value: asset.value || 'Pending Estimate'
        }, asset.id))
      })
    });
  } catch (error) {
    if (error instanceof Error) {
      return jsx(ErrorCard, {
        title: "Error estimating property asset values",
        error: error.message
      });
    }
    return jsx(ErrorCard, {
      title: 'Failed to estimate property asset values'
    });
  }
};

const AddSpaceSchema = z.object({
  title: z.string(),
  propertyId: z.string(),
  spaceId: z.string(),
  area: z.string().nullish(),
  spaceType: z.string().nullish()
});
function AddSpace({
  result
}) {
  try {
    if (!result) {
      return jsx(LoadingCard, {
        title: "Creating Space",
        Icon: HousePlus
      });
    }
    const d = AddSpaceSchema.parse(JSON.parse(result));
    return jsxs(CardWrapper, {
      children: [jsx(CardHeader, {
        Icon: HousePlus,
        title: `${d.title} Added`,
        link: `/properties/${d.propertyId}/space/${d.spaceId}`
      }), jsxs(CardContent, {
        children: [jsx(CardItem, {
          title: "Click on the top right button to view more details",
          Icon: Info,
          bold: true
        }), (d === null || d === void 0 ? void 0 : d.area) && jsx(CardItem, {
          title: `${d.area} sq. ft.`,
          Icon: Ruler,
          filled: true
        }), (d === null || d === void 0 ? void 0 : d.spaceType) && jsx(CardItem, {
          title: d.spaceType,
          Icon: BedDouble,
          filled: true
        })]
      })]
    });
  } catch (error) {
    console.error(`Error creating space: ${JSON.stringify(error)}`);
    return jsx(ErrorCard, {
      title: "Error creating space",
      error: JSON.stringify(error)
    });
  }
}

const GetFAQ = ({
  toolName,
  result
}) => {
  if (!result) {
    return jsx(LoadingCard, {
      Icon: Sparkles,
      title: "Searching FAQs"
    });
  }
  const TGetFAQ = z.object({
    video: z.string().nullish(),
    answer: z.string(),
    faqCitations: z.array(z.object({
      title: z.string().nullish(),
      link: z.string().nullish()
    }))
  });
  try {
    const faq = TGetFAQ.parse(JSON.parse(result));
    return jsxs(CardWrapper, {
      fullHeight: true,
      children: [jsx(CardHeader, {
        title: "FAQs Searched",
        Icon: Sparkles,
        size: "sm"
      }), jsxs(CardContent, {
        fullHeight: true,
        children: [faq.video ? jsxs("video", {
          controls: true,
          className: "lumina-rounded-lg",
          children: [jsx("source", {
            src: faq.video,
            type: "video/mp4"
          }), jsx("track", {
            kind: "captions"
          })]
        }) : jsx(CardItem, {
          title: 'No relevant video found',
          Icon: MonitorPlay,
          filled: true
        }), faq.faqCitations.length > 0 && jsxs("div", {
          className: "lumina-flex lumina-flex-col lumina-gap-2",
          children: [jsx(CardItem, {
            title: "Sources",
            bold: true
          }), jsx("div", {
            className: "lumina-flex lumina-flex-row lumina-gap-2 lumina-flex-wrap",
            children: faq.faqCitations.map((citation, index) => jsx(CitationLink, {
              title: citation.title || '',
              link: citation.link || ''
            }, citation.link || index))
          })]
        })]
      })]
    });
  } catch (e) {
    return jsx(LoadingCard, {
      Icon: Sparkles,
      title: "Searching FAQs"
    });
  }
};

const GetSupport = ({
  result
}) => {
  return jsx(CardWrapper, {
    children: jsx(CardContent, {
      children: jsx(ButtonLink, {
        title: "Contact Support",
        link: "contact-us",
        Icon: CircleHelp
      })
    })
  });
};

const Loader = () => {
  const oscillate = {
    x: [0, 10, 0, -10, 0],
    transition: {
      x: {
        repeat: Infinity,
        repeatType: "loop",
        duration: 2,
        ease: "easeInOut"
      }
    }
  };
  return jsx("div", {
    className: "lumina-flex lumina-items-center lumina-justify-center",
    children: jsx(motion.div, {
      animate: oscillate,
      children: jsx(ChartNoAxesGantt, {
        size: 24,
        className: "lumina-text-foreground"
      })
    })
  });
};

const ChatMessages = /*#__PURE__*/React__default.memo(function ChatMessages({
  messages,
  isLoading,
  showAvatar = true,
  onNewConversation,
  error
}) {
  const {
    thread
  } = useChatStore();
  const scrollViewRef = useRef(null);
  const messagesEndRef = useRef(null);
  const [timedOut, setTimedout] = useState(false);
  const {
    isCreatingThread
  } = useThreadStore();
  const {
    copyToClipboard,
    isCopied
  } = useCopyToClipboard({
    timeout: 1000
  });
  const scrollToBottom = useCallback(() => {
    var _a;
    (_a = messagesEndRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
      behavior: "smooth"
    });
  }, []);
  useEffect(() => {
    if (messages.length > 0) {
      scrollToBottom();
    }
  }, [messages.length, scrollToBottom]);
  useEffect(() => {
    const tm = setTimeout(() => setTimedout(true), 1000);
    return () => clearTimeout(tm);
  }, []);
  useEffect(() => {
    setTimedout(false);
    const tm = setTimeout(() => setTimedout(true), 1000);
    return () => clearTimeout(tm);
  }, [thread]);
  if (!thread || !thread.messages) {
    return jsx("div", {
      className: "lumina-flex lumina-flex-col lumina-items-center lumina-justify-center lumina-h-full lumina-gap-4",
      children: timedOut ? jsxs(Fragment, {
        children: [jsx(MessageSquare, {
          size: 32,
          className: "lumina-text-foreground"
        }), jsx("p", {
          className: "lumina-text-lg lumina-font-bold lumina-text-center lumina-text-foreground",
          children: "Need assistance? Let's chat!"
        }), jsxs(Button, {
          variant: "secondary",
          className: "lumina-gap-2",
          onClick: onNewConversation,
          disabled: isCreatingThread,
          children: [isCreatingThread ? jsx(Loader$1, {}) : jsx(Plus, {
            size: 24,
            className: "lumina-min-w-4 lumina-min-h-4 lumina-text-foreground"
          }), jsx("p", {
            children: "New Conversation"
          })]
        })]
      }) : jsx("div", {
        className: "lumina-flex lumina-items-center lumina-justify-center lumina-animate-spin",
        children: jsx(Loader2, {
          size: 32,
          className: "lumina-text-foreground"
        })
      })
    });
  }
  return jsxs("div", {
    ref: scrollViewRef,
    className: "lumina-flex lumina-flex-col lumina-w-full lumina-gap-2 lumina-h-full lumina-overflow-x-hidden lumina-overflow-y-auto lumina-p-4",
    children: [messages === null || messages === void 0 ? void 0 : messages.map(message => jsx(BasicMessage, {
      message: message,
      showAvatar: showAvatar
    }, message.id)), jsx("div", {
      className: cn("lumina-h-6 lumina-transition-all lumina-duration-300 lumina-ease-in-out lumina-flex lumina-flex-row lumina-justify-start", isLoading ? "lumina-opacity-100" : "lumina-opacity-0 lumina-h-0"),
      children: jsx(Loader, {})
    }), (error === null || error === void 0 ? void 0 : error.message) && jsxs("div", {
      className: "lumina-p-3 lumina-flex lumina-justify-center lumina-items-center lumina-gap-3 lumina-bg-secondary lumina-rounded-2xl",
      children: [jsx("p", {
        className: "lumina-text-foreground",
        children: "Oops. We're having trouble."
      }), jsxs(Button, {
        variant: "ghost",
        size: "sm",
        onClick: () => {
          copyToClipboard(error.message);
        },
        children: [jsx(Copy, {
          size: 15,
          className: cn("lumina-text-foreground lumina-transition-all lumina-duration-300 lumina-shrink-0", isCopied ? "lumina-opacity-0 lumina-w-0" : "lumina-opacity-100 lumina-w-[1rem]")
        }), jsx(CircleCheck, {
          size: 15,
          className: cn("lumina-text-foreground lumina-transition-all lumina-duration-300 lumina-shrink-0", isCopied ? "lumina-opacity-100" : "lumina-opacity-0 lumina-w-0")
        })]
      })]
    }), jsx("div", {
      ref: messagesEndRef
    })]
  });
});

function Chat({
  rounded = true,
  showSendBtn = true,
  showAvatar = true,
  miniMode = false,
  requestNewThread,
  setRequestNewThread
}) {
  const INIT_SUGGESTIONS = ['View properties', 'View assets', 'Help'];
  const {
    thread,
    setThread
  } = useChatStore();
  const {
    user,
    signIn
  } = useUserStore();
  const {
    threads,
    setThreads,
    addThread,
    setIsCreatingNewThread
  } = useThreadStore();
  const {
    threadId
  } = useParams();
  const [suggestions, setSuggestions] = useState(INIT_SUGGESTIONS);
  const newThreadCreatedRef = useRef(false);
  const {
    authToken,
    tenantId
  } = useRouterStore();
  const location = useLocation();
  const [metadata, setMetadata] = useState([]);
  const [fatalError, setFatalError] = useState('');
  const loginAttempts = useRef(0);
  const MAX_LOGINS = 5;
  const getSuggestions = useCallback(message => __awaiter(this, void 0, void 0, function* () {
    if (!thread || !thread.id) return;
    setSuggestions([]);
    apiGetSuggestions(authToken, tenantId, metadata, thread.id, message.content).then(res => {
      try {
        const {
          suggestions
        } = res;
        setSuggestions(suggestions || []);
      } catch (error) {
        console.error('Failed to get suggestions:', error);
      }
    });
  }), [thread, authToken, tenantId]);
  useEffect(() => {
    // saves the last 5 page switches along with the timestamp
    setMetadata([...metadata, {
      timestamp: new Date().toLocaleString('en-US', {
        timeZoneName: 'short'
      }),
      location
    }].slice(-5));
  }, [location]);
  const {
    messages,
    setMessages,
    input,
    handleInputChange,
    handleSubmit,
    isLoading,
    error,
    stop,
    append
  } = useChat({
    api: `${getApiHost()}/chat`,
    body: {
      threadId: thread === null || thread === void 0 ? void 0 : thread.id,
      metadata: metadata
    },
    onFinish: getSuggestions,
    headers: {
      Authorization: `Bearer ${authToken}`,
      'X-Es-Tenantid': `${tenantId}`
    }
  });
  // handle external new thread button on minichat
  useEffect(() => {
    if (setRequestNewThread && requestNewThread) {
      createNewThread();
    }
  }, [requestNewThread, setRequestNewThread]);
  // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
  const createNewThread = useCallback(() => __awaiter(this, void 0, void 0, function* () {
    if (newThreadCreatedRef.current || !user || user.error || !authToken) return;
    try {
      setIsCreatingNewThread(true);
      const newThread = yield apiThreadCreate(user.id, new Intl.DateTimeFormat('en-US', {
        timeZoneName: 'short',
        hour12: false,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }).format(new Date()));
      if (!newThread) {
        console.error('[Chat.tsx] Failed to create new thread');
        setFatalError('Failed to create new thread');
        return;
      }
      newThreadCreatedRef.current = true;
      setThread(addThread(newThread));
      setMessages(newThread.messages || []);
      if (setRequestNewThread) {
        setRequestNewThread(false);
        setSuggestions(INIT_SUGGESTIONS);
      }
      if (!miniMode) {
        navigate(`/chat/${newThread.id}`);
      }
    } finally {
      setIsCreatingNewThread(false);
      newThreadCreatedRef.current = false;
    }
  }), [user, setThread, addThread, setMessages, miniMode, authToken]);
  const loadExistingThread = useCallback(id => __awaiter(this, void 0, void 0, function* () {
    const fetchedThread = yield apiGetThread(id);
    setThread(fetchedThread);
    setMessages(fetchedThread.messages);
  }), [setThread, setMessages]);
  useEffect(() => {
    const initializeChat = () => __awaiter(this, void 0, void 0, function* () {
      if (!user) {
        console.error('[Chat.tsx] No user found, login required');
        return;
      }
      if (threadId === 'new' || miniMode) {
        yield createNewThread();
      } else if (threadId && threadId !== 'undefined') {
        yield loadExistingThread(threadId);
      }
    });
    initializeChat();
  }, [threadId, user, createNewThread, loadExistingThread]);
  useEffect(() => {
    const login = () => __awaiter(this, void 0, void 0, function* () {
      if (miniMode && (!user || (user === null || user === void 0 ? void 0 : user.error)) && authToken && tenantId && loginAttempts.current < MAX_LOGINS) {
        loginAttempts.current++;
        if (loginAttempts.current >= MAX_LOGINS) {
          console.error('[Chat.tsx] Login attempts exceeded the maximum limit');
          setFatalError(`Failed to connect after ${loginAttempts.current} attempts`);
          return;
        }
        yield signIn({
          username: 'user',
          role: UserRole.user
        });
      }
    });
    login();
  }, [miniMode, signIn, user, tenantId, authToken]);
  const updateThreadName = useCallback(() => {
    if (thread && !thread.name && input.trim()) {
      const editedThreads = threads.map(t => t.id === (thread === null || thread === void 0 ? void 0 : thread.id) ? Object.assign(Object.assign({}, t), {
        name: input
      }) : t);
      setThreads(editedThreads);
      setThread(Object.assign(Object.assign({}, thread), {
        name: input
      }));
    }
  }, [thread, input, threads, setThreads, setThread]);
  if (!user) {
    return jsxs("div", {
      className: "lumina-flex lumina-flex-col lumina-w-full lumina-h-full lumina-items-center lumina-justify-center",
      children: [jsxs("div", {
        className: "lumina-flex lumina-flex-row lumina-gap-2",
        children: [jsx("p", {
          className: "lumina-text-lg lumina-font-bold lumina-text-center lumina-text-foreground",
          children: "Connecting"
        }), jsx(Loader$1, {})]
      }), jsx("p", {
        className: "lumina-text-foreground/70 lumina-text-sm lumina-font-medium",
        children: "Please wait"
      })]
    });
  }
  if (requestNewThread) {
    return jsxs("div", {
      className: "lumina-flex lumina-flex-col lumina-w-full lumina-h-full lumina-items-center lumina-justify-center",
      children: [jsxs("div", {
        className: "lumina-flex lumina-flex-row lumina-gap-2",
        children: [jsx("p", {
          className: "lumina-text-lg lumina-font-bold lumina-text-center lumina-text-foreground",
          children: "Creating new thread"
        }), jsx(Loader$1, {})]
      }), jsx("p", {
        className: "lumina-text-foreground/70 lumina-text-sm lumina-font-medium",
        children: "Please wait"
      })]
    });
  }
  if (fatalError) {
    return jsx("div", {
      className: "lumina-flex lumina-flex-col lumina-h-full lumina-overflow-hidden",
      children: jsx("div", {
        className: cn('lumina-flex lumina-flex-col lumina-h-full lumina-items-center lumina-justify-center', rounded ? 'lumina-rounded-2xl' : ''),
        children: jsxs("div", {
          className: "lumina-p-3 lumina-max-w-64 lumina-text-foreground lumina-flex lumina-flex-col lumina-items-center lumina-justify-center lumina-gap-2",
          children: [jsx(ShieldX, {
            className: "lumina-text-red-600 lumina-my-3",
            size: 32
          }), jsx("h3", {
            className: "lumina-text-red-600 lumina-text-lg lumina-font-semibold",
            children: "Error Loading Chat"
          }), jsx("p", {
            className: "lumina-text-foreground lumina-text-sm lumina-text-center",
            children: "This indicates the backend service is either down or under maintenance"
          }), jsx("p", {
            className: "lumina-p-2 rounded-xl lumina-text-xs lumina-text-red-600",
            children: fatalError
          })]
        })
      })
    });
  }
  return jsx("div", {
    className: "lumina-flex lumina-flex-col lumina-h-full lumina-overflow-hidden",
    children: jsxs("div", {
      className: cn('lumina-flex lumina-flex-col lumina-h-full', rounded ? 'lumina-rounded-2xl' : ''),
      children: [jsx("div", {
        className: "lumina-flex-1 lumina-h-full lumina-overflow-hidden",
        children: jsx(ChatMessages, {
          messages: messages,
          isLoading: isLoading,
          showAvatar: showAvatar,
          onNewConversation: createNewThread,
          error: error
        })
      }), (messages === null || messages === void 0 ? void 0 : messages.length) > 0 && jsx(ChatField, {
        input: input,
        handleInputChange: handleInputChange,
        handleSubmit: e => {
          setSuggestions([]);
          getAuth().then(() => {
            handleSubmit(e);
            updateThreadName();
          });
        },
        metadata: metadata,
        setMetadata: setMetadata,
        suggestions: suggestions,
        isLoading: isLoading || !thread,
        showSendBtn: showSendBtn,
        stop: stop,
        append: append
      })]
    })
  });
}

function ChatFull() {
  return jsx("div", {
    className: "lumina-flex lumina-flex-col lumina-rounded-xl lumina-w-full lumina-h-full lumina-overflow-hidden lumina-bg-secondary",
    children: jsx(Chat, {})
  });
}

function MiniChat() {
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(true);
  const [requestNewThread, setRequestNewThread] = useState(false);
  const onToggle = () => {
    setIsOpen(prev => !prev);
  };
  const onToggleMinimize = () => {
    setIsMinimized(prev => !prev);
  };
  const onNewThreadButton = () => {
    if (requestNewThread) return;
    setRequestNewThread(true);
  };
  return jsxs(Fragment, {
    children: [jsx("div", {
      onClick: onToggle,
      className: cn('lumina-fixed lumina-bottom-0 lumina-right-0 lumina-overflow-hidden lumina-flex lumina-flex-col lumina-items-center lumina-justify-center lumina-rounded-full lumina-transition-all lumina-m-7 lumina-pointer-events-none lumina-z-[10000]'),
      children: jsx("div", {
        className: "lumina-size-24 lumina-shadow-xl lumina-pointer-events-auto lumina-transition-all hover:lumina-scale-105",
        children: jsx(BrandLily, {})
      })
    }), jsx("div", {
      className: cn('lumina-z-[10000] lumina-fixed lumina-bottom-0 lumina-right-0 lumina-rounded-lg lumina-flex lumina-flex-col lumina-px-4 lumina-transition-all lumina-duration-300 lumina-ease-in-out lumina-h-full lumina-pt-20 lumina-pointer-events-none', isOpen ? 'lumina-scale-100 lumina-opacity-100' : 'lumina-scale-0 lumina-opacity-0 lumina-pointer-events-none lumina-translate-x-1/2 lumina-translate-y-1/2', isMinimized ? 'lumina-w-[34rem] lumina-pb-16' : 'lumina-w-full lumina-pb-2 lumina-translate-x-1/2', isOpen && !isMinimized ? 'lumina-right-1/2 lumina-pr-6 lumina-pl-[19rem]' : 'lumina-right-0'),
      children: jsxs("div", {
        className: "lumina-flex lumina-flex-col lumina-h-full lumina-rounded-2xl lumina-overflow-hidden lumina-bg-background lumina-shadow-lg lumina-pointer-events-auto",
        children: [jsxs("div", {
          className: "lumina-flex lumina-flex-row lumina-items-center lumina-justify-between lumina-px-3 lumina-bg-accent lumina-rounded-t-lg",
          children: [jsxs("div", {
            className: "lumina-flex lumina-flex-row lumina-items-center lumina-gap-1",
            children: [jsx("div", {
              className: "lumina-size-16 -lumina-m-2",
              children: jsx(BrandLily, {})
            }), jsx("p", {
              className: "lumina-text-accent-foreground lumina-text-lg",
              children: "Lily"
            }), jsxs("div", {
              onClick: onNewThreadButton,
              className: "lumina-flex lumina-items-center lumina-justify-center lumina-rounded-3xl hover:lumina-bg-accent-foreground/20 lumina-size-10",
              children: [jsx(Plus, {
                className: "lumina-text-accent-foreground lumina-transition-all lumina-p-2",
                size: 35
              }), ' ']
            })]
          }), jsxs("div", {
            className: "lumina-flex lumina-flex-row lumina-items-center lumina-gap-1 lumina-justify-center",
            children: [jsx("div", {
              onClick: onToggleMinimize,
              className: "lumina-flex lumina-items-center lumina-justify-center lumina-rounded-3xl hover:lumina-bg-accent-foreground/20 lumina-size-10",
              children: isMinimized ? jsx(Maximize2, {
                className: "lumina-text-accent-foreground lumina-transition-all lumina-p-2",
                size: 35
              }) : jsx(Minimize2, {
                className: "lumina-text-accent-foreground lumina-transition-all lumina-p-2",
                size: 35
              })
            }), jsx("div", {
              onClick: onToggle,
              className: "lumina-flex lumina-items-center lumina-justify-center lumina-rounded-3xl hover:lumina-bg-accent-foreground/20 lumina-size-10",
              children: jsx(X, {
                className: "lumina-text-accent-foreground lumina-transition-all lumina-p-2",
                size: 35
              })
            })]
          })]
        }), jsx(Chat, {
          rounded: false,
          showAvatar: false,
          showSendBtn: false,
          miniMode: true,
          requestNewThread: requestNewThread,
          setRequestNewThread: setRequestNewThread
        })]
      })
    })]
  });
}

var isArray$1 = isArray$4;
var lengthOfArrayLike$1 = lengthOfArrayLike$5;
var doesNotExceedSafeInteger = doesNotExceedSafeInteger$2;
var bind = functionBindContext;

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray$1 = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? bind(mapper, thisArg) : false;
  var element, elementLen;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray$1(element)) {
        elementLen = lengthOfArrayLike$1(element);
        targetIndex = flattenIntoArray$1(target, original, element, elementLen, targetIndex, depth - 1) - 1;
      } else {
        doesNotExceedSafeInteger(targetIndex + 1);
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray$1;

var isArray = isArray$4;
var isConstructor = isConstructor$2;
var isObject = isObject$e;
var wellKnownSymbol = wellKnownSymbol$l;

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesConstructor$1 = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};

var arraySpeciesConstructor = arraySpeciesConstructor$1;

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$1 = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};

var $$2 = _export;
var flattenIntoArray = flattenIntoArray_1;
var aCallable$2 = aCallable$d;
var toObject = toObject$6;
var lengthOfArrayLike = lengthOfArrayLike$5;
var arraySpeciesCreate = arraySpeciesCreate$1;

// `Array.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-array.prototype.flatmap
$$2({ target: 'Array', proto: true }, {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A;
    aCallable$2(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    return A;
  }
});

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module
var addToUnscopables = addToUnscopables$3;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flatMap');

var $$1 = _export;
var call$2 = functionCall;
var aCallable$1 = aCallable$d;
var anObject$2 = anObject$j;
var getIteratorDirect$2 = getIteratorDirect$5;
var createIteratorProxy$1 = iteratorCreateProxy;
var callWithSafeIterationClosing = callWithSafeIterationClosing$2;
var IS_PURE$1 = isPure;

var IteratorProxy$1 = createIteratorProxy$1(function () {
  var iterator = this.iterator;
  var predicate = this.predicate;
  var next = this.next;
  var result, done, value;
  while (true) {
    result = anObject$2(call$2(next, iterator));
    done = this.done = !!result.done;
    if (done) return;
    value = result.value;
    if (callWithSafeIterationClosing(iterator, predicate, [value, this.counter++], true)) return value;
  }
});

// `Iterator.prototype.filter` method
// https://tc39.es/ecma262/#sec-iterator.prototype.filter
$$1({ target: 'Iterator', proto: true, real: true, forced: IS_PURE$1 }, {
  filter: function filter(predicate) {
    anObject$2(this);
    aCallable$1(predicate);
    return new IteratorProxy$1(getIteratorDirect$2(this), {
      predicate: predicate
    });
  }
});

var call$1 = functionCall;
var anObject$1 = anObject$j;
var getIteratorDirect$1 = getIteratorDirect$5;
var getIteratorMethod = getIteratorMethod$3;

var getIteratorFlattenable$1 = function (obj, stringHandling) {
  if (!stringHandling || typeof obj !== 'string') anObject$1(obj);
  var method = getIteratorMethod(obj);
  return getIteratorDirect$1(anObject$1(method !== undefined ? call$1(method, obj) : obj));
};

var $ = _export;
var call = functionCall;
var aCallable = aCallable$d;
var anObject = anObject$j;
var getIteratorDirect = getIteratorDirect$5;
var getIteratorFlattenable = getIteratorFlattenable$1;
var createIteratorProxy = iteratorCreateProxy;
var iteratorClose = iteratorClose$4;
var IS_PURE = isPure;

var IteratorProxy = createIteratorProxy(function () {
  var iterator = this.iterator;
  var mapper = this.mapper;
  var result, inner;

  while (true) {
    if (inner = this.inner) try {
      result = anObject(call(inner.next, inner.iterator));
      if (!result.done) return result.value;
      this.inner = null;
    } catch (error) { iteratorClose(iterator, 'throw', error); }

    result = anObject(call(this.next, iterator));

    if (this.done = !!result.done) return;

    try {
      this.inner = getIteratorFlattenable(mapper(result.value, this.counter++), false);
    } catch (error) { iteratorClose(iterator, 'throw', error); }
  }
});

// `Iterator.prototype.flatMap` method
// https://tc39.es/ecma262/#sec-iterator.prototype.flatmap
$({ target: 'Iterator', proto: true, real: true, forced: IS_PURE }, {
  flatMap: function flatMap(mapper) {
    anObject(this);
    aCallable(mapper);
    return new IteratorProxy(getIteratorDirect(this), {
      mapper: mapper,
      inner: null
    });
  }
});

const areEqual = (prevProps, nextProps) => {
  return prevProps.thread.id === nextProps.thread.id && prevProps.thread.name === nextProps.thread.name;
};
const ThreadListItemComponent = ({
  thread,
  animIndex
}) => {
  const {
    threadId
  } = useParams();
  const {
    deleteThread
  } = useThreadStore();
  const {
    setThread
  } = useChatStore();
  const displayName = thread.name || '';
  const canAnim = useRef(true);
  const onDeleteItem = useCallback(e => {
    e.stopPropagation();
    e.preventDefault();
    if (threadId === thread.id) {
      setThread(undefined);
    }
    deleteThread(thread.id);
  }, [threadId, thread.id, setThread, deleteThread]);
  const handleThreadClick = useCallback(() => {
    setThread(thread);
    navigate(`/chat/${thread.id}`);
  }, [thread, setThread]);
  useEffect(() => {
    setTimeout(() => {
      canAnim.current = false;
    }, 500);
  }, []);
  return jsx(Button, {
    variant: "ghost",
    className: "lumina-group lumina-px-2 lumina-py-0 lumina-w-full",
    onClick: handleThreadClick,
    children: jsxs("div", {
      className: "lumina-flex lumina-flex-row lumina-items-center lumina-w-full",
      children: [jsxs("div", {
        className: "lumina-flex lumina-items-center lumina-flex-row lumina-flex-grow lumina-min-w-0",
        children: [jsx(ChevronRight, {
          className: "lumina-text-foreground lumina-transition-all lumina-w-0 lumina-min-w-0 group-hover:lumina-min-w-5 group-hover:lumina-mr-5"
        }), jsx(MessageSquareText, {
          className: "lumina-text-foreground lumina-min-w-5 lumina-size-5 lumina-mr-2 lumina-transition-all group-hover:lumina-w-0 group-hover:lumina-min-w-0 group-hover:lumina-m-0"
        }), jsx("p", {
          className: "lumina-text-foreground lumina-text-sm lumina-truncate lumina-transition-all group-hover:lumina--ml-3",
          children: displayName || 'New Chat'
        })]
      }), jsx("div", {
        onClick: onDeleteItem,
        children: jsx(X, {
          className: "lumina-text-foreground group-hover:lumina-opacity-100 lumina-opacity-0 lumina-transition-all lumina-border-2 lumina-border-border lumina-bg-muted lumina-p-1 lumina-m-0 lumina-rounded-lg hover:lumina-bg-border",
          size: 25
        })
      })]
    })
  });
};
const ThreadListItem = /*#__PURE__*/memo(ThreadListItemComponent, areEqual);

function ThreadList({
  threads,
  isFetching,
  hasNextPage
}) {
  const {
    user
  } = useUserStore();
  const renderItem = ({
    item,
    index
  }) => jsx(ThreadListItem, {
    thread: item,
    animIndex: index
  }, item.id);
  const renderFooter = () => {
    if (hasNextPage) {
      return jsx("div", {
        className: cn('lumina-flex lumina-items-center lumina-justify-center lumina-p-4 lumina-backdrop-blur-sm lumina-transition-all lumina-scale-0 lumina-opacity-0', isFetching && 'lumina-opacity-100 lumina-scale-100'),
        children: jsx(Loader$1, {})
      });
    }
    return jsxs("div", {
      className: "lumina-flex lumina-flex-row lumina-gap-2 lumina-px-2 lumina-py-4 lumina-rounded-lg lumina-items-center lumina-justify-center",
      children: [jsx(Layers2, {
        size: 20,
        className: "lumina-text-foreground/70 lumina-text-sm"
      }), jsx("p", {
        className: "lumina-text-center lumina-text-foreground/70",
        children: "End of threads"
      })]
    });
  };
  return jsxs("div", {
    className: "lumina-flex-1",
    style: {
      overflowY: 'auto'
    },
    children: [user && threads.map((item, index) => jsx("div", {
      children: renderItem({
        item,
        index
      })
    }, item.id)), renderFooter === null || renderFooter === void 0 ? void 0 : renderFooter()]
  });
}

function Sidebar({
  className
}) {
  const {
    isSidebarOpen
  } = useSidebarStore();
  const {
    user
  } = useUserStore();
  const {
    threads,
    remoteThreads,
    setRemoteThreads,
    deletedThreads
  } = useThreadStore();
  const scrollRef = useRef(null);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching
  } = useInfiniteQuery({
    queryKey: ['threads', user === null || user === void 0 ? void 0 : user.id],
    queryFn: ({
      pageParam
    }) => apiGetThreads({
      pageParam,
      userId: user === null || user === void 0 ? void 0 : user.id
    }),
    getNextPageParam: lastPage => lastPage.nextCursor ? lastPage.nextCursor + threads.length : undefined,
    initialPageParam: 0
  });
  useEffect(() => {
    setRemoteThreads((data === null || data === void 0 ? void 0 : data.pages.flatMap(page => page.threads)) || []);
  }, [data, setRemoteThreads]);
  const mergedThreads = useMemo(() => {
    const threadMap = new Map();
    for (const thread of threads || []) {
      if (!thread || !thread.id) continue;
      threadMap.set(thread.id, thread);
    }
    for (const thread of remoteThreads) {
      if (!thread || !thread.id) continue;
      threadMap.set(thread.id, thread);
    }
    return Array.from(threadMap.values()).filter(thread => !deletedThreads.includes(thread.id));
  }, [threads, remoteThreads, deletedThreads]);
  const handleScroll = e => {
    const {
      scrollTop,
      scrollHeight,
      clientHeight
    } = e.currentTarget;
    if (scrollTop + clientHeight >= scrollHeight) {
      fetchNextPage();
      setIsScrolledToBottom(true);
    } else {
      setIsScrolledToBottom(false);
    }
  };
  useEffect(() => {
    if (isScrolledToBottom && hasNextPage && !isFetching) {
      fetchNextPage();
    }
  }, [isScrolledToBottom, hasNextPage, isFetching, fetchNextPage]);
  useEffect(() => {
    const checkAndFetchMore = () => {
      if (scrollRef.current) {
        const scrollView = scrollRef.current;
        if (scrollView.contentSize && scrollView.layoutMeasurement) {
          const {
            height: contentHeight
          } = scrollView.contentSize;
          const {
            height: layoutHeight
          } = scrollView.layoutMeasurement;
          if (contentHeight <= layoutHeight && hasNextPage && !isFetching) {
            fetchNextPage();
          }
        }
      }
    };
    checkAndFetchMore();
  }, [data, hasNextPage, isFetching, fetchNextPage]);
  return jsxs("div", {
    ref: scrollRef,
    onScroll: handleScroll,
    "data-state": isSidebarOpen ? 'open' : 'closed',
    className: cn(className, 'lumina-transition-all lumina-py-1 lumina-overflow-y-auto lumina-bg-background lumina-h-full', 'lumina-fixed sm:lumina-static lumina-top-0 lumina-left-0 lumina-z-50', isSidebarOpen ? 'lumina-w-full sm:lumina-w-96 lumina-px-2' : 'lumina-w-0 sm:lumina-w-0 lumina-px-0 lumina-overflow-hidden'),
    children: [jsxs("div", {
      className: "lumina-flex-shrink-0 lumina-flex lumina-flex-row lumina-justify-between lumina-items-center lumina-pt-1 lumina-pb-2",
      children: [jsxs("div", {
        className: "lumina-flex lumina-flex-row lumina-items-center lumina-gap-2 lumina-ml-2",
        children: [jsx(GalleryHorizontalEnd, {
          size: 20,
          className: "lumina-text-foreground"
        }), jsx("p", {
          className: "lumina-text-nowrap lumina-text-lg lumina-font-semibold lumina-text-foreground",
          children: "Threads"
        })]
      }), jsx(SidebarToggle, {})]
    }), jsx("div", {
      children: jsx(ThreadList, {
        threads: mergedThreads,
        isFetching: isFetching,
        hasNextPage: hasNextPage
      })
    })]
  });
}

function UserBasedChat({
  authToken = ''
}) {
  const {
    user
  } = useUserStore();
  if (!user) return jsx("div", {
    className: "lumina-flex lumina-h-screen lumina-justify-center lumina-items-center lumina-bg-background",
    children: jsxs("div", {
      className: "lumina-flex lumina-flex-col lumina-bg-secondary lumina-p-6 lumina-items-center lumina-rounded-lg",
      children: [jsx(ShieldAlert, {
        size: 32,
        className: "lumina-text-foreground lumina-mb-4"
      }), jsx("p", {
        children: "We're having trouble logging you in"
      })]
    })
  });
  if (user.role === UserRole.admin) {
    return jsxs("div", {
      className: "lumina-bg-background lumina-flex lumina-flex-row lumina-h-screen",
      children: [jsx(Sidebar, {}), jsxs("div", {
        className: "lumina-w-full lumina-flex lumina-flex-col",
        children: [jsx(ActionMenu, {}), jsx(ChatFull, {})]
      })]
    });
  }
  return jsx("div", {
    className: "lumina-bg-background lumina-flex lumina-flex-row lumina-w-screen lumina-h-screen lumina-overflow-hidden",
    children: jsxs("div", {
      className: "lumina-w-full lumina-flex lumina-flex-col lumina-h-full",
      children: [jsx("img", {
        src: "/images/lilyBg.jpg",
        alt: "chat",
        className: "lumina-object-contain lumina-h-full lumina-w-full"
      }), jsx(MiniChat, {})]
    })
  });
}

function LoginForm() {
  const {
    signIn
  } = useUserStore();
  const {
    setSidebar
  } = useSidebarStore();
  const onGuestLogin = () => __awaiter(this, void 0, void 0, function* () {
    yield signIn({
      username: 'test user',
      role: UserRole.user
    });
    navigate('/chat/new');
  });
  const onAdminLogin = () => __awaiter(this, void 0, void 0, function* () {
    yield signIn({
      username: 'admin user',
      role: UserRole.admin
    });
    setSidebar(true);
    navigate('/chat/view');
  });
  useEffect(() => {
    setSidebar(false);
  }, []);
  return jsxs(Card, {
    className: "lumina-mx-auto lumina-max-w-sm",
    children: [jsxs(CardHeader$1, {
      children: [jsx(CardTitle, {
        className: "lumina-text-2xl",
        children: "Login"
      }), jsx(CardDescription, {
        children: "Enter your email below to login to your account"
      })]
    }), jsxs(CardContent$1, {
      children: [jsxs("div", {
        className: "lumina-grid lumina-gap-4",
        children: [jsxs("div", {
          className: "lumina-grid lumina-gap-2",
          children: [jsx(Label, {
            htmlFor: "email",
            children: "Email"
          }), jsx(Input, {
            id: "email",
            type: "email",
            placeholder: "name@example.com",
            required: true
          })]
        }), jsxs("div", {
          className: "lumina-grid lumina-gap-2",
          children: [jsxs("div", {
            className: "lumina-flex lumina-items-center",
            children: [jsx(Label, {
              htmlFor: "password",
              children: "Password"
            }), jsx("a", {
              href: "#",
              onClick: () => navigate(''),
              className: "lumina-ml-auto lumina-inline-block lumina-text-sm lumina-underline",
              children: "Forgot your password?"
            })]
          }), jsx(Input, {
            id: "password",
            type: "password",
            required: true
          })]
        }), jsx(Button, {
          type: "submit",
          className: "lumina-w-full",
          onClick: onGuestLogin,
          children: "Sign in as user"
        }), jsx(Button, {
          variant: "outline",
          className: "lumina-w-full",
          onClick: onAdminLogin,
          children: "Sign in as admin"
        })]
      }), jsxs("div", {
        className: "lumina-mt-4 lumina-text-center lumina-text-sm",
        children: ["Don't have an account?", ' ', jsx("a", {
          href: "#",
          onClick: () => navigate(''),
          className: "lumina-ml-auto lumina-inline-block lumina-text-sm lumina-underline",
          children: "Sign up"
        })]
      })]
    })]
  });
}

function Login() {
  return jsx("div", {
    className: "lumina-flex lumina-items-center lumina-justify-center lumina-h-screen lumina-w-screen lumina-bg-background",
    children: jsx(LoginForm, {})
  });
}

const queryClient = new QueryClient();
function Providers(_a) {
  var {
      children
    } = _a,
    props = __rest(_a, ["children"]);
  return jsx(QueryClientProvider, {
    client: queryClient,
    children: jsx(ThemeProvider, Object.assign({}, props, {
      children: jsx(TooltipProvider, {
        children: children
      })
    }))
  });
}

const NavigationProvider = ({
  setNavigate,
  setUseParams,
  setUseLocation,
  authToken,
  tenantId,
  children,
  LILY_API_HOST,
  onBeforeChat
}) => {
  if (LILY_API_HOST) {
    setApiHost(LILY_API_HOST);
  }
  const storeSetNavigate = useRouterStore(state => state.setNavigate);
  const storeSetUseParams = useRouterStore(state => state.setUseParams);
  const storeSetAuthToken = useRouterStore(state => state.setAuthToken);
  const storeSetTenantId = useRouterStore(state => state.setTenantId);
  const storeSetUseLocation = useRouterStore(state => state.setUseLocation);
  const storeSetOnBeforeChat = useRouterStore(state => state.setOnBeforeChat);
  useEffect(() => {
    storeSetNavigate(setNavigate);
    storeSetUseParams(setUseParams);
    storeSetUseLocation(setUseLocation);
    storeSetAuthToken(authToken);
    storeSetTenantId(tenantId);
    onBeforeChat ? storeSetOnBeforeChat(onBeforeChat) : console.error("onBeforeChat not set");
  }, [setNavigate, setUseParams, storeSetNavigate, storeSetUseParams, storeSetUseLocation, authToken, storeSetAuthToken, tenantId, storeSetTenantId, setUseLocation, onBeforeChat, storeSetOnBeforeChat]);
  return children;
};

function Settings() {
  const navItems = ['General', 'Account', 'Security'];
  const [prompt, setPrompt] = useState('');
  const onSavePrompt = () => {
    console.log(prompt);
  };
  return jsxs("article", {
    className: "lumina-h-screen lumina-flex lumina-flex-row lumina-w-full lumina-bg-background lumina-overflow-hidden",
    children: [jsxs("section", {
      className: "lumina-px-2 lumina-flex lumina-flex-col lumina-w-[200px] lumina-py-4",
      children: [jsx("h1", {
        className: "lumina-w-64 lumina-px-4 lumina-font-medium",
        children: "Settings"
      }), navItems.map((item, index) => jsx(Button, {
        variant: "ghost",
        className: "lumina-p-2",
        children: item
      }, index))]
    }), jsx("div", {
      className: 'lumina-p-4 lumina-flex lumina-w-full',
      children: jsxs("section", {
        className: 'lumina-bg-secondary lumina-w-full lumina-p-4 lumina-rounded-lg',
        children: [jsx(Label, {
          className: 'lumina-font-medium lumina-py-8',
          children: "Custom Prompt"
        }), jsx(Textarea, {
          className: 'lumina-w-full lumina-h-32',
          value: prompt,
          onChange: e => setPrompt(e.target.value)
        }), jsx(Button, {
          className: 'lumina-mt-2',
          onClick: () => onSavePrompt(),
          children: "Save"
        })]
      })
    })]
  });
}

export { ActionMenu, AddAsset, AddProperty, AddSOP, AddSpace, AddTask, AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, AlertDialogPortal, AlertDialogTitle, AlertDialogTrigger, AnalyzeBidById, AnimCard, Badge, BasicMessage, Button, Card, CardContent$1 as CardContent, CardDescription, CardFooter, CardHeader$1 as CardHeader, CardTitle, ChatFull, Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger, DisplayAssets, DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuGroup, DropdownMenuItem, DropdownMenuLabel, DropdownMenuPortal, DropdownMenuRadioGroup, DropdownMenuRadioItem, DropdownMenuSeparator, DropdownMenuShortcut, DropdownMenuSub, DropdownMenuSubContent, DropdownMenuSubTrigger, DropdownMenuTrigger, EditAsset, EditItemSchema, EditProperty, EditSOP, EditTask, EstimateAsset, EstimateProperty, FetchBidById, FindSOPs, GetFAQ, GetItem, GetProjects, GetProperties, GetPropertyAssetValue, GetServiceRequests, GetSupport, GetVendorContact, IconArrowDown, IconArrowElbow, IconArrowRight, IconCheck, IconChevronUpDown, IconClose, IconCopy, IconDownload, IconEdit, IconExternalLink, IconGitHub, IconMessage, IconMoon, IconNextChat, IconOpenAI, IconPlus, IconRefresh, IconSeparator, IconShare, IconSidebar, IconSpinner, IconStop, IconSun, IconTrash, IconUser, IconUsers, IconVercel, Input, Label, Login, LoginForm, MiniChat, NavigationProvider, NewThreadButton, PatchSchema, Providers, RefreshAssets, RefreshTasks, Research, ReviewAsset, ReviewProperty, Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectScrollDownButton, SelectScrollUpButton, SelectSeparator, SelectTrigger, SelectValue, Separator, ServiceRequest, Settings, Sheet, SheetClose, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetOverlay, SheetPortal, SheetTitle, SheetTrigger, Sidebar, Skeleton, Switch, TEditItem, TaskSummary, Textarea, ThemeToggle, ThreadList, ThreadListItem, Toaster, Tooltip, TooltipContent, TooltipProvider, TooltipTrigger, UserBasedChat, UserMenu, WeatherMessage, badgeVariants, buttonVariants };
